import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Token: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AiCreditEntitlement = {
  __typename?: 'AICreditEntitlement';
  monthlyLimit?: Maybe<Scalars['Int']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
  resetAt: Scalars['DateTime']['output'];
  /**
   * Number of purchased top-up credits active in the current billing period
   * (not included in monthlyLimit). Resets when the period rolls over.
   */
  topupCredits: Scalars['Int']['output'];
  unlimited: Scalars['Boolean']['output'];
  used: Scalars['Int']['output'];
};

export type AiExtractedFeatures = {
  __typename?: 'AIExtractedFeatures';
  categories?: Maybe<Scalars['JSON']['output']>;
  color?: Maybe<Array<Scalars['String']['output']>>;
  depth?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Array<Scalars['String']['output']>>;
  pattern?: Maybe<Array<Scalars['String']['output']>>;
  room?: Maybe<Array<Scalars['String']['output']>>;
  shape?: Maybe<Array<Scalars['String']['output']>>;
  style?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export enum AiUsageAction {
  AddObjectToImage = 'ADD_OBJECT_TO_IMAGE',
  AiSearch = 'AI_SEARCH',
  AngleRender = 'ANGLE_RENDER',
  ApplySurface = 'APPLY_SURFACE',
  CombineImages = 'COMBINE_IMAGES',
  DeleteObject = 'DELETE_OBJECT',
  EditImage = 'EDIT_IMAGE',
  MagicGrab = 'MAGIC_GRAB',
  Model_3DGeneration = 'MODEL_3D_GENERATION',
  MoodboardRender = 'MOODBOARD_RENDER',
  Upscale = 'UPSCALE'
}

export type AiUsageCounter = {
  __typename?: 'AIUsageCounter';
  createdAt: Scalars['DateTime']['output'];
  creditsUsed: Scalars['Int']['output'];
  enterprise?: Maybe<Enterprise>;
  granularity: AiUsageGranularity;
  id: Scalars['ID']['output'];
  ownerId: Scalars['String']['output'];
  ownerType: AiUsageCounterOwnerType;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usageCount: Scalars['Int']['output'];
  user?: Maybe<User>;
};

export enum AiUsageCounterOwnerType {
  Enterprise = 'ENTERPRISE',
  User = 'USER'
}

export type AiUsageEvent = {
  __typename?: 'AIUsageEvent';
  action: AiUsageAction;
  createdAt: Scalars['DateTime']['output'];
  creditsConsumed: Scalars['Int']['output'];
  enterprise?: Maybe<Enterprise>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  outputTokens?: Maybe<Scalars['Int']['output']>;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export enum AiUsageGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type AiUsageMemberSummary = {
  __typename?: 'AIUsageMemberSummary';
  creditsUsed: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  membership?: Maybe<EnterpriseMembership>;
  normalizedEmail: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
  user?: Maybe<User>;
};

export type ActivationAndVerificationStatusInput = {
  addTrialActivatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  addTrialEndViewShownAt?: InputMaybe<Scalars['Boolean']['input']>;
  updateVerificationLinkEmailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updateVerificationLinkShownAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityStats = {
  __typename?: 'ActivityStats';
  date: Scalars['String']['output'];
  sessionCount: Scalars['Int']['output'];
};

export type AddBasketItemInput = {
  clientPrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pricesIncludeVAT?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  retailPrice?: InputMaybe<Scalars['Float']['input']>;
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export enum AddObjectOperation {
  Add = 'ADD',
  Replace = 'REPLACE'
}

export type AddSearchDebugCommentInput = {
  historyId: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type AdminAddExampleImageInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  coverPage?: InputMaybe<Scalars['Boolean']['input']>;
  image: Scalars['Upload']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCommunityUserModels3DInput = {
  limit?: Scalars['Int']['input'];
  listingStates?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminExampleImagesQueryInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminOversizedProduct3DFootprint = {
  __typename?: 'AdminOversizedProduct3DFootprint';
  assetId: Scalars['ID']['output'];
  footprintSource?: Maybe<Scalars['String']['output']>;
  footprintSvg?: Maybe<Scalars['String']['output']>;
  footprintSvgBytes: Scalars['Int']['output'];
  glbUrl?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  /**
   * Best image for tracing in the footprint editor: TOP no-bg, else TOP,
   * else source photo.
   */
  referenceImageUrl?: Maybe<Scalars['String']['output']>;
  /** Catalog / source product photo (fallback for editor underlay). */
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminProduct3DJobsInput = {
  limit?: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  skip?: Scalars['Int']['input'];
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminProduct3DJobsResponse = {
  __typename?: 'AdminProduct3DJobsResponse';
  data: Array<Product3DAsset>;
  summary: AdminProduct3DJobsSummary;
  total: Scalars['Int']['output'];
};

export type AdminProduct3DJobsSummary = {
  __typename?: 'AdminProduct3DJobsSummary';
  disabled: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  ready: Scalars['Int']['output'];
  review: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  uploading: Scalars['Int']['output'];
};

export type AdminUpdateExampleImageInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  coverPage?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type AiFeatureUsageByPeriod = {
  __typename?: 'AiFeatureUsageByPeriod';
  byMethod: Array<AiFeatureUsageRow>;
  label: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type AiFeatureUsageRow = {
  __typename?: 'AiFeatureUsageRow';
  count: Scalars['Int']['output'];
  sourceMethod: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
};

export type AiImageEditSessionResult = {
  __typename?: 'AiImageEditSessionResult';
  aiGeneratedImages: Array<UserItemAiImage>;
  imageUrl: Scalars['String']['output'];
  /** Set when the session row was persisted on a UserItem (upload or forked item). Null when updating a ProItem in place. */
  userItemId?: Maybe<Scalars['ID']['output']>;
};

export type AiRenderLog = {
  __typename?: 'AiRenderLog';
  angle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  effectiveSourceImageUrl?: Maybe<Scalars['String']['output']>;
  effectiveSourceImageUrl1?: Maybe<Scalars['String']['output']>;
  effectiveSourceImageUrl2?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  item1Id?: Maybe<Scalars['String']['output']>;
  item1Type?: Maybe<Scalars['String']['output']>;
  item2Id?: Maybe<Scalars['String']['output']>;
  item2Type?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  productId1?: Maybe<Scalars['String']['output']>;
  productId2?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  renderedImageUrl: Scalars['String']['output'];
  resizedImageUrl: Scalars['String']['output'];
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  sourceImageUrl1?: Maybe<Scalars['String']['output']>;
  sourceImageUrl2?: Maybe<Scalars['String']['output']>;
  sourceMethod: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type AiRenderLogsInput = {
  /** Search users by email, username, first name, or last name (case-insensitive) */
  email?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sourceMethod?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiRenderLogsResponse = {
  __typename?: 'AiRenderLogsResponse';
  data: Array<AiRenderLog>;
  total: Scalars['Int']['output'];
};

export enum AiVideoJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type AnalysisOptionsInput = {
  detectCategoryConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  detectLowConfidence?: InputMaybe<Scalars['Boolean']['input']>;
  detectWallpaperMiscategorization?: InputMaybe<Scalars['Boolean']['input']>;
  sampleSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiKeyInfo = {
  __typename?: 'ApiKeyInfo';
  createdAt: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  lastUsed?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  rateLimit: ApiKeyRateLimit;
  usage: ApiKeyUsage;
};

export type ApiKeyManagementResponse = {
  __typename?: 'ApiKeyManagementResponse';
  apiKey?: Maybe<ApiKeyInfo>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ApiKeyRateLimit = {
  __typename?: 'ApiKeyRateLimit';
  requestsPerDay: Scalars['Int']['output'];
  requestsPerHour: Scalars['Int']['output'];
  requestsPerMinute: Scalars['Int']['output'];
};

export type ApiKeyRateLimitInput = {
  requestsPerDay?: InputMaybe<Scalars['Int']['input']>;
  requestsPerHour?: InputMaybe<Scalars['Int']['input']>;
  requestsPerMinute?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiKeyStats = {
  __typename?: 'ApiKeyStats';
  currentDayUsage: Scalars['Int']['output'];
  currentHourUsage: Scalars['Int']['output'];
  currentMinuteUsage: Scalars['Int']['output'];
  rateLimitStatus: Scalars['JSONObject']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type ApiKeyStatsResponse = {
  __typename?: 'ApiKeyStatsResponse';
  error?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<ApiKeyStats>>;
  success: Scalars['Boolean']['output'];
};

export type ApiKeyUsage = {
  __typename?: 'ApiKeyUsage';
  day: Array<Scalars['Int']['output']>;
  hour: Array<Scalars['Int']['output']>;
  minute: Array<Scalars['Int']['output']>;
};

export enum ApplicationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum ApplySurfaceSourceType {
  Ncs = 'ncs',
  Product = 'product',
  Proitem = 'proitem',
  Useritem = 'useritem'
}

export type ApplySurfaceToImageResult = {
  __typename?: 'ApplySurfaceToImageResult';
  modifiedImageUrl: Scalars['String']['output'];
  sourceProducts?: Maybe<Array<Product>>;
  userItem?: Maybe<UserItem>;
};

export type AuditInfo = {
  __typename?: 'AuditInfo';
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  action: Scalars['String']['output'];
  changes: Scalars['JSONObject']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<Scalars['String']['output']>;
};

export type AuditMetadata = {
  __typename?: 'AuditMetadata';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum AuthScope {
  Admin = 'ADMIN',
  Client = 'CLIENT'
}

export type Basket = {
  __typename?: 'Basket';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<BasketItem>;
  subtotalAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type BasketItem = {
  __typename?: 'BasketItem';
  available: Scalars['Boolean']['output'];
  basketId: Scalars['ID']['output'];
  brandName: Scalars['String']['output'];
  clientPrice: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lineTotal: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  retailPrice: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Float']['output'];
  tradePrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatAmount: Scalars['Float']['output'];
  vatIncluded: Scalars['Boolean']['output'];
  vatRate: Scalars['Float']['output'];
};

export type BatchCategorizationError = {
  __typename?: 'BatchCategorizationError';
  error: Scalars['String']['output'];
  productId: Scalars['ID']['output'];
};

export type BatchCategorizationInput = {
  notifyOnComplete?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type BatchCategorizationJob = {
  __typename?: 'BatchCategorizationJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errors?: Maybe<Array<BatchCategorizationError>>;
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  processedCount: Scalars['Int']['output'];
  results: Array<BatchCategorizationResult>;
  status: BatchJobStatus;
  totalProducts: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BatchCategorizationResult = {
  __typename?: 'BatchCategorizationResult';
  categoriesCount?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  productId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export enum BatchJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type BoardProSettings = {
  __typename?: 'BoardProSettings';
  brands?: Maybe<Array<Maybe<ProBrand>>>;
  currency?: Maybe<Scalars['String']['output']>;
  customExpenses?: Maybe<Array<Maybe<CustomExpense>>>;
  descriptions?: Maybe<Array<Maybe<ProDesc>>>;
  groupLabels?: Maybe<Array<Maybe<ProGroupLabel>>>;
  hideBrands?: Maybe<Scalars['Boolean']['output']>;
  hideClientPrices?: Maybe<Scalars['Boolean']['output']>;
  hideDescriptions?: Maybe<Scalars['Boolean']['output']>;
  hideOriginalPrices?: Maybe<Scalars['Boolean']['output']>;
  hideStoreLinks?: Maybe<Scalars['Boolean']['output']>;
  hideSuppliers?: Maybe<Scalars['Boolean']['output']>;
  markups?: Maybe<Array<Maybe<ProMarkup>>>;
  order?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paintVisibilities?: Maybe<Array<Maybe<PaintVisibility>>>;
  prices?: Maybe<Array<Maybe<ProPrice>>>;
  quantities?: Maybe<Array<Maybe<ProQuantity>>>;
  suppliers?: Maybe<Array<Maybe<ProSupplier>>>;
  tradePrices?: Maybe<Array<Maybe<ProPrice>>>;
  visibilities?: Maybe<Array<Maybe<ProVisibility>>>;
};

export type BoardProSettingsInput = {
  brands?: InputMaybe<Array<InputMaybe<ProBrandInput>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customExpenses?: InputMaybe<Array<InputMaybe<CustomExpenseInput>>>;
  descriptions?: InputMaybe<Array<InputMaybe<ProDescInput>>>;
  groupLabels?: InputMaybe<Array<InputMaybe<ProGroupLabelInput>>>;
  hideBrands?: InputMaybe<Scalars['Boolean']['input']>;
  hideClientPrices?: InputMaybe<Scalars['Boolean']['input']>;
  hideDescriptions?: InputMaybe<Scalars['Boolean']['input']>;
  hideOriginalPrices?: InputMaybe<Scalars['Boolean']['input']>;
  hideStoreLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
  markups?: InputMaybe<Array<InputMaybe<ProMarkupInput>>>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paintVisibilities?: InputMaybe<Array<InputMaybe<PaintVisibilityInput>>>;
  prices?: InputMaybe<Array<InputMaybe<ProPriceInput>>>;
  quantities?: InputMaybe<Array<InputMaybe<ProQuantityInput>>>;
  suppliers?: InputMaybe<Array<InputMaybe<ProSupplierInput>>>;
  tradePrices?: InputMaybe<Array<InputMaybe<ProPriceInput>>>;
  visibilities?: InputMaybe<Array<InputMaybe<ProVisibilityInput>>>;
};

export type BoardSetting = {
  __typename?: 'BoardSetting';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  json?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BoardSettingEditInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type BoundingBoxInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Brand = {
  __typename?: 'Brand';
  description?: Maybe<Scalars['String']['output']>;
  hasQuotableSuppliers?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  maxQuoteDiscount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<BrandProduct>>;
};

export type BrandCacheRebuildResponse = {
  __typename?: 'BrandCacheRebuildResponse';
  brandCount?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BrandChannelChoiceInput = {
  channel: OrderChannel;
  groupKey: Scalars['ID']['input'];
};

export type BrandEditInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BrandInfo = {
  __typename?: 'BrandInfo';
  hasQuotableSuppliers?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  maxQuoteDiscount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type BrandInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
};

export type BrandInsights = {
  __typename?: 'BrandInsights';
  /** AI render logs in the date range where productId, productId1, or productId2 resolves to a catalog product whose brand matches one of the input brands. */
  aiFeatureUsageByPeriod: Array<AiFeatureUsageByPeriod>;
  brands: Array<Scalars['String']['output']>;
  from: Scalars['DateTime']['output'];
  granularity: UsageInsightsGranularity;
  moodboardProductSnapshot?: Maybe<Array<MoodboardProductSnapshotRow>>;
  /** Explains that moodboard product rows are a snapshot of current boards, not time-series drag events. */
  moodboardProductSnapshotNote: Scalars['String']['output'];
  /** Search history rows in the date range where the user applied a brand filter matching one of the input brands. */
  searchWithBrandFilterByPeriod: Array<UsageCountByPeriod>;
  to: Scalars['DateTime']['output'];
};

export type BrandInsightsInput = {
  /** One or more brand names (matched case-insensitively against product.brand). */
  brands: Array<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  granularity: UsageInsightsGranularity;
  /** When true, scans up to moodboardSnapshotLimit mood boards and ranks product IDs by how often they appear on boards (current state, not historical drags). Only products whose brand matches one of `brands` are included. */
  includeMoodboardProductSnapshot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Caps work for snapshot; default 5000. */
  moodboardSnapshotLimit?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};

export type BrandOrder = {
  __typename?: 'BrandOrder';
  actualDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  billingAddress: Address;
  brandEmail?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['ID']['output']>;
  brandLastRead?: Maybe<Scalars['DateTime']['output']>;
  brandName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  designerLastRead?: Maybe<Scalars['DateTime']['output']>;
  estimatedDelivery?: Maybe<Scalars['String']['output']>;
  externalLinkKey?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  notes?: Maybe<Scalars['JSON']['output']>;
  orderChannel?: Maybe<OrderChannel>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  parentOrder: ParentOrder;
  parentOrderId: Scalars['ID']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  shippingAddress: Address;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  sourceSupplierIds?: Maybe<Array<Scalars['ID']['output']>>;
  status: OrderStatus;
  subtotalAmount: Scalars['Float']['output'];
  supplier?: Maybe<Supplier>;
  totalAmount: Scalars['Float']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatAmount: Scalars['Float']['output'];
  vatIncluded: Scalars['Boolean']['output'];
  vatRate: Scalars['Float']['output'];
};

export type BrandOrdersResponse = {
  __typename?: 'BrandOrdersResponse';
  data: Array<BrandOrder>;
  total: Scalars['Int']['output'];
};

export type BrandProduct = {
  __typename?: 'BrandProduct';
  brand: Brand;
  categories?: Maybe<Array<Category>>;
  categoriesMeta?: Maybe<Array<CategoryMeta>>;
  colors?: Maybe<Array<Color>>;
  depth?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  isHidden: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type BrandProductEditInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  colors?: InputMaybe<Array<Scalars['ID']['input']>>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type BrandProductInput = {
  brandId: Scalars['ID']['input'];
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  colors?: InputMaybe<Array<Scalars['ID']['input']>>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type BrandProductsQueryInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  colors?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit: Scalars['Int']['input'];
  priceRange?: InputMaybe<PriceRange>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  sortBy?: InputMaybe<SortOption>;
};

export type BrandProductsResponse = {
  __typename?: 'BrandProductsResponse';
  data: Array<BrandProduct>;
  total: Scalars['Int']['output'];
};

export type BrandReplacement = {
  __typename?: 'BrandReplacement';
  correctName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  misspelling: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BrandWithOrders = {
  __typename?: 'BrandWithOrders';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type BusinessApplication = {
  __typename?: 'BusinessApplication';
  billingAddress: Address;
  companyName: Scalars['String']['output'];
  contactPerson: ContactPerson;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  shippingAddress?: Maybe<Address>;
  status: ApplicationStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  billingAddress?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPerson: ContactPerson;
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  shippingAddress?: Maybe<Address>;
  status?: Maybe<ApplicationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CategorizationAnalysisResult = {
  __typename?: 'CategorizationAnalysisResult';
  confidence?: Maybe<Scalars['String']['output']>;
  currentCategories: Array<Scalars['String']['output']>;
  issues: Array<CategorizationIssue>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type CategorizationError = {
  __typename?: 'CategorizationError';
  code: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CategorizationErrorLog = {
  __typename?: 'CategorizationErrorLog';
  error: Scalars['String']['output'];
  productId?: Maybe<Scalars['ID']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type CategorizationFilterInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  hasErrors?: InputMaybe<Scalars['Boolean']['input']>;
  lowConfidenceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  uncategorizedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategorizationIssue = {
  __typename?: 'CategorizationIssue';
  metadata?: Maybe<Scalars['JSON']['output']>;
  reason: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CategorizationProductError = {
  __typename?: 'CategorizationProductError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type CategorizationResult = {
  __typename?: 'CategorizationResult';
  confidence?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Array<CategorizationError>>;
  processingTimeMs?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<Product>;
  provider?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CategorizationStatistics = {
  __typename?: 'CategorizationStatistics';
  averageCategoriesPerProduct: Scalars['Float']['output'];
  categorizedProducts: Scalars['Int']['output'];
  recentErrors: Array<CategorizationErrorLog>;
  topCategories: Array<CategoryCount>;
  totalProducts: Scalars['Int']['output'];
  uncategorizedProducts: Scalars['Int']['output'];
};

export type CategorizeProductInput = {
  /**
   * Optional API key for external service calls (e.g. parser/importer).
   * When provided, validated against server CATEGORIZE_API_KEYS.
   * When omitted, existing CORS / session auth applies.
   */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional supplier ID to use for category scoping.
   * If omitted, the product's supplier will be used.
   */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type Category = {
  __typename?: 'Category';
  children?: Maybe<Array<Maybe<Category>>>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  outsideCategories?: Maybe<Scalars['JSONObject']['output']>;
  parent?: Maybe<Category>;
};

export type CategoryCount = {
  __typename?: 'CategoryCount';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CategoryInput = {
  id: Scalars['String']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  outsideCategories?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type CategoryMeta = {
  __typename?: 'CategoryMeta';
  children?: Maybe<Array<Maybe<CategoryMeta>>>;
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  outsideCategories?: Maybe<Scalars['JSONObject']['output']>;
  parent?: Maybe<CategoryMeta>;
};

export type CheckoutBasketInput = {
  billingAddress?: InputMaybe<AddressInput>;
  businessProfileId: Scalars['ID']['input'];
  channelChoices?: InputMaybe<Array<BrandChannelChoiceInput>>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressInput>;
};

export type ChunkingConfig = {
  __typename?: 'ChunkingConfig';
  enabled: Scalars['Boolean']['output'];
  overlap?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type ChunkingConfigInput = {
  enabled: Scalars['Boolean']['input'];
  overlap?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type Color = {
  __typename?: 'Color';
  hex: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CommonResult = {
  __typename?: 'CommonResult';
  productId: Scalars['ID']['output'];
  rank1: Scalars['Int']['output'];
  rank2: Scalars['Int']['output'];
  score1: Scalars['Float']['output'];
  score2: Scalars['Float']['output'];
};

export enum CommunityUserModel3DSort {
  Name = 'NAME',
  Recent = 'RECENT'
}

export type CommunityUserModels3DInput = {
  limit?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  sortBy?: InputMaybe<CommunityUserModel3DSort>;
};

export type ComparisonDifferences = {
  __typename?: 'ComparisonDifferences';
  config: Scalars['Boolean']['output'];
  performance: Scalars['Boolean']['output'];
  queryText: Scalars['Boolean']['output'];
  results: Scalars['Boolean']['output'];
};

export type ComparisonResult = {
  __typename?: 'ComparisonResult';
  differences: ComparisonDifferences;
  session1: SearchDebugSession;
  session2: SearchDebugSession;
  similarities: ComparisonSimilarities;
};

export type ComparisonSimilarities = {
  __typename?: 'ComparisonSimilarities';
  commonResults: Array<CommonResult>;
  scoreCorrelation: Scalars['Float']['output'];
  timeDifference: Scalars['Float']['output'];
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBrandOrderInput = {
  billingAddress: AddressInput;
  brandEmail?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  brandName: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  externalLinkKey?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  orderChannel?: InputMaybe<OrderChannel>;
  parentOrderId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  shippingAddress: AddressInput;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingDescription?: InputMaybe<Scalars['String']['input']>;
  sourceSupplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OrderStatus>;
  vatIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateBrandReplacementInput = {
  correctName: Scalars['String']['input'];
  misspelling: Scalars['String']['input'];
};

export type CreateBusinessApplicationInput = {
  billingAddress: AddressInput;
  companyName: Scalars['String']['input'];
  contactPerson: ContactPersonInput;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  email: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessProfileInput = {
  billingAddress: AddressInput;
  companyName: Scalars['String']['input'];
  contactPerson: ContactPersonInput;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  email: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEnterpriseInput = {
  billingCycleAnchorDay?: InputMaybe<Scalars['Int']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<EnterpriseFeatureFlagsInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<EnterpriseLimitsInput>;
  maxActiveUsers?: InputMaybe<Scalars['Int']['input']>;
  monthlyAiCreditLimit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnterpriseStatus>;
};

export type CreateOrderInput = {
  billingAddress: Scalars['JSONObject']['input'];
  businessProfileId: Scalars['ID']['input'];
  formData?: InputMaybe<Scalars['JSONObject']['input']>;
  notes?: InputMaybe<Scalars['JSONObject']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  products: Array<Scalars['JSONObject']['input']>;
  shippingAddress: Scalars['JSONObject']['input'];
  subtotal: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderItemInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  brandOrderId: Scalars['ID']['input'];
  clientPrice: Scalars['Float']['input'];
  clientReferenceId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['ID']['input'];
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  retailPrice: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  tradePrice: Scalars['Float']['input'];
  vatIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateParentOrderInput = {
  businessProfileId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReindexJobInput = {
  config?: InputMaybe<JobConfigInput>;
  profileId: Scalars['String']['input'];
  targetIndex: Scalars['String']['input'];
};

export type CreateSearchDebugHistoryInput = {
  config: SearchDebugConfigInput;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  preFilters?: InputMaybe<Scalars['JSON']['input']>;
  profileId: Scalars['ID']['input'];
  profileName: Scalars['String']['input'];
  queryText: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  results: SearchDebugResultsInput;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * A purchasable AI credit top-up bundle. Prices are sourced from Stripe so the
 * client always sees the up-to-date price for the configured Stripe Price ID.
 */
export type CreditPack = {
  __typename?: 'CreditPack';
  credits: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priceCents: Scalars['Int']['output'];
};

export type CropInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type CropProductImageInput = {
  crop: CropInput;
  key: Scalars['String']['input'];
  overlayImageUrl?: InputMaybe<Scalars['String']['input']>;
  overlayLeft?: InputMaybe<Scalars['Int']['input']>;
  overlayTop?: InputMaybe<Scalars['Int']['input']>;
  sourceImageUrl: Scalars['String']['input'];
};

export type CuratedItem = {
  __typename?: 'CuratedItem';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  product?: Maybe<Product>;
  setKey: Scalars['String']['output'];
};

export type CuratedItemInput = {
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export type CuratedSeedInput = {
  categoriesMetaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  key: Scalars['String']['input'];
  prioritizeAdjacentSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type CuratedSet = {
  __typename?: 'CuratedSet';
  id: Scalars['ID']['output'];
  items: Array<CuratedItem>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rotationWeight?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type CuratedSetInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rotationWeight?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  convertedAmount: Scalars['Float']['output'];
  from: Scalars['String']['output'];
  lastUpdated: Scalars['String']['output'];
  originalAmount: Scalars['Float']['output'];
  rateUsed: Scalars['Float']['output'];
  roundedAmount: Scalars['Float']['output'];
  to: Scalars['String']['output'];
};

export type CurrencyRateEntry = {
  __typename?: 'CurrencyRateEntry';
  currency: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export type CurrencyRatesResponse = {
  __typename?: 'CurrencyRatesResponse';
  base: Scalars['String']['output'];
  lastUpdated: Scalars['String']['output'];
  rates: Array<CurrencyRateEntry>;
  supported: Array<Scalars['String']['output']>;
};

export type CustomExpense = {
  __typename?: 'CustomExpense';
  description?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type CustomExpenseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type DashboardStatistics = {
  __typename?: 'DashboardStatistics';
  activeProfiles: Scalars['Int']['output'];
  averageEmbeddingTime: Scalars['Int']['output'];
  errorRate: Scalars['Float']['output'];
  runningJobs: Scalars['Int']['output'];
  totalEmbeddings: Scalars['Int']['output'];
  totalJobs: Scalars['Int']['output'];
  totalProfiles: Scalars['Int']['output'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  indexedDocuments: Scalars['Int']['output'];
  runningJobs: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalJobs: Scalars['Int']['output'];
  totalProfiles: Scalars['Int']['output'];
};

export type DateRangeInput = {
  end: Scalars['DateTime']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DebugPerformance = {
  __typename?: 'DebugPerformance';
  embeddingTimeMs?: Maybe<Scalars['Float']['output']>;
  indexStats: IndexStats;
  rerankTimeMs?: Maybe<Scalars['Float']['output']>;
  searchTimeMs?: Maybe<Scalars['Float']['output']>;
  totalTimeMs?: Maybe<Scalars['Float']['output']>;
};

export type DebugVectorSearchInput = {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  includeRawResults?: InputMaybe<Scalars['Boolean']['input']>;
  includeRerankedResults?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type DeleteObjectFromImageResult = {
  __typename?: 'DeleteObjectFromImageResult';
  modifiedImageUrl: Scalars['String']['output'];
};

export type DesignerOrderUpdateInput = {
  itemUpdates?: InputMaybe<Array<ProductAvailabilityInput>>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  removedItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OrderStatus>;
};

export enum DiscountFilterType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Default = 'DEFAULT'
}

export type DiscountRule = {
  __typename?: 'DiscountRule';
  brandName?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  discount: Scalars['Float']['output'];
  filterType: DiscountFilterType;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountRuleInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  discount: Scalars['Float']['input'];
  filterType: DiscountFilterType;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority: Scalars['Int']['input'];
};

export type Document = {
  __typename?: 'Document';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<User>;
  lockedExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Members with access (for owner share management). */
  members?: Maybe<Array<DocumentMember>>;
  moodBoards?: Maybe<Array<MoodBoard>>;
  /** Current user's role on this document (OWNER, EDITOR, or VIEWER). */
  myRole: DocumentAccessRole;
  name?: Maybe<Scalars['String']['output']>;
  priceListState?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum DocumentAccessRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type DocumentInvite = {
  __typename?: 'DocumentInvite';
  document: Document;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedAt: Scalars['DateTime']['output'];
  invitedBy: User;
  role: DocumentRole;
};

export type DocumentLockEvent = {
  __typename?: 'DocumentLockEvent';
  documentId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  reason?: Maybe<DocumentLockTransitionReason>;
  user?: Maybe<User>;
};

export type DocumentLockStatus = {
  __typename?: 'DocumentLockStatus';
  expiresAt: Scalars['DateTime']['output'];
  locked: Scalars['Boolean']['output'];
  lockedAt: Scalars['DateTime']['output'];
  user: User;
};

export enum DocumentLockTransitionReason {
  Expired = 'EXPIRED',
  ExplicitUnlock = 'EXPLICIT_UNLOCK',
  Locked = 'LOCKED',
  Refreshed = 'REFRESHED'
}

export type DocumentMember = {
  __typename?: 'DocumentMember';
  addedAt: Scalars['DateTime']['output'];
  addedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  role: DocumentRole;
  user: User;
};

export type DocumentMembersResponse = {
  __typename?: 'DocumentMembersResponse';
  members: Array<DocumentMember>;
};

export enum DocumentRole {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export enum DocumentUpdateChangeType {
  CurrencyChanged = 'CURRENCY_CHANGED'
}

export type DocumentUpdatedEvent = {
  __typename?: 'DocumentUpdatedEvent';
  changeType: DocumentUpdateChangeType;
  documentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type EditImageWithAiResult = ProItemAiImage | UserItem;

export type EditImageWithAiSessionResult = ProItem | ProItemAiImage | UserItem;

export type EditSupplierInput = {
  UTMTag?: InputMaybe<Scalars['String']['input']>;
  affiliate?: InputMaybe<Scalars['ID']['input']>;
  affiliateUrl?: InputMaybe<Scalars['String']['input']>;
  aiCategoryScope?: InputMaybe<Scalars['JSON']['input']>;
  brandContact?: InputMaybe<Scalars['String']['input']>;
  brandDescription?: InputMaybe<Scalars['String']['input']>;
  calculateToExcludeVAT?: InputMaybe<Scalars['Boolean']['input']>;
  calculateToIncludeVAT?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountInformation?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountRules?: InputMaybe<Array<DiscountRuleInput>>;
  id: Scalars['ID']['input'];
  identifier?: InputMaybe<Scalars['String']['input']>;
  importAllTypes?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isQuotable?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parserKeepBG?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  purchaseTerms?: InputMaybe<Scalars['String']['input']>;
  quoteDiscount?: InputMaybe<Scalars['Float']['input']>;
  requiresQuoteAccess?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type EditUserInput = {
  betaProgram?: InputMaybe<Array<Scalars['String']['input']>>;
  company?: InputMaybe<Scalars['String']['input']>;
  countCustomProducts?: InputMaybe<Scalars['Int']['input']>;
  countDesigns?: InputMaybe<Scalars['Int']['input']>;
  countSharedDesigns?: InputMaybe<Scalars['Int']['input']>;
  countUploadedAIImages?: InputMaybe<Scalars['Int']['input']>;
  countUploadedImages?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  quoteAccess?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  setupStatus?: InputMaybe<SetupStatusInput>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  trialActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndViewShownAt?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  usingBoni?: InputMaybe<UsingBoniOption>;
  usingRole?: InputMaybe<UsingRole>;
  verificationLinkEmailedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verificationLinkShownAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmbeddingConfig = {
  __typename?: 'EmbeddingConfig';
  chunking: ChunkingConfig;
  dimension: Scalars['Int']['output'];
  fields: Array<EmbeddingFieldConfig>;
  inputTemplate?: Maybe<Scalars['String']['output']>;
  language: LanguageConfig;
  model: Scalars['String']['output'];
  preReplacementListId?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  vectorField: Scalars['String']['output'];
};

export type EmbeddingConfigInput = {
  chunking: ChunkingConfigInput;
  dimension: Scalars['Int']['input'];
  fields: Array<EmbeddingFieldConfigInput>;
  inputTemplate?: InputMaybe<Scalars['String']['input']>;
  language: LanguageConfigInput;
  model: Scalars['String']['input'];
  preReplacementListId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  vectorField: Scalars['String']['input'];
};

export type EmbeddingFieldConfig = {
  __typename?: 'EmbeddingFieldConfig';
  fallback?: Maybe<Scalars['String']['output']>;
  flattenObject?: Maybe<Scalars['Boolean']['output']>;
  numericLabelKeys?: Maybe<Array<Scalars['String']['output']>>;
  path: Scalars['String']['output'];
  transform?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Int']['output'];
};

export type EmbeddingFieldConfigInput = {
  fallback?: InputMaybe<Scalars['String']['input']>;
  flattenObject?: InputMaybe<Scalars['Boolean']['input']>;
  numericLabelKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  path: Scalars['String']['input'];
  transform?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Int']['input'];
};

export type EmbeddingInfo = {
  __typename?: 'EmbeddingInfo';
  dimension: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
};

export type EmbeddingInfoInput = {
  dimension: Scalars['Int']['input'];
  model: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  tokens: Scalars['Int']['input'];
};

export type EmbeddingProvider = {
  __typename?: 'EmbeddingProvider';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSONObject']['output'];
  health: ProviderHealth;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  models: Array<ProviderModel>;
  name: Scalars['String']['output'];
  rateLimit: RateLimitConfig;
  status: ProviderStatus;
  type: EmbeddingProviderType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usage: ProviderUsage;
  version: Scalars['Int']['output'];
};

export type EmbeddingProviderInput = {
  authSecretKeyRef: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  headers: Scalars['JSONObject']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  models: Array<ProviderModelInput>;
  name: Scalars['String']['input'];
  rateLimit: RateLimitConfigInput;
  type: EmbeddingProviderType;
};

export type EmbeddingProviderResponse = {
  __typename?: 'EmbeddingProviderResponse';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  models: Array<Scalars['String']['output']>;
  rateLimit?: Maybe<RateLimitConfig>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmbeddingProviderType {
  Cohere = 'COHERE',
  Custom = 'CUSTOM',
  Openai = 'OPENAI',
  Voyageai = 'VOYAGEAI'
}

/** Legacy response types are removed in favor of direct response objects the frontend expects. */
export type EmbeddingProvidersResponse = {
  __typename?: 'EmbeddingProvidersResponse';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  models: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rateLimit?: Maybe<RateLimitConfig>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Enterprise = {
  __typename?: 'Enterprise';
  activeUserCount: Scalars['Int']['output'];
  aiCredits: AiCreditEntitlement;
  aiUsage: Array<AiUsageCounter>;
  aiUsageByMember: Array<AiUsageMemberSummary>;
  auditEvents: Array<EnterpriseAuditEvent>;
  billingCycleAnchorDay: Scalars['Int']['output'];
  billingEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  featureFlags: EnterpriseFeatureFlags;
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  limits: EnterpriseLimits;
  maxActiveUsers: Scalars['Int']['output'];
  memberships: Array<EnterpriseMembership>;
  monthlyAiCreditLimit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  occupiedSeatCount: Scalars['Int']['output'];
  pendingUserCount: Scalars['Int']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  status: EnterpriseStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  waitlistedUserCount: Scalars['Int']['output'];
};


export type EnterpriseAiUsageArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  granularity: AiUsageGranularity;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EnterpriseAiUsageByMemberArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  granularity?: InputMaybe<AiUsageGranularity>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EnterpriseAuditEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type EnterpriseMembershipsArgs = {
  status?: InputMaybe<Array<EnterpriseMembershipStatus>>;
};

export type EnterpriseAuditEvent = {
  __typename?: 'EnterpriseAuditEvent';
  actor?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  enterprise: Enterprise;
  id: Scalars['ID']['output'];
  membership?: Maybe<EnterpriseMembership>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  type: EnterpriseAuditEventType;
};

export enum EnterpriseAuditEventType {
  AiCreditsUpdated = 'AI_CREDITS_UPDATED',
  Created = 'CREATED',
  EmailAdded = 'EMAIL_ADDED',
  EmailRemoved = 'EMAIL_REMOVED',
  FeatureFlagsUpdated = 'FEATURE_FLAGS_UPDATED',
  InvitationSent = 'INVITATION_SENT',
  LimitsUpdated = 'LIMITS_UPDATED',
  MembershipActivated = 'MEMBERSHIP_ACTIVATED',
  MembershipDeactivated = 'MEMBERSHIP_DEACTIVATED',
  MembershipWaitlisted = 'MEMBERSHIP_WAITLISTED',
  Updated = 'UPDATED'
}

export type EnterpriseFeatureFlags = {
  __typename?: 'EnterpriseFeatureFlags';
  aiTools: Scalars['Boolean']['output'];
  customProducts: Scalars['Boolean']['output'];
  floorplannerCatalogMaterials: Scalars['Boolean']['output'];
  floorplannerProduct3DAssets: Scalars['Boolean']['output'];
  folders: Scalars['Boolean']['output'];
  priceLists: Scalars['Boolean']['output'];
  profiles: Scalars['Boolean']['output'];
  quoteAccess: Scalars['Boolean']['output'];
  shareDocuments: Scalars['Boolean']['output'];
  sharedUploads: Scalars['Boolean']['output'];
};

export type EnterpriseFeatureFlagsInput = {
  aiTools?: InputMaybe<Scalars['Boolean']['input']>;
  customProducts?: InputMaybe<Scalars['Boolean']['input']>;
  floorplannerCatalogMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  floorplannerProduct3DAssets?: InputMaybe<Scalars['Boolean']['input']>;
  folders?: InputMaybe<Scalars['Boolean']['input']>;
  priceLists?: InputMaybe<Scalars['Boolean']['input']>;
  profiles?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAccess?: InputMaybe<Scalars['Boolean']['input']>;
  shareDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  sharedUploads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnterpriseLimits = {
  __typename?: 'EnterpriseLimits';
  maxBoards?: Maybe<Scalars['Int']['output']>;
  maxCustomProducts?: Maybe<Scalars['Int']['output']>;
  maxFloorplanShapes?: Maybe<Scalars['Int']['output']>;
  maxFloorplans?: Maybe<Scalars['Int']['output']>;
  maxPagesPerProject?: Maybe<Scalars['Int']['output']>;
  maxProjects?: Maybe<Scalars['Int']['output']>;
  maxSharedDesigns?: Maybe<Scalars['Int']['output']>;
  maxUploadedImages?: Maybe<Scalars['Int']['output']>;
};

export type EnterpriseLimitsInput = {
  maxBoards?: InputMaybe<Scalars['Int']['input']>;
  maxCustomProducts?: InputMaybe<Scalars['Int']['input']>;
  maxFloorplanShapes?: InputMaybe<Scalars['Int']['input']>;
  maxFloorplans?: InputMaybe<Scalars['Int']['input']>;
  maxPagesPerProject?: InputMaybe<Scalars['Int']['input']>;
  maxProjects?: InputMaybe<Scalars['Int']['input']>;
  maxSharedDesigns?: InputMaybe<Scalars['Int']['input']>;
  maxUploadedImages?: InputMaybe<Scalars['Int']['input']>;
};

export enum EnterpriseMemberRole {
  Manager = 'MANAGER',
  Member = 'MEMBER'
}

export type EnterpriseMembership = {
  __typename?: 'EnterpriseMembership';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  enterprise: Enterprise;
  id: Scalars['ID']['output'];
  invitationSentAt?: Maybe<Scalars['DateTime']['output']>;
  inviteExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedBy?: Maybe<User>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  normalizedEmail: Scalars['String']['output'];
  role: EnterpriseMemberRole;
  status: EnterpriseMembershipStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum EnterpriseMembershipStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING',
  Waitlisted = 'WAITLISTED'
}

export enum EnterpriseStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  PastDue = 'PAST_DUE'
}

export type EnterprisesQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<EnterpriseStatus>>;
};

export type EnterprisesResponse = {
  __typename?: 'EnterprisesResponse';
  data: Array<Enterprise>;
  total: Scalars['Int']['output'];
};

export enum EntitlementPlan {
  Developer = 'DEVELOPER',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Pro = 'PRO',
  ProYear = 'PRO_YEAR',
  Starter = 'STARTER'
}

export type ExampleImage = {
  __typename?: 'ExampleImage';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** When true, the image is scaled to cover the moodboard page when added. */
  coverPage: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExampleImagesQueryInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ExampleImagesResponse = {
  __typename?: 'ExampleImagesResponse';
  data: Array<ExampleImage>;
  total: Scalars['Int']['output'];
};

export type ExclusionConfig = {
  __typename?: 'ExclusionConfig';
  enabled: Scalars['Boolean']['output'];
  fieldConditions: Array<FieldCondition>;
};

export type ExistingFiltersInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  colors?: InputMaybe<Array<Scalars['String']['input']>>;
  productsSkip?: InputMaybe<Scalars['Int']['input']>;
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FieldCondition = {
  __typename?: 'FieldCondition';
  field: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldConditionInput = {
  field: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FilterFieldValue = {
  __typename?: 'FilterFieldValue';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FlaggedProductMessage = {
  __typename?: 'FlaggedProductMessage';
  Product?: Maybe<Product>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Floorplan = {
  __typename?: 'Floorplan';
  backdropImage?: Maybe<Scalars['String']['output']>;
  backdropRatio?: Maybe<Scalars['Float']['output']>;
  backdropSize?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display currency for catalog price summary (catalog storage stays SEK). */
  currency?: Maybe<Scalars['String']['output']>;
  /** Active edit-lease holder, if any. */
  editingBy?: Maybe<User>;
  /** When the current edit lease expires. */
  editingExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** True when the current user owns this floorplan. */
  isOwner: Scalars['Boolean']['output'];
  json?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Users with shared edit access (enterprise team sharing). */
  sharedWith?: Maybe<Array<User>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Owner of the floorplan. */
  user?: Maybe<User>;
};

export type FloorplanCollabEvent = {
  __typename?: 'FloorplanCollabEvent';
  editingBy?: Maybe<User>;
  floorplanId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Presence + lease state for turn-taking floorplan editing. */
export type FloorplanCollabState = {
  __typename?: 'FloorplanCollabState';
  editingBy?: Maybe<User>;
  editingExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  isMine: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FloorplanEditInput = {
  backdropImage?: InputMaybe<Scalars['Upload']['input']>;
  backdropRatio?: InputMaybe<Scalars['Float']['input']>;
  backdropSize?: InputMaybe<Scalars['Float']['input']>;
  /** Display currency for catalog price summary (default SEK). */
  currency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optimistic concurrency token. When provided and it does not match the
   * stored updatedAt, the mutation fails with FLOORPLAN_STALE.
   */
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloorplanImageImport = {
  __typename?: 'FloorplanImageImport';
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  attemptCount: Scalars['Int']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  draft?: Maybe<FloorplanImportDraft>;
  draftRevision: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  floorplanId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isPartial: Scalars['Boolean']['output'];
  latestOverlayUrl?: Maybe<Scalars['String']['output']>;
  mode: FloorplanImageImportMode;
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  pipelineVersion: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  progress: Scalars['Float']['output'];
  reviewState?: Maybe<FloorplanImportReviewState>;
  stage: FloorplanImageImportStage;
  stageStates: Array<FloorplanImportStageState>;
  status: FloorplanImageImportStatus;
  symbolCatalogHash: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum FloorplanImageImportMode {
  Elevation = 'ELEVATION',
  FloorPlan = 'FLOOR_PLAN'
}

export enum FloorplanImageImportStage {
  DetectingOpenings = 'DETECTING_OPENINGS',
  DetectingSymbols = 'DETECTING_SYMBOLS',
  Finalizing = 'FINALIZING',
  Layering = 'LAYERING',
  Normalizing = 'NORMALIZING',
  Queued = 'QUEUED',
  ReadingAnnotations = 'READING_ANNOTATIONS',
  Reconciling = 'RECONCILING',
  ReconcilingStructure = 'RECONCILING_STRUCTURE',
  TracingStructure = 'TRACING_STRUCTURE',
  Understanding = 'UNDERSTANDING',
  Validating = 'VALIDATING',
  Verifying = 'VERIFYING'
}

export enum FloorplanImageImportStatus {
  Applied = 'APPLIED',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Failed = 'FAILED',
  NeedsInput = 'NEEDS_INPUT',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Ready = 'READY'
}

export type FloorplanImportCalibrationInput = {
  distanceMm: Scalars['Float']['input'];
  end: FloorplanImportPointInput;
  start: FloorplanImportPointInput;
};

export enum FloorplanImportChangeType {
  Changed = 'CHANGED',
  New = 'NEW'
}

export type FloorplanImportDraft = {
  __typename?: 'FloorplanImportDraft';
  issues: Array<FloorplanImportIssue>;
  labels: Array<FloorplanImportLabel>;
  lines: Array<FloorplanImportLine>;
  measurements: Array<FloorplanImportMeasurement>;
  mode: FloorplanImageImportMode;
  openings: Array<FloorplanImportOpening>;
  overallConfidence: Scalars['Float']['output'];
  scaleConfidence?: Maybe<Scalars['Float']['output']>;
  scaleEvidence?: Maybe<Array<FloorplanImportScaleEvidence>>;
  scaleMmPerPixel: Scalars['Float']['output'];
  scaleSource?: Maybe<FloorplanImportScaleSource>;
  sourceHeight: Scalars['Int']['output'];
  sourceWidth: Scalars['Int']['output'];
  symbols: Array<FloorplanImportSymbol>;
  version: Scalars['Int']['output'];
  walls: Array<FloorplanImportWall>;
};

export type FloorplanImportIssue = {
  __typename?: 'FloorplanImportIssue';
  code: Scalars['String']['output'];
  entityRefs: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  severity: FloorplanImportIssueSeverity;
};

export enum FloorplanImportIssueSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type FloorplanImportLabel = {
  __typename?: 'FloorplanImportLabel';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  position: FloorplanImportPoint;
  ref: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum FloorplanImportLayer {
  Annotations = 'ANNOTATIONS',
  Openings = 'OPENINGS',
  Structure = 'STRUCTURE',
  Symbols = 'SYMBOLS'
}

export type FloorplanImportLine = {
  __typename?: 'FloorplanImportLine';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  end: FloorplanImportPoint;
  ref: Scalars['String']['output'];
  start: FloorplanImportPoint;
};

export type FloorplanImportMeasurement = {
  __typename?: 'FloorplanImportMeasurement';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  end: FloorplanImportPoint;
  ref: Scalars['String']['output'];
  start: FloorplanImportPoint;
  valueMm: Scalars['Float']['output'];
};

export type FloorplanImportNormalizedRectInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type FloorplanImportOpening = {
  __typename?: 'FloorplanImportOpening';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  kind: FloorplanImportOpeningKind;
  offset: Scalars['Float']['output'];
  ref: Scalars['String']['output'];
  wallRef: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export enum FloorplanImportOpeningKind {
  Door = 'DOOR',
  DoubleDoor = 'DOUBLE_DOOR',
  Void = 'VOID',
  Window = 'WINDOW'
}

export type FloorplanImportPoint = {
  __typename?: 'FloorplanImportPoint';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type FloorplanImportPointInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type FloorplanImportReviewInput = {
  excludedEntityIds: Array<Scalars['String']['input']>;
  symbolOverrides: Array<FloorplanImportSymbolOverrideInput>;
};

export type FloorplanImportReviewState = {
  __typename?: 'FloorplanImportReviewState';
  excludedEntityIds: Array<Scalars['String']['output']>;
  symbolOverrides: Array<FloorplanImportSymbolOverride>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FloorplanImportScaleEvidence = {
  __typename?: 'FloorplanImportScaleEvidence';
  confidence: Scalars['Float']['output'];
  entityRef?: Maybe<Scalars['String']['output']>;
  kind: FloorplanImportScaleEvidenceKind;
  label: Scalars['String']['output'];
  scaleMmPerPixel: Scalars['Float']['output'];
};

export enum FloorplanImportScaleEvidenceKind {
  DrawingPrior = 'DRAWING_PRIOR',
  ManualMeasurement = 'MANUAL_MEASUREMENT',
  MatchedSymbol = 'MATCHED_SYMBOL',
  StandardOpening = 'STANDARD_OPENING',
  VisibleMeasurement = 'VISIBLE_MEASUREMENT',
  WallThickness = 'WALL_THICKNESS'
}

export enum FloorplanImportScaleSource {
  ArchitecturalPriors = 'ARCHITECTURAL_PRIORS',
  Manual = 'MANUAL',
  MatchedSymbols = 'MATCHED_SYMBOLS',
  Mixed = 'MIXED',
  VisibleMeasurements = 'VISIBLE_MEASUREMENTS'
}

export type FloorplanImportStageState = {
  __typename?: 'FloorplanImportStageState';
  attempts: Scalars['Int']['output'];
  entityCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Float']['output'];
  recoverable: Scalars['Boolean']['output'];
  stage: FloorplanImageImportStage;
  status: FloorplanImportStageStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FloorplanImportStageStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Skipped = 'SKIPPED'
}

export type FloorplanImportSymbol = {
  __typename?: 'FloorplanImportSymbol';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  detectedHeight?: Maybe<Scalars['Float']['output']>;
  detectedWidth?: Maybe<Scalars['Float']['output']>;
  height: Scalars['Float']['output'];
  libraryKey?: Maybe<Scalars['String']['output']>;
  position: FloorplanImportPoint;
  ref: Scalars['String']['output'];
  rotation: Scalars['Float']['output'];
  semanticType: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type FloorplanImportSymbolCatalogEntryInput = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  category: Scalars['String']['input'];
  height: Scalars['Float']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  scaleReliable?: InputMaybe<Scalars['Boolean']['input']>;
  tab: FloorplanImageImportMode;
  width: Scalars['Float']['input'];
};

export type FloorplanImportSymbolOverride = {
  __typename?: 'FloorplanImportSymbolOverride';
  libraryKey: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  rotation: Scalars['Float']['output'];
};

export type FloorplanImportSymbolOverrideInput = {
  libraryKey: Scalars['String']['input'];
  ref: Scalars['String']['input'];
  rotation: Scalars['Float']['input'];
};

export type FloorplanImportWall = {
  __typename?: 'FloorplanImportWall';
  changeType?: Maybe<FloorplanImportChangeType>;
  confidence: Scalars['Float']['output'];
  end: FloorplanImportPoint;
  height: Scalars['Float']['output'];
  ref: Scalars['String']['output'];
  start: FloorplanImportPoint;
  thickness: Scalars['Float']['output'];
};

export type FloorplanSceneRenderInput = {
  manifest: Scalars['JSONObject']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the created UserItem. Floorplanner sends project name + date, editable in the render modal. */
  name?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  snapshot: Scalars['Upload']['input'];
  stylePreset?: InputMaybe<Scalars['String']['input']>;
};

export type FloorplanSceneRenderResult = {
  __typename?: 'FloorplanSceneRenderResult';
  createdAt: Scalars['DateTime']['output'];
  imageUrl: Scalars['String']['output'];
  manifestDigest: Scalars['String']['output'];
  model: Scalars['String']['output'];
  userItemId: Scalars['ID']['output'];
};

export type FloorplannerSymbol3DDefault = {
  __typename?: 'FloorplannerSymbol3DDefault';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modelPitchOffsetDeg?: Maybe<Scalars['Float']['output']>;
  modelRollOffsetDeg?: Maybe<Scalars['Float']['output']>;
  modelYawOffsetDeg?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['ID']['output']>;
  publicModel?: Maybe<UserModel3D>;
  publicModelId?: Maybe<Scalars['ID']['output']>;
  standardModelKey?: Maybe<Scalars['String']['output']>;
  symbolKey: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
};

export type FloorplannerSymbol3DDefaultInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  modelPitchOffsetDeg?: InputMaybe<Scalars['Float']['input']>;
  modelRollOffsetDeg?: InputMaybe<Scalars['Float']['input']>;
  modelYawOffsetDeg?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  publicModelId?: InputMaybe<Scalars['ID']['input']>;
  standardModelKey?: InputMaybe<Scalars['String']['input']>;
  symbolKey: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type Folder = {
  __typename?: 'Folder';
  documents?: Maybe<Array<Document>>;
  floorplans?: Maybe<Array<Floorplan>>;
  galleryBoards?: Maybe<Array<GalleryBoard>>;
  id: Scalars['ID']['output'];
  materials?: Maybe<Array<Material>>;
  name: Scalars['String']['output'];
  paints?: Maybe<Array<Product>>;
  proItems?: Maybe<Array<ProItem>>;
  products?: Maybe<Array<Product>>;
  surfaces?: Maybe<Array<Surface>>;
  userItems?: Maybe<Array<UserItem>>;
};

export type GalleryBoard = {
  __typename?: 'GalleryBoard';
  createdBy: User;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  likedBy?: Maybe<Array<User>>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paints?: Maybe<Array<MoodboardPaint>>;
  proItems?: Maybe<Array<MoodboardProItem>>;
  proSettings?: Maybe<BoardProSettings>;
  products?: Maybe<Array<MoodboardProduct>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GalleryBoardEditInput = {
  id: Scalars['ID']['input'];
  json?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum GalleryBoardSort {
  Latest = 'LATEST',
  MostLiked = 'MOST_LIKED'
}

export type GalleryBoardsInput = {
  limit: Scalars['Int']['input'];
  notLocked?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  sort?: InputMaybe<GalleryBoardSort>;
};

export type GenerateAiVideoResult = {
  __typename?: 'GenerateAiVideoResult';
  creditsConsumed: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  status: AiVideoJobStatus;
  userItem?: Maybe<UserItem>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type GenerateApiKeyResponse = {
  __typename?: 'GenerateApiKeyResponse';
  config?: Maybe<ApiKeyInfo>;
  error?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImageSearchCropInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type ImageSearchInput = {
  crop?: InputMaybe<ImageSearchCropInput>;
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSearchResponse = {
  __typename?: 'ImageSearchResponse';
  embeddingTime: Scalars['Float']['output'];
  hasMore: Scalars['Boolean']['output'];
  indexUsed: Scalars['String']['output'];
  profileUsed: Scalars['String']['output'];
  results: Array<ImageSearchResult>;
  searchTime: Scalars['Float']['output'];
  totalResults: Scalars['Int']['output'];
};

export type ImageSearchResult = {
  __typename?: 'ImageSearchResult';
  _id: Scalars['ID']['output'];
  document: Scalars['JSONObject']['output'];
  matchedFields: Array<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type IndexAuditLogEntry = {
  __typename?: 'IndexAuditLogEntry';
  action: Scalars['String']['output'];
  details: Scalars['JSONObject']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IndexConfig = {
  __typename?: 'IndexConfig';
  batchSize: Scalars['Int']['output'];
  exclusionConfig?: Maybe<ExclusionConfig>;
  fields?: Maybe<Array<IndexField>>;
  maxRetries?: Maybe<Scalars['Int']['output']>;
  parallelism?: Maybe<Scalars['Int']['output']>;
  preFilterFields?: Maybe<Array<Scalars['String']['output']>>;
  similarityAlgorithm?: Maybe<Scalars['String']['output']>;
  throttleMs?: Maybe<Scalars['Int']['output']>;
};

export type IndexConfigInput = {
  exclusionConfig?: InputMaybe<IndexExclusionConfigInput>;
  fields?: InputMaybe<Array<IndexFieldInput>>;
  preFilterFields?: InputMaybe<Array<Scalars['String']['input']>>;
  similarityAlgorithm: Scalars['String']['input'];
};

export type IndexExclusionConfigInput = {
  enabled: Scalars['Boolean']['input'];
  fieldConditions: Array<FieldConditionInput>;
};

export type IndexField = {
  __typename?: 'IndexField';
  name: Scalars['String']['output'];
  searchable: Scalars['Boolean']['output'];
  sortable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type IndexFieldInput = {
  name: Scalars['String']['input'];
  searchable: Scalars['Boolean']['input'];
  sortable: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type IndexHealth = {
  __typename?: 'IndexHealth';
  issues: Array<Scalars['String']['output']>;
  lastCheck: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type IndexInfo = {
  __typename?: 'IndexInfo';
  available?: Maybe<Array<IndexVersion>>;
  createdAt: Scalars['DateTime']['output'];
  docs: Scalars['Int']['output'];
  inSync: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IndexStats = {
  __typename?: 'IndexStats';
  avgVectorDistance: Scalars['Float']['output'];
  documentsSearched: Scalars['Int']['output'];
  searchMethod: Scalars['String']['output'];
};

export type IndexVersion = {
  __typename?: 'IndexVersion';
  activeVersion: Scalars['String']['output'];
  auditLog: Array<IndexAuditLogEntry>;
  collectionName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  docs: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inSync: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  vectorProfile: VectorProfile;
  versions: Array<IndexVersionInfo>;
};

export type IndexVersionDetail = {
  __typename?: 'IndexVersionDetail';
  createdAt: Scalars['DateTime']['output'];
  docs: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IndexVersionInfo = {
  __typename?: 'IndexVersionInfo';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  docs?: Maybe<Scalars['Int']['output']>;
  documentCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  health: IndexHealth;
  inSync: Scalars['Boolean']['output'];
  indexedDocumentCount: Scalars['Int']['output'];
  metadata: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
  status: IndexVersionStatus;
};

export type IndexVersionInfoInput = {
  documentCount: Scalars['Int']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  indexedDocumentCount: Scalars['Int']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  status: IndexVersionStatus;
};

export type IndexVersionInput = {
  activeVersion: Scalars['String']['input'];
  collectionName: Scalars['String']['input'];
  vectorProfileId: Scalars['String']['input'];
  versions: Array<IndexVersionInfoInput>;
};

export enum IndexVersionStatus {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Failed = 'FAILED',
  Inactive = 'INACTIVE'
}

export type InviteResult = {
  __typename?: 'InviteResult';
  invite?: Maybe<DocumentInvite>;
  member?: Maybe<DocumentMember>;
};

export type JobAuditLogEntry = {
  __typename?: 'JobAuditLogEntry';
  action: Scalars['String']['output'];
  details: Scalars['JSONObject']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<Scalars['String']['output']>;
};

export type JobConfig = {
  __typename?: 'JobConfig';
  batchSize: Scalars['Int']['output'];
  maxRetries?: Maybe<Scalars['Int']['output']>;
  parallelism?: Maybe<Scalars['Int']['output']>;
  throttleMs?: Maybe<Scalars['Int']['output']>;
};

export type JobConfigInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  parallelism?: InputMaybe<Scalars['Int']['input']>;
  throttleMs?: InputMaybe<Scalars['Int']['input']>;
};

export type JobConfiguration = {
  __typename?: 'JobConfiguration';
  batchSize: Scalars['Int']['output'];
  concurrency: Scalars['Int']['output'];
  filter: Scalars['JSONObject']['output'];
  forceUpdate: Scalars['Boolean']['output'];
  retryAttempts: Scalars['Int']['output'];
  retryDelayMs: Scalars['Int']['output'];
  skipExisting: Scalars['Boolean']['output'];
};

export type JobConfigurationInput = {
  batchSize: Scalars['Int']['input'];
  concurrency: Scalars['Int']['input'];
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  forceUpdate: Scalars['Boolean']['input'];
  retryAttempts: Scalars['Int']['input'];
  retryDelayMs: Scalars['Int']['input'];
  skipExisting: Scalars['Boolean']['input'];
};

export type JobFailure = {
  __typename?: 'JobFailure';
  _id: Scalars['ID']['output'];
  context?: Maybe<Scalars['JSON']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  retryCount: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type JobPerformance = {
  __typename?: 'JobPerformance';
  averageDocumentTime: Scalars['Int']['output'];
  errorRate: Scalars['Float']['output'];
  peakThroughput: Scalars['Int']['output'];
  totalProcessingTime: Scalars['Int']['output'];
};

export type JobProgress = {
  __typename?: 'JobProgress';
  etaSec?: Maybe<Scalars['Int']['output']>;
  pct?: Maybe<Scalars['Float']['output']>;
  percentage: Scalars['Float']['output'];
  processed: Scalars['Int']['output'];
  throughput: JobThroughput;
  total: Scalars['Int']['output'];
};

export enum JobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DevPaused = 'DEV_PAUSED',
  DevQueued = 'DEV_QUEUED',
  DevRunning = 'DEV_RUNNING',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type JobThroughput = {
  __typename?: 'JobThroughput';
  documentsPerHour: Scalars['Int']['output'];
  documentsPerMinute: Scalars['Int']['output'];
};

export type LanguageConfig = {
  __typename?: 'LanguageConfig';
  detect: Scalars['Boolean']['output'];
  exceptionsListId?: Maybe<Scalars['String']['output']>;
  mode: LanguageMode;
};

export type LanguageConfigInput = {
  detect: Scalars['Boolean']['input'];
  exceptionsListId?: InputMaybe<Scalars['String']['input']>;
  mode: LanguageMode;
};

export enum LanguageMode {
  Auto = 'AUTO',
  None = 'NONE'
}

export type LinkAccess = {
  __typename?: 'LinkAccess';
  accessCount: Scalars['Int']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRevoked: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  lastAccessIP?: Maybe<Scalars['String']['output']>;
  lastAccessTime?: Maybe<Scalars['String']['output']>;
  maxAccessCount?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['String']['output'];
};

export type LinkAccessLog = {
  __typename?: 'LinkAccessLog';
  accessIP?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['String']['output'];
  action: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type LogFloorplanAiRenderErrorInput = {
  errorMessage: Scalars['String']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  snapshotBytes?: InputMaybe<Scalars['Int']['input']>;
  stylePreset?: InputMaybe<Scalars['String']['input']>;
};

export enum MagicGrabAction {
  Delete = 'DELETE',
  Move = 'MOVE'
}

export type MagicGrabResult = {
  __typename?: 'MagicGrabResult';
  boundingBox: BoundingBox;
  confidence: Scalars['Float']['output'];
  extractedObjectUrl: Scalars['String']['output'];
  maskUrl?: Maybe<Scalars['String']['output']>;
  modifiedImageUrl?: Maybe<Scalars['String']['output']>;
  objectMetadata: ObjectMetadata;
};

export type Material = {
  __typename?: 'Material';
  categories?: Maybe<Array<Maybe<MaterialCategory>>>;
  colors?: Maybe<Array<Maybe<Color>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MaterialCategory = {
  __typename?: 'MaterialCategory';
  children?: Maybe<Array<Maybe<MaterialCategory>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<MaterialCategory>;
};

export type MaterialCategoryInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type MaterialEditInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<Scalars['Upload']['input']>;
  productImageNoBg?: InputMaybe<Scalars['Upload']['input']>;
};

export type MaterialInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
};

export type MaterialResponse = {
  __typename?: 'MaterialResponse';
  data?: Maybe<Array<Material>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type MaterialsQueryInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type MigrationResponse = {
  __typename?: 'MigrationResponse';
  message: Scalars['String']['output'];
  results: Scalars['JSONObject']['output'];
  success: Scalars['Boolean']['output'];
};

export type MoodBoard = {
  __typename?: 'MoodBoard';
  documentId?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * When true, the page is skipped in Presentation view (PowerPoint-style).
   * Does not change existing share links; share page selection is chosen at share time.
   */
  hiddenFromPresentation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<MoodBoardMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  paints?: Maybe<Array<MoodboardPaint>>;
  proItems?: Maybe<Array<MoodboardProItem>>;
  proSettings?: Maybe<BoardProSettings>;
  products?: Maybe<Array<MoodboardProduct>>;
  sharedWith?: Maybe<Array<User>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MoodBoardEditInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  proSettings?: InputMaybe<BoardProSettingsInput>;
};

export type MoodBoardLockEvent = {
  __typename?: 'MoodBoardLockEvent';
  documentId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  moodBoardId: Scalars['ID']['output'];
  reason?: Maybe<MoodBoardLockTransitionReason>;
  user?: Maybe<User>;
};

export enum MoodBoardLockTransitionReason {
  Expired = 'EXPIRED',
  ExplicitUnlock = 'EXPLICIT_UNLOCK',
  Locked = 'LOCKED',
  Refreshed = 'REFRESHED',
  Replaced = 'REPLACED'
}

export type MoodBoardMetadata = {
  __typename?: 'MoodBoardMetadata';
  /** When the lock expires (TTL). After this time the lock is auto-released. */
  expiresAt: Scalars['DateTime']['output'];
  /** Whether the board is currently locked. */
  locked: Scalars['Boolean']['output'];
  /** When the board was locked. */
  lockedAt: Scalars['DateTime']['output'];
  user: User;
};

export type MoodBoardNote = {
  __typename?: 'MoodBoardNote';
  date: Scalars['String']['output'];
  message: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export enum MoodBoardUpdateChangeType {
  Copied = 'COPIED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  DetailsUpdated = 'DETAILS_UPDATED',
  Moved = 'MOVED',
  Saved = 'SAVED'
}

export type MoodBoardUpdatedEvent = {
  __typename?: 'MoodBoardUpdatedEvent';
  changeType: MoodBoardUpdateChangeType;
  documentId: Scalars['ID']['output'];
  moodBoardId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type MoodboardImageCleanupResult = {
  __typename?: 'MoodboardImageCleanupResult';
  bucket: Scalars['String']['output'];
  deleted: Scalars['Int']['output'];
  deletedKeys: Array<Scalars['String']['output']>;
  dryRun: Scalars['Boolean']['output'];
  eligible: Scalars['Int']['output'];
  eligibleKeys: Array<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  failedKeys: Array<Scalars['String']['output']>;
  gracePeriodHours: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  referenced: Scalars['Int']['output'];
  scanned: Scalars['Int']['output'];
  skippedRecent: Scalars['Int']['output'];
};

export type MoodboardPaint = {
  __typename?: 'MoodboardPaint';
  code: Scalars['String']['output'];
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type MoodboardProItem = {
  __typename?: 'MoodboardProItem';
  id: Scalars['String']['output'];
  notShowInMoodboard?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProItem>;
};

export type MoodboardProduct = {
  __typename?: 'MoodboardProduct';
  breakColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  notShowInMoodboard?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  selectedImage?: Maybe<Scalars['String']['output']>;
  selectedVariant?: Maybe<Scalars['String']['output']>;
};

export type MoodboardProductSnapshotRow = {
  __typename?: 'MoodboardProductSnapshotRow';
  brand?: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptDocumentInvite: Document;
  activateAndNotifyEnterpriseMembership: EnterpriseMembership;
  activateApiKey: ApiKeyManagementResponse;
  activateEnterpriseMembership: EnterpriseMembership;
  activationAndVerificationStatus: Scalars['String']['output'];
  addAcceptedCategories: Supplier;
  addBasketItem: Basket;
  addBrandToFavorites: Scalars['String']['output'];
  addCategory: Category;
  addCategoryMeta: CategoryMeta;
  addCategoryToFavorites: Scalars['ID']['output'];
  addEnterpriseEmail: EnterpriseMembership;
  addMaterial: Material;
  addMaterialCategory: MaterialCategory;
  addMaterialToFavorites: Scalars['ID']['output'];
  addMoodBoardNote: ShareBoard;
  /**
   * Adds the given object (product / useritem / proitem) image into the marked bounding box on the source image,
   * returning a new session image version. Mirrors deleteObjectFromImagePreviewSession.
   */
  addObjectToImagePreviewSession: ApplySurfaceToImageResult;
  addOutsideCategory: Category;
  addOutsideCategoryMeta: CategoryMeta;
  addProItem: ProItem;
  addProductToFavorites: Scalars['ID']['output'];
  addProducts: Array<Product>;
  addProfileToFavorites: Scalars['ID']['output'];
  addRoomElement?: Maybe<Surface>;
  addSearchDebugComment: SearchDebugComment;
  addShareDocumentFinalComment: ShareDocument;
  addSupplier?: Maybe<Supplier>;
  addSupplierToFavorites: Scalars['ID']['output'];
  addSurface: Surface;
  addSurfaceCategory: SurfaceCategory;
  addSurfaceToFavorites: Scalars['ID']['output'];
  addToFolder: Folder;
  /**
   * Upload an image as a UserItem. Optional productIds attach catalog Product lineage
   * (same fields as AI render). Only IDs that exist in the Product collection are stored.
   */
  addUserItem: UserItem;
  /** Onboarding variant of `addUserItemToNewMoodBoard`: creates a new MoodBoard page at index 0 (the first page) named "Your room" containing an existing UserItem (`userItemId`) plus a Fabric Textbox hint pointing first-time users at the Edit image AI tools. Existing pages are shifted down by one. */
  addUserItemAsFirstMoodBoard: MoodBoard;
  /** Create a new MoodBoard page in `documentId` containing an existing UserItem (`userItemId`). Used by the floorplanner Add to project flow. */
  addUserItemToNewMoodBoard: MoodBoard;
  addUserToBusinessProfile: BusinessProfile;
  adminAddCuratedItem: CuratedItem;
  adminAddExampleImage: ExampleImage;
  /** Persist a proposed footprint SVG (from preview) as the active generated symbol. */
  adminApplyProduct3DFootprintSvg: Product3DAsset;
  /**
   * Automatically regenerate and persist the 2D footprint for a Product3D asset.
   * Image-sourced (runware): reuse stored TOP when present (else generate TOP from
   * source photo) → Nano Banana → Recraft → SVGO optimize. Uploaded GLB: classic
   * mesh silhouette. Applies immediately (no preview). On Nano Banana failure,
   * keeps the mesh SVG when available.
   */
  adminAutoApplyProduct3DFootprint: Product3DAsset;
  adminCleanUnusedImages: Scalars['String']['output'];
  adminCleanUnusedMoodboardImages: MoodboardImageCleanupResult;
  /**
   * Run Claude, Gemini, and GPT vision SVG writers on the same TOP cutout.
   * Candidates that fail still return with an error; others remain usable.
   * Pair with adminApplyProduct3DFootprintSvg to persist a chosen SVG.
   * Each compare run is also saved to product3DFootprintSvgLogs.
   */
  adminCompareProduct3DFootprintModels: Product3DFootprintModelCompare;
  adminDeleteFloorplannerPublic3DAsset: Scalars['Boolean']['output'];
  adminDeleteFloorplannerSymbol3DDefault: Scalars['Boolean']['output'];
  adminDeleteParserService: Scalars['String']['output'];
  adminDeleteProduct3DAsset: Scalars['Boolean']['output'];
  adminExecuteParserServiceAction: Supplier;
  /**
   * Force-fail a stuck processing community model. Stops the worker from
   * reclaiming it, releases reserved AI credits, and records an admin reason.
   */
  adminFailCommunityUserModel3D: UserModel3D;
  adminFailProduct3DAsset: Product3DAsset;
  adminGenerateProduct3DAsset: Product3DAsset;
  /**
   * SVGO path packing on the stored community 2D symbol (no mesh re-trace).
   * Safe to run after mesh regenerate or on any existing footprintSvg.
   */
  adminOptimizeCommunityUserModel3DFootprint: UserModel3D;
  /**
   * Preview SVGO path packing for the stored footprint SVG (does not persist).
   * Pair with adminApplyProduct3DFootprintSvg so admins can keep old or use new.
   */
  adminOptimizeProduct3DFootprintSvg: Product3DFootprintOptimizeResult;
  adminParserServiceStartAll: Scalars['String']['output'];
  /**
   * Build a new 2D footprint without writing it.
   * Pair with adminApplyProduct3DFootprintSvg so admins can keep old or use new.
   * For TOP_DOWN_NANO_BANANA_RECRAFT, pass lineArtCustomPrompt to re-run Nano
   * Banana with extra instructions (same TOP, simpler line art).
   */
  adminPreviewProduct3DFootprintRegeneration: Product3DFootprintRegenerationPreview;
  /**
   * Preview (and optionally regenerate) the orthographic TOP cutout used as
   * Nano Banana / Recraft input. Regeneration uses OpenRouter
   * google/gemini-2.5-flash-image with the straight-from-above footprint prompt.
   * Pass simplifiedArchitecture=true to re-render a low-detail plan when the
   * first TOP is too ornate. Persists new TOP images on the product when generated.
   */
  adminPreviewProduct3DTopImage: Product3DTopImagePreview;
  adminPublishCuratedSet: CuratedSet;
  adminPublishProduct3DAsset: Product3DAsset;
  adminRegenerateCommunityUserModel3DFootprint: UserModel3D;
  /**
   * Render an orthographic top-down PNG from the optimized GLB (same software
   * path as thumbnails), then Nano Banana → Recraft → SVGO. No product photo.
   */
  adminRegenerateCommunityUserModel3DFootprintNanoBanana: UserModel3D;
  adminRegenerateProduct3DFootprint: Product3DAsset;
  adminRegenerateProductFeatures: Product;
  adminRemoveCuratedItem: Scalars['Boolean']['output'];
  adminRemoveExampleImage: Scalars['ID']['output'];
  adminReplaceCuratedItems: CuratedSet;
  adminResetPassword: Scalars['String']['output'];
  adminRetryProduct3DAsset: Product3DAsset;
  adminSeedCuratedSet: CuratedSet;
  adminSetCommunityUserModel3DListing: UserModel3D;
  adminStartParserService: Scalars['String']['output'];
  adminTranslate: TranslationResponse;
  adminUnpublishProduct3DAsset: Product3DAsset;
  adminUpdateCommunityUserModel3DMetadata: UserModel3D;
  adminUpdateExampleImage: ExampleImage;
  adminUpdateProduct3DAsset: Product3DAsset;
  adminUploadFloorplannerPublic3DAsset: UserModel3D;
  adminUploadProduct3DAsset: Product3DAsset;
  adminUploadProduct3DFootprint: Product3DAsset;
  adminUpsertCuratedSet: CuratedSet;
  adminUpsertFloorplannerSymbol3DDefault: FloorplannerSymbol3DDefault;
  adminVerifyUser: User;
  applySurfaceToImage: ApplySurfaceToImageResult;
  applySurfaceToSessionImage: ApplySurfaceToImageResult;
  /** Approve a product's AI categorization, removing it from the review queue (Admin only) */
  approveProductCategorization: CategorizationResult;
  archiveUserItemTag: UserItemTag;
  /**
   * Support chatbot: answers from curated help articles via OpenRouter,
   * or returns top product-library matches for catalog questions.
   * Persists turns for admin review. Requires authentication.
   */
  askSupportBot: SupportChatReply;
  /**
   * Admin: bake a seamless tileable material texture from a Flooring or Wallpaper
   * product photo (Replicate Flux), upload to S3, and store it on
   * aiGeneratedImages with angle MATERIAL for floorplanner surface apply.
   * sourceImageUrl optional — defaults to images[0].
   */
  bakeProductMaterialTexture: ProductAiImage;
  /**
   * Admin: bake a seamless tileable PBR albedo from a Surface photo (Replicate),
   * upload to S3, and store it at images[0] for floorplanner catalog textures.
   * sourceImageUrl optional — defaults to images[2] (original) else images[0].
   */
  bakeSurfaceAlbedo: Surface;
  /** Start a batch categorization job (Admin/Parser only) */
  batchCategorizeProducts: BatchCategorizationJob;
  /** Cancel a running batch job (Admin/Parser only) */
  cancelBatchCategorization: BatchCategorizationJob;
  cancelBrandOrder: BrandOrder;
  cancelFloorplanImageImport: FloorplanImageImport;
  cancelReindexJob: Scalars['Boolean']['output'];
  /** Categorize a single product by ID (Admin/Parser only) */
  categorizeProduct: CategorizationResult;
  changeDocumentCurrency: Document;
  changeDocumentName: Document;
  checkoutBasketToDraftOrder: ParentOrder;
  claimFloorplanEditor: FloorplanCollabState;
  cleanupUnusedMoodboardImage: Scalars['Boolean']['output'];
  clearBasket: Basket;
  /** Clear categorization data for products (Admin/Parser only) */
  clearProductCategorization: Scalars['Int']['output'];
  clearVectorSearchData: MigrationResponse;
  combineImagesWithAI: UserItem;
  compareDebugSessions: ComparisonResult;
  confirmBrandOrder: BrandOrder;
  confirmOrder: Order;
  copyDocument: Document;
  copyExampleImageToUserItem: UserItem;
  /**
   * Duplicate a page (MoodBoard). By default copies into the same project.
   * Pass targetDocumentId to copy the page into another project the user can edit.
   * Canvas content is copied; project price-list customizations are not.
   */
  copyMoodboard: MoodBoard;
  createBrand: Brand;
  createBrandOrder: BrandOrder;
  createBrandProduct: BrandProduct;
  createBrandReplacement: BrandReplacement;
  createBusinessApplication: BusinessApplication;
  createBusinessProfile: BusinessProfile;
  createCheckoutSession: Scalars['String']['output'];
  /**
   * Creates a Stripe Checkout Session (mode=payment) for a one-time AI credit
   * top-up pack. Returns the hosted checkout URL the client should redirect to.
   */
  createCreditTopupCheckoutSession: Scalars['String']['output'];
  createDocument: Document;
  createEmbeddingProvider: EmbeddingProvidersResponse;
  createEnterprise: Enterprise;
  createFolder: Folder;
  createIndexVersion: IndexVersionDetail;
  createMoodBoard: MoodBoard;
  createOrder: Order;
  createOrderAccessLink: Scalars['String']['output'];
  createOrderFromForm: Order;
  createOrderItem: OrderItem;
  createParentOrder: ParentOrder;
  createProfile: Profile;
  createReplacementList: ReplacementListResponse;
  createRerankerProvider: RerankerProvidersResponse;
  createSearchDebugHistory: SearchDebugHistory;
  createShareDocument?: Maybe<ShareDocument>;
  createTemplateMoodBoard: GalleryBoard;
  createUserItemTag: UserItemTag;
  createValidateLink: User;
  createVectorProfile: VectorProfileResponse;
  cropImage: Scalars['String']['output'];
  cropProductImage: Scalars['String']['output'];
  deactivateApiKey: ApiKeyManagementResponse;
  deactivateEnterpriseMembership: EnterpriseMembership;
  deleteAllRoomElements?: Maybe<Surface>;
  deleteBrand: Scalars['ID']['output'];
  deleteBrandOrder: Scalars['Boolean']['output'];
  deleteBrandProduct: Scalars['ID']['output'];
  deleteBrandReplacement?: Maybe<BrandReplacement>;
  deleteDocument: Document;
  deleteEmbeddingProvider: Scalars['Boolean']['output'];
  deleteEnterprise: Enterprise;
  deleteEnterpriseMembership: EnterpriseMembership;
  deleteFloorplan: Floorplan;
  deleteFloorplanBackdropImage: Scalars['Boolean']['output'];
  deleteFolder: Folder;
  deleteGalleryBoard: GalleryBoard;
  deleteImage: Scalars['ID']['output'];
  deleteIndexVersion: Scalars['Boolean']['output'];
  deleteMaterial: Scalars['ID']['output'];
  deleteMoodBoard: MoodBoard;
  deleteNews: Scalars['ID']['output'];
  deleteObjectFromImage: DeleteObjectFromImageResult;
  /** Removes the labeled object from the image. Returns imageUrl only (no UserItem). Use addUserItem with this URL to persist. */
  deleteObjectFromImagePreview: TransformImageWithPromptResult;
  deleteObjectFromImagePreviewSession: AiImageEditSessionResult;
  deleteOrder: Scalars['Boolean']['output'];
  deleteOrderItem: Scalars['Boolean']['output'];
  deleteParentOrder: Scalars['Boolean']['output'];
  deleteProduct: Scalars['ID']['output'];
  deleteProfile: Scalars['ID']['output'];
  deleteReplacementList: Scalars['Boolean']['output'];
  deleteRerankerProvider: Scalars['Boolean']['output'];
  deleteSearchDebugHistory: Scalars['Boolean']['output'];
  deleteSupplier: Scalars['ID']['output'];
  deleteSurface: Scalars['ID']['output'];
  deleteUserModel3D: Scalars['Boolean']['output'];
  deleteVectorProfile: Scalars['Boolean']['output'];
  designerUpdateOrder: BrandOrder;
  editFloorplan: Floorplan;
  editFolder: Folder;
  editImageWithAI: EditImageWithAiResult;
  editImageWithAISession: EditImageWithAiSessionResult;
  editMaterial: Material;
  editMaterialCategory: MaterialCategory;
  editMoodBoard: MoodBoard;
  editProItem: ProItem;
  editProduct: Product;
  editProducts?: Maybe<Array<Maybe<Product>>>;
  editProfile: Profile;
  editSupplier?: Maybe<Supplier>;
  editSurface: Surface;
  editSurfaceCategory: SurfaceCategory;
  editUser?: Maybe<User>;
  fixProductImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fixUserAndProItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flagProducts?: Maybe<Array<Maybe<Product>>>;
  forgotPassword: Scalars['String']['output'];
  /**
   * Queue image-to-video generation. Returns immediately with a job id; poll
   * `aiVideoJob` until COMPLETED or FAILED. Charges 5 AI credits on success.
   * Provide exactly one of moodBoardId or imageUrl.
   */
  generateAiVideo: GenerateAiVideoResult;
  generateProItemAngle: ProItemAiImage;
  generateProductAngle: ProductAiImage;
  generateShareToken: Scalars['String']['output'];
  generateUserItemAngle: UserItemAiImage;
  generateUserModel3DFromImage: UserModel3D;
  /** Extend the lock TTL. Call periodically while editing (e.g. every 5–10 min). Fails if you are not the locker. */
  heartbeatMoodBoardLock: MoodBoard;
  hideProduct: Product;
  hideProducts?: Maybe<Array<Maybe<Product>>>;
  inviteUserToDocument: InviteResult;
  likeGalleryBoard: GalleryBoard;
  lockDocument: Document;
  lockMoodBoard: MoodBoard;
  /**
   * Persists a failed floorplan AI render to AIRenderLog when the client never
   * reached renderFloorplanSceneWithAI (for example HTTP 413). No image upload.
   */
  logFloorplanAiRenderError: Scalars['Boolean']['output'];
  logLinkAction: LinkAccessLog;
  login?: Maybe<Session>;
  logout: Scalars['Boolean']['output'];
  magicGrab: MagicGrabResult;
  markFloorplanImageImportApplied: FloorplanImageImport;
  markNewsSeen: User;
  migrateVectorIds: MigrationResponse;
  moveBoardInDocument: Document;
  pauseReindexJob: Scalars['Boolean']['output'];
  projectiveImage: Scalars['String']['output'];
  provideFloorplanImageImportCalibration: FloorplanImageImport;
  publishMoodBoard: GalleryBoard;
  publishNews: News;
  rebuildBrandCache: BrandCacheRebuildResponse;
  /** Re-categorize all products from a supplier (Admin/Parser only) */
  recategorizeSupplierProducts: BatchCategorizationJob;
  recheckFloorplanImageImportRegion: FloorplanImageImport;
  refreshTokens: TokensResponse;
  releaseFloorplanEditor: Scalars['Boolean']['output'];
  removeAcceptedCategories: Supplier;
  removeBasketItem: Basket;
  removeBrandFromFavorites: Scalars['String']['output'];
  removeCategory?: Maybe<Scalars['Boolean']['output']>;
  removeCategoryFromFavorites: Scalars['ID']['output'];
  removeCategoryMeta?: Maybe<Scalars['Boolean']['output']>;
  removeDocumentMember: Document;
  removeEnterpriseMembership: EnterpriseMembership;
  removeFromFolder: Folder;
  removeMaterialCategory?: Maybe<Scalars['Boolean']['output']>;
  removeMaterialFromFavorites: Scalars['ID']['output'];
  removeProItem: Scalars['ID']['output'];
  removeProItemAiGeneratedImage: ProItem;
  removeProItemBackground: Array<Maybe<Scalars['ID']['output']>>;
  removeProductBackground?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  removeProductFromFavorites: Scalars['ID']['output'];
  removeProfileFromFavorites: Scalars['ID']['output'];
  removeSupplierFromFavorites: Scalars['ID']['output'];
  removeSurfaceCategory?: Maybe<Scalars['Boolean']['output']>;
  removeSurfaceFromFavorites: Scalars['ID']['output'];
  removeUploadedBackgroundImage?: Maybe<Scalars['Boolean']['output']>;
  removeUserFromBusinessProfile: BusinessProfile;
  removeUserItem?: Maybe<Scalars['Boolean']['output']>;
  removeUserItemAiGeneratedImage: UserItem;
  removeUserItemBackground: Array<Maybe<Scalars['ID']['output']>>;
  renameUserItem: UserItem;
  renameUserItemTag: UserItemTag;
  renameUserModel3D: UserModel3D;
  renderFloorplanSceneWithAI: FloorplanSceneRenderResult;
  renderImageWithAI: UserItem;
  reorderMoodBoardInDocument: Document;
  resetPassword: Scalars['String']['output'];
  resumeReindexJob: Scalars['Boolean']['output'];
  retryFloorplanImageImport: FloorplanImageImport;
  retryFloorplanImageImportStage: FloorplanImageImport;
  retryUserModel3DGeneration: UserModel3D;
  reviewBusinessApplication: BusinessApplication;
  reviewBusinessProfile: BusinessProfile;
  revokeDocumentInvite: Document;
  revokeLinkAccess: Scalars['Boolean']['output'];
  saveBoardSetting: BoardSetting;
  /** When currency is provided, returned moodboard product prices (products[].product.price) match documentById(currency). Editing is exclusive via lock; no conflict check. */
  saveMoodboard: MoodBoard;
  savePriceListState: PriceListState;
  sendDraftOrderToSuppliers: ParentOrder;
  sendEnterpriseInvitation: EnterpriseMembership;
  sendShareDocument?: Maybe<Scalars['Boolean']['output']>;
  sendShareLink?: Maybe<Scalars['Boolean']['output']>;
  sendUserVerificationEmail: Scalars['String']['output'];
  setActiveIndex: Scalars['Boolean']['output'];
  setActiveVectorProfile: VectorProfileResponse;
  /**
   * Hide or show a page in Presentation view (PowerPoint-style).
   * Does not mutate existing ShareDocument snapshots.
   */
  setMoodBoardHiddenFromPresentation: MoodBoard;
  setPersonalisationUsageType: Personalisation;
  /**
   * Set the AI category scope for a supplier (Admin only)
   * Limits the category tree used for AI categorization of this supplier's products.
   */
  setSupplierAICategories: Supplier;
  shareFloorplan: Floorplan;
  signup?: Maybe<User>;
  startFloorplanImageImport: FloorplanImageImport;
  startProfileReindex: ReindexJobResponse;
  startReindexJob: ReindexJobResponse;
  submitSupplierResponse: Order;
  /** Forcefully take over the board lock even if another user currently holds it. */
  takeOverLock: MoodBoard;
  testReindexWorker: TestReindexResponse;
  testSearchPipeline: SearchTestResponse;
  trackLinkAccess: LinkAccess;
  trackSuggestionInteraction: Scalars['Boolean']['output'];
  unFlagProducts?: Maybe<Array<Maybe<Product>>>;
  unLikeGalleryBoard: GalleryBoard;
  unlockDocument: Document;
  unlockMoodBoard: MoodBoard;
  unshareFloorplan: Floorplan;
  updateApiKeyRateLimit: ApiKeyManagementResponse;
  updateBasketItem: Basket;
  updateBrand: Brand;
  updateBrandOrder: BrandOrder;
  updateBrandProduct: BrandProduct;
  updateBrandReplacement?: Maybe<BrandReplacement>;
  updateBusinessProfile: BusinessProfile;
  updateDocumentMemberRole: Document;
  updateEmbeddingProvider: EmbeddingProvidersResponse;
  updateEnterprise: Enterprise;
  updateFloorplanImageImportReview: FloorplanImageImport;
  updateOrder: Order;
  updateOrderItem: OrderItem;
  updateOrderReadStatus: BrandOrder;
  updateOrderWithBrand: Order;
  updateParentOrder: ParentOrder;
  updatePaymentDetails: Scalars['String']['output'];
  updateProductEmbedding: UpdateProductEmbeddingResponse;
  updateReplacementList: ReplacementListResponse;
  updateRerankerProvider: RerankerProvidersResponse;
  updateSearchDebugHistory: SearchDebugHistory;
  updateSetupStatus: Scalars['String']['output'];
  updateShareDocumentCheckedNotes: ShareDocumentListItem;
  updateShareDocumentPriceListSelection: ShareDocument;
  updateUserItemTags: UserItem;
  /**
   * Owner edit for library metadata: name, plan dimensions in metres,
   * and optional standard floorplanner 2D symbol key.
   * Pass architectureSymbolKey as empty to restore the generated footprint.
   */
  updateUserModel3D: UserModel3D;
  updateVectorProfile: VectorProfileResponse;
  uploadFloorplanBackdropImage: Scalars['String']['output'];
  uploadProducts?: Maybe<Scalars['String']['output']>;
  uploadRemovedBackgroundImage?: Maybe<Scalars['String']['output']>;
  uploadUserModel3D: UserModel3D;
  uploadUserModel3DThumbnail: UserModel3D;
  /**
   * AI upscale: uploads a new high-resolution image and appends an `aiGeneratedImages` row
   * tagged UPSCALE. `imageUrl` must match an existing AI row or a library `images[]` URL on
   * the item. Requires the same AI keys as edit-image flows.
   */
  upscaleAiGeneratedImage: UpscaleAiGeneratedImageResult;
  userCounterUpdate: User;
  validateSession?: Maybe<ValidateSession>;
  validateUser?: Maybe<Session>;
  waitlistEnterpriseMembership: EnterpriseMembership;
};


export type MutationAcceptDocumentInviteArgs = {
  inviteId: Scalars['String']['input'];
};


export type MutationActivateAndNotifyEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationActivateApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


export type MutationActivateEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationActivationAndVerificationStatusArgs = {
  input?: InputMaybe<ActivationAndVerificationStatusInput>;
};


export type MutationAddAcceptedCategoriesArgs = {
  category: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationAddBasketItemArgs = {
  input: AddBasketItemInput;
};


export type MutationAddBrandToFavoritesArgs = {
  name: Scalars['String']['input'];
};


export type MutationAddCategoryArgs = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCategoryMetaArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCategoryToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddEnterpriseEmailArgs = {
  email: Scalars['String']['input'];
  enterpriseId: Scalars['ID']['input'];
  sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddMaterialArgs = {
  input: MaterialInput;
};


export type MutationAddMaterialCategoryArgs = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddMaterialToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddMoodBoardNoteArgs = {
  message: Scalars['String']['input'];
  moodBoardId: Scalars['String']['input'];
  shareBoardId?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};


export type MutationAddObjectToImagePreviewSessionArgs = {
  boundingBox: BoundingBoxInput;
  imageUrl: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  objectId: Scalars['ID']['input'];
  objectImageUrl?: InputMaybe<Scalars['String']['input']>;
  objectType: Scalars['String']['input'];
  operation: AddObjectOperation;
  userItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddOutsideCategoryArgs = {
  input?: InputMaybe<CategoryInput>;
};


export type MutationAddOutsideCategoryMetaArgs = {
  input?: InputMaybe<CategoryInput>;
};


export type MutationAddProItemArgs = {
  input: ProItemInput;
};


export type MutationAddProductToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddProductsArgs = {
  input: ProductsInput;
};


export type MutationAddProfileToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddRoomElementArgs = {
  input?: InputMaybe<RoomElementsMutationInput>;
};


export type MutationAddSearchDebugCommentArgs = {
  input: AddSearchDebugCommentInput;
};


export type MutationAddShareDocumentFinalCommentArgs = {
  message: Scalars['String']['input'];
  shareDocumentId: Scalars['String']['input'];
  user: Scalars['String']['input'];
};


export type MutationAddSupplierArgs = {
  input: SupplierInput;
};


export type MutationAddSupplierToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddSurfaceArgs = {
  input: SurfaceInput;
};


export type MutationAddSurfaceCategoryArgs = {
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSurfaceToFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddToFolderArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  galleryBoardId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  materialId?: InputMaybe<Scalars['String']['input']>;
  proItemId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  surfaceId?: InputMaybe<Scalars['String']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddUserItemArgs = {
  image: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBG?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddUserItemAsFirstMoodBoardArgs = {
  documentId: Scalars['ID']['input'];
  userItemId: Scalars['ID']['input'];
};


export type MutationAddUserItemToNewMoodBoardArgs = {
  documentId: Scalars['ID']['input'];
  userItemId: Scalars['ID']['input'];
};


export type MutationAddUserToBusinessProfileArgs = {
  businessProfileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminAddCuratedItemArgs = {
  key: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAdminAddExampleImageArgs = {
  input: AdminAddExampleImageInput;
};


export type MutationAdminApplyProduct3DFootprintSvgArgs = {
  footprintSvg: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminAutoApplyProduct3DFootprintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminCleanUnusedMoodboardImagesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  gracePeriodHours?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminCompareProduct3DFootprintModelsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteFloorplannerPublic3DAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminDeleteFloorplannerSymbol3DDefaultArgs = {
  symbolKey: Scalars['String']['input'];
};


export type MutationAdminDeleteParserServiceArgs = {
  serviceArn: Scalars['String']['input'];
};


export type MutationAdminDeleteProduct3DAssetArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAdminExecuteParserServiceActionArgs = {
  action: Scalars['String']['input'];
  serviceUrl: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type MutationAdminFailCommunityUserModel3DArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminFailProduct3DAssetArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminGenerateProduct3DAssetArgs = {
  productId: Scalars['ID']['input'];
  quality?: Product3DGenerationQuality;
  sourceImageUrl: Scalars['String']['input'];
};


export type MutationAdminOptimizeCommunityUserModel3DFootprintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminOptimizeProduct3DFootprintSvgArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminPreviewProduct3DFootprintRegenerationArgs = {
  id: Scalars['ID']['input'];
  lineArtCustomPrompt?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Product3DFootprintRegenerationMethod>;
};


export type MutationAdminPreviewProduct3DTopImageArgs = {
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  forceRegenerate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  simplifiedArchitecture?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminPublishCuratedSetArgs = {
  key: Scalars['String']['input'];
};


export type MutationAdminPublishProduct3DAssetArgs = {
  dimension?: InputMaybe<Product3DDimensionInput>;
  footprint?: InputMaybe<Product3DFootprintInput>;
  id: Scalars['ID']['input'];
  placement: Product3DPlacementInput;
};


export type MutationAdminRegenerateCommunityUserModel3DFootprintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRegenerateCommunityUserModel3DFootprintNanoBananaArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRegenerateProduct3DFootprintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRegenerateProductFeaturesArgs = {
  productId: Scalars['String']['input'];
};


export type MutationAdminRemoveCuratedItemArgs = {
  key: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};


export type MutationAdminRemoveExampleImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminReplaceCuratedItemsArgs = {
  items: Array<CuratedItemInput>;
  key: Scalars['String']['input'];
};


export type MutationAdminResetPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminRetryProduct3DAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminSeedCuratedSetArgs = {
  input: CuratedSeedInput;
};


export type MutationAdminSetCommunityUserModel3DListingArgs = {
  id: Scalars['ID']['input'];
  listed: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminStartParserServiceArgs = {
  supplierId: Scalars['String']['input'];
};


export type MutationAdminTranslateArgs = {
  input: TranslationInput;
};


export type MutationAdminUnpublishProduct3DAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminUpdateCommunityUserModel3DMetadataArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationAdminUpdateExampleImageArgs = {
  input: AdminUpdateExampleImageInput;
};


export type MutationAdminUpdateProduct3DAssetArgs = {
  dimension?: InputMaybe<Product3DDimensionInput>;
  footprint?: InputMaybe<Product3DFootprintInput>;
  id: Scalars['ID']['input'];
  placement: Product3DPlacementInput;
};


export type MutationAdminUploadFloorplannerPublic3DAssetArgs = {
  model: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUploadProduct3DAssetArgs = {
  model: Scalars['Upload']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAdminUploadProduct3DFootprintArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAdminUpsertCuratedSetArgs = {
  input: CuratedSetInput;
};


export type MutationAdminUpsertFloorplannerSymbol3DDefaultArgs = {
  input: FloorplannerSymbol3DDefaultInput;
};


export type MutationAdminVerifyUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationApplySurfaceToImageArgs = {
  boundingBox?: InputMaybe<BoundingBoxInput>;
  imageUrl: Scalars['String']['input'];
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  productCategory?: InputMaybe<Scalars['String']['input']>;
  productImageUrl?: InputMaybe<Scalars['String']['input']>;
  redStrokeUrl?: InputMaybe<Scalars['String']['input']>;
  surfaceId: Scalars['String']['input'];
  surfaceType: ApplySurfaceSourceType;
  userItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationApplySurfaceToSessionImageArgs = {
  boundingBox?: InputMaybe<BoundingBoxInput>;
  imageUrl: Scalars['String']['input'];
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  productCategory?: InputMaybe<Scalars['String']['input']>;
  productImageUrl?: InputMaybe<Scalars['String']['input']>;
  redStrokeUrl?: InputMaybe<Scalars['String']['input']>;
  surfaceId: Scalars['String']['input'];
  surfaceType: ApplySurfaceSourceType;
  userItemId: Scalars['ID']['input'];
};


export type MutationApproveProductCategorizationArgs = {
  productId: Scalars['ID']['input'];
};


export type MutationArchiveUserItemTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAskSupportBotArgs = {
  messages: Array<SupportChatMessageInput>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBakeProductMaterialTextureArgs = {
  productId: Scalars['ID']['input'];
  sourceImageUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBakeSurfaceAlbedoArgs = {
  sourceImageUrl?: InputMaybe<Scalars['String']['input']>;
  surfaceId: Scalars['ID']['input'];
};


export type MutationBatchCategorizeProductsArgs = {
  input: BatchCategorizationInput;
};


export type MutationCancelBatchCategorizationArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCancelBrandOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelFloorplanImageImportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelReindexJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCategorizeProductArgs = {
  input: CategorizeProductInput;
};


export type MutationChangeDocumentCurrencyArgs = {
  currency: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};


export type MutationChangeDocumentNameArgs = {
  documentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCheckoutBasketToDraftOrderArgs = {
  input: CheckoutBasketInput;
};


export type MutationClaimFloorplanEditorArgs = {
  floorplanId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCleanupUnusedMoodboardImageArgs = {
  imageUrl: Scalars['String']['input'];
  moodboardId: Scalars['ID']['input'];
};


export type MutationClearProductCategorizationArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCombineImagesWithAiArgs = {
  baseItemId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl1: Scalars['String']['input'];
  imageUrl2: Scalars['String']['input'];
  item1: Scalars['ID']['input'];
  item1Type: Scalars['String']['input'];
  item2: Scalars['ID']['input'];
  item2Type: Scalars['String']['input'];
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompareDebugSessionsArgs = {
  sessionId1: Scalars['ID']['input'];
  sessionId2: Scalars['ID']['input'];
};


export type MutationConfirmBrandOrderArgs = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationCopyExampleImageToUserItemArgs = {
  exampleImageId: Scalars['ID']['input'];
};


export type MutationCopyMoodboardArgs = {
  id: Scalars['String']['input'];
  targetDocumentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBrandArgs = {
  input: BrandInput;
};


export type MutationCreateBrandOrderArgs = {
  input: CreateBrandOrderInput;
};


export type MutationCreateBrandProductArgs = {
  input: BrandProductInput;
};


export type MutationCreateBrandReplacementArgs = {
  input: CreateBrandReplacementInput;
};


export type MutationCreateBusinessApplicationArgs = {
  input: CreateBusinessApplicationInput;
};


export type MutationCreateBusinessProfileArgs = {
  input: CreateBusinessProfileInput;
};


export type MutationCreateCheckoutSessionArgs = {
  trial: Scalars['Int']['input'];
  type: PaymentSubscriptionType;
};


export type MutationCreateCreditTopupCheckoutSessionArgs = {
  packId: Scalars['String']['input'];
};


export type MutationCreateEmbeddingProviderArgs = {
  input: EmbeddingProviderInput;
};


export type MutationCreateEnterpriseArgs = {
  input: CreateEnterpriseInput;
};


export type MutationCreateFolderArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateIndexVersionArgs = {
  name: Scalars['String']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationCreateMoodBoardArgs = {
  documentId: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateOrderAccessLinkArgs = {
  brandName: Scalars['String']['input'];
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  maxAccessCount?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationCreateOrderFromFormArgs = {
  input: OrderInput;
};


export type MutationCreateOrderItemArgs = {
  input: CreateOrderItemInput;
};


export type MutationCreateParentOrderArgs = {
  input: CreateParentOrderInput;
};


export type MutationCreateProfileArgs = {
  input: ProfileInput;
};


export type MutationCreateReplacementListArgs = {
  input: ReplacementListInput;
};


export type MutationCreateRerankerProviderArgs = {
  input: RerankerProviderInput;
};


export type MutationCreateSearchDebugHistoryArgs = {
  input: CreateSearchDebugHistoryInput;
};


export type MutationCreateShareDocumentArgs = {
  documentId: Scalars['String']['input'];
  hideMoodBoards?: InputMaybe<Scalars['Boolean']['input']>;
  hideProductList?: InputMaybe<Scalars['Boolean']['input']>;
  moodBoardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  proSettings?: InputMaybe<BoardProSettingsInput>;
};


export type MutationCreateTemplateMoodBoardArgs = {
  image: Scalars['Upload']['input'];
  moodBoardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUserItemTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateValidateLinkArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreateVectorProfileArgs = {
  input: VectorProfileInput;
};


export type MutationCropImageArgs = {
  crop: CropInput;
  image: Scalars['String']['input'];
  oldImage: Scalars['String']['input'];
};


export type MutationCropProductImageArgs = {
  input: CropProductImageInput;
};


export type MutationDeactivateApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


export type MutationDeactivateEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationDeleteAllRoomElementsArgs = {
  surfaceId: Scalars['String']['input'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandReplacementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmbeddingProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnterpriseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationDeleteFloorplanArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFloorplanBackdropImageArgs = {
  floorplanId: Scalars['ID']['input'];
  imageUrl: Scalars['String']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteGalleryBoardArgs = {
  galleryBoardId: Scalars['String']['input'];
};


export type MutationDeleteImageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIndexVersionArgs = {
  indexName: Scalars['String']['input'];
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMoodBoardArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNewsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteObjectFromImageArgs = {
  boundingBox?: InputMaybe<BoundingBoxInput>;
  imageUrl: Scalars['String']['input'];
  objectLabel: Scalars['String']['input'];
};


export type MutationDeleteObjectFromImagePreviewArgs = {
  boundingBox?: InputMaybe<BoundingBoxInput>;
  imageUrl: Scalars['String']['input'];
  objectLabel: Scalars['String']['input'];
};


export type MutationDeleteObjectFromImagePreviewSessionArgs = {
  boundingBox?: InputMaybe<BoundingBoxInput>;
  imageUrl: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  objectLabel: Scalars['String']['input'];
  userItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteParentOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReplacementListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRerankerProviderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSearchDebugHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSurfaceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserModel3DArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVectorProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDesignerUpdateOrderArgs = {
  id: Scalars['ID']['input'];
  input: DesignerOrderUpdateInput;
};


export type MutationEditFloorplanArgs = {
  input?: InputMaybe<FloorplanEditInput>;
};


export type MutationEditFolderArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationEditImageWithAiArgs = {
  imageUrl: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
};


export type MutationEditImageWithAiSessionArgs = {
  imageUrl: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['ID']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
  prompt: Scalars['String']['input'];
  userItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationEditMaterialArgs = {
  input: MaterialEditInput;
};


export type MutationEditMaterialCategoryArgs = {
  input?: InputMaybe<MaterialCategoryInput>;
};


export type MutationEditMoodBoardArgs = {
  input: MoodBoardEditInput;
};


export type MutationEditProItemArgs = {
  input: ProItemEditInput;
};


export type MutationEditProductArgs = {
  input: ProductEditInput;
};


export type MutationEditProductsArgs = {
  categories: Array<InputMaybe<Scalars['String']['input']>>;
  lock?: InputMaybe<Scalars['Boolean']['input']>;
  products: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationEditProfileArgs = {
  id: Scalars['ID']['input'];
  input: ProfileInput;
};


export type MutationEditSupplierArgs = {
  input: EditSupplierInput;
};


export type MutationEditSurfaceArgs = {
  input: SurfaceEditInput;
};


export type MutationEditSurfaceCategoryArgs = {
  input?: InputMaybe<SurfaceCategoryInput>;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationFixProductImagesArgs = {
  productId: Scalars['String']['input'];
};


export type MutationFixUserAndProItemsArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationFlagProductsArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateAiVideoArgs = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  moodBoardId?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateProItemAngleArgs = {
  angle: ProductAngle;
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
  proItemId: Scalars['ID']['input'];
  sourceImageUrl: Scalars['String']['input'];
};


export type MutationGenerateProductAngleArgs = {
  angle: ProductAngle;
  productId: Scalars['ID']['input'];
  sourceImageUrl: Scalars['String']['input'];
};


export type MutationGenerateShareTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateUserItemAngleArgs = {
  angle: ProductAngle;
  moodboardId: Scalars['ID']['input'];
  sourceImageUrl: Scalars['String']['input'];
  userItemId: Scalars['ID']['input'];
};


export type MutationGenerateUserModel3DFromImageArgs = {
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  shareWithCommunity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationHeartbeatMoodBoardLockArgs = {
  moodBoardId: Scalars['ID']['input'];
};


export type MutationHideProductArgs = {
  isHidden: Scalars['Boolean']['input'];
  productId: Scalars['String']['input'];
};


export type MutationHideProductsArgs = {
  isHidden: Scalars['Boolean']['input'];
  productIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationInviteUserToDocumentArgs = {
  documentId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  role: DocumentRole;
};


export type MutationLikeGalleryBoardArgs = {
  galleryBoardId: Scalars['String']['input'];
};


export type MutationLockDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationLockMoodBoardArgs = {
  moodBoardId: Scalars['ID']['input'];
};


export type MutationLogFloorplanAiRenderErrorArgs = {
  input: LogFloorplanAiRenderErrorInput;
};


export type MutationLogLinkActionArgs = {
  action: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  scope: AuthScope;
};


export type MutationMagicGrabArgs = {
  action?: InputMaybe<MagicGrabAction>;
  boundingBox?: InputMaybe<BoundingBoxInput>;
  displayHeight?: InputMaybe<Scalars['Float']['input']>;
  displayWidth?: InputMaybe<Scalars['Float']['input']>;
  imageUrl: Scalars['String']['input'];
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationMarkFloorplanImageImportAppliedArgs = {
  excludedEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationMoveBoardInDocumentArgs = {
  documentId: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  moodboardId: Scalars['String']['input'];
  moveUp: Scalars['Boolean']['input'];
};


export type MutationPauseReindexJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationProjectiveImageArgs = {
  cornerPoints: Array<Scalars['Float']['input']>;
  offSetX: Scalars['Float']['input'];
  offSetY: Scalars['Float']['input'];
  oldTransImage: Scalars['String']['input'];
  scaleFactor: Scalars['Float']['input'];
  sourceImage: Scalars['String']['input'];
  xRepeat?: InputMaybe<Scalars['Int']['input']>;
  yRepeat?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProvideFloorplanImageImportCalibrationArgs = {
  calibration: FloorplanImportCalibrationInput;
  id: Scalars['ID']['input'];
};


export type MutationPublishMoodBoardArgs = {
  image: Scalars['Upload']['input'];
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  moodBoardId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationPublishNewsArgs = {
  input: PublishNewsInput;
};


export type MutationRecategorizeSupplierProductsArgs = {
  options?: InputMaybe<CategorizationFilterInput>;
  supplierId: Scalars['ID']['input'];
};


export type MutationRecheckFloorplanImageImportRegionArgs = {
  draftRevision: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  layer: FloorplanImportLayer;
  rect: FloorplanImportNormalizedRectInput;
};


export type MutationReleaseFloorplanEditorArgs = {
  floorplanId: Scalars['String']['input'];
};


export type MutationRemoveAcceptedCategoriesArgs = {
  category: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationRemoveBasketItemArgs = {
  itemId: Scalars['ID']['input'];
};


export type MutationRemoveBrandFromFavoritesArgs = {
  name: Scalars['String']['input'];
};


export type MutationRemoveCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type MutationRemoveCategoryFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCategoryMetaArgs = {
  categoryId: Scalars['String']['input'];
};


export type MutationRemoveDocumentMemberArgs = {
  documentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationRemoveFromFolderArgs = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  galleryBoardId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  materialId?: InputMaybe<Scalars['String']['input']>;
  proItemId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  surfaceId?: InputMaybe<Scalars['String']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMaterialCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type MutationRemoveMaterialFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProItemAiGeneratedImageArgs = {
  imageUrl: Scalars['String']['input'];
  proItemId: Scalars['ID']['input'];
};


export type MutationRemoveProItemBackgroundArgs = {
  aiGeneratedImageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sourceImageUrl?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveProductBackgroundArgs = {
  aiGeneratedImageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  imageVariant?: InputMaybe<Scalars['Int']['input']>;
  sourceImageUrl?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveProductFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveProfileFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveSupplierFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveSurfaceCategoryArgs = {
  categoryId: Scalars['String']['input'];
};


export type MutationRemoveSurfaceFromFavoritesArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveUploadedBackgroundImageArgs = {
  image: Scalars['String']['input'];
};


export type MutationRemoveUserFromBusinessProfileArgs = {
  businessProfileId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveUserItemAiGeneratedImageArgs = {
  imageUrl: Scalars['String']['input'];
  userItemId: Scalars['ID']['input'];
};


export type MutationRemoveUserItemBackgroundArgs = {
  aiGeneratedImageUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sourceImageUrl?: InputMaybe<Scalars['String']['input']>;
  trim?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRenameUserItemArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRenameUserItemTagArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameUserModel3DArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenderFloorplanSceneWithAiArgs = {
  input: FloorplanSceneRenderInput;
};


export type MutationRenderImageWithAiArgs = {
  model?: InputMaybe<Scalars['String']['input']>;
  moodboardId: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReorderMoodBoardInDocumentArgs = {
  documentId: Scalars['String']['input'];
  moodboardId: Scalars['String']['input'];
  toIndex: Scalars['Int']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResumeReindexJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationRetryFloorplanImageImportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryFloorplanImageImportStageArgs = {
  id: Scalars['ID']['input'];
  stage: FloorplanImageImportStage;
};


export type MutationRetryUserModel3DGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewBusinessApplicationArgs = {
  input: ReviewBusinessApplicationInput;
};


export type MutationReviewBusinessProfileArgs = {
  input: ReviewBusinessProfileInput;
};


export type MutationRevokeDocumentInviteArgs = {
  documentId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationRevokeLinkAccessArgs = {
  key: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationSaveBoardSettingArgs = {
  height: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  json: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};


export type MutationSaveMoodboardArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  json: Scalars['String']['input'];
};


export type MutationSavePriceListStateArgs = {
  documentId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationSendDraftOrderToSuppliersArgs = {
  parentOrderId: Scalars['ID']['input'];
};


export type MutationSendEnterpriseInvitationArgs = {
  membershipId: Scalars['ID']['input'];
};


export type MutationSendShareDocumentArgs = {
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type MutationSendShareLinkArgs = {
  email: Scalars['String']['input'];
  link: Scalars['String']['input'];
};


export type MutationSendUserVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSetActiveIndexArgs = {
  indexName: Scalars['String']['input'];
};


export type MutationSetActiveVectorProfileArgs = {
  profileId: Scalars['ID']['input'];
};


export type MutationSetMoodBoardHiddenFromPresentationArgs = {
  hidden: Scalars['Boolean']['input'];
  moodBoardId: Scalars['ID']['input'];
};


export type MutationSetPersonalisationUsageTypeArgs = {
  usageType: PersonalisationUsageType;
};


export type MutationSetSupplierAiCategoriesArgs = {
  rootIds: Array<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
};


export type MutationShareFloorplanArgs = {
  email: Scalars['String']['input'];
  floorplanId: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  input: UserSignupInput;
};


export type MutationStartFloorplanImageImportArgs = {
  image: Scalars['Upload']['input'];
  input: StartFloorplanImageImportInput;
};


export type MutationStartProfileReindexArgs = {
  options?: InputMaybe<ProfileReindexOptionsInput>;
  profileId: Scalars['ID']['input'];
};


export type MutationStartReindexJobArgs = {
  input: CreateReindexJobInput;
};


export type MutationSubmitSupplierResponseArgs = {
  input: SupplierResponseInput;
};


export type MutationTakeOverLockArgs = {
  moodBoardId: Scalars['ID']['input'];
};


export type MutationTestReindexWorkerArgs = {
  productLimit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTestSearchPipelineArgs = {
  includeRerank?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  profileId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type MutationTrackLinkAccessArgs = {
  accessIP?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationTrackSuggestionInteractionArgs = {
  input: TrackSuggestionInteractionInput;
};


export type MutationUnFlagProductsArgs = {
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationUnLikeGalleryBoardArgs = {
  galleryBoardId: Scalars['String']['input'];
};


export type MutationUnlockDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationUnlockMoodBoardArgs = {
  moodBoardId: Scalars['ID']['input'];
};


export type MutationUnshareFloorplanArgs = {
  floorplanId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateApiKeyRateLimitArgs = {
  apiKey: Scalars['String']['input'];
  rateLimit: ApiKeyRateLimitInput;
};


export type MutationUpdateBasketItemArgs = {
  input: UpdateBasketItemInput;
};


export type MutationUpdateBrandArgs = {
  input: BrandEditInput;
};


export type MutationUpdateBrandOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBrandOrderInput;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBrandProductArgs = {
  input: BrandProductEditInput;
};


export type MutationUpdateBrandReplacementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBrandReplacementInput;
};


export type MutationUpdateBusinessProfileArgs = {
  input: UpdateBusinessProfileInput;
};


export type MutationUpdateDocumentMemberRoleArgs = {
  documentId: Scalars['String']['input'];
  role: DocumentRole;
  userId: Scalars['String']['input'];
};


export type MutationUpdateEmbeddingProviderArgs = {
  id: Scalars['ID']['input'];
  input: EmbeddingProviderInput;
};


export type MutationUpdateEnterpriseArgs = {
  input: UpdateEnterpriseInput;
};


export type MutationUpdateFloorplanImageImportReviewArgs = {
  draftRevision: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  review: FloorplanImportReviewInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrderItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrderItemInput;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrderReadStatusArgs = {
  id: Scalars['ID']['input'];
  isDesigner: Scalars['Boolean']['input'];
};


export type MutationUpdateOrderWithBrandArgs = {
  input: UpdateOrderWithBrandInput;
};


export type MutationUpdateParentOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateParentOrderInput;
};


export type MutationUpdateProductEmbeddingArgs = {
  input: UpdateProductEmbeddingInput;
};


export type MutationUpdateReplacementListArgs = {
  id: Scalars['ID']['input'];
  input: ReplacementListInput;
};


export type MutationUpdateRerankerProviderArgs = {
  id: Scalars['ID']['input'];
  input: RerankerProviderInput;
};


export type MutationUpdateSearchDebugHistoryArgs = {
  input: UpdateSearchDebugHistoryInput;
};


export type MutationUpdateSetupStatusArgs = {
  input?: InputMaybe<UpdateSetupStatusInput>;
};


export type MutationUpdateShareDocumentCheckedNotesArgs = {
  checkedNotes: Scalars['Boolean']['input'];
  shareDocumentId: Scalars['String']['input'];
};


export type MutationUpdateShareDocumentPriceListSelectionArgs = {
  input: UpdateShareDocumentPriceListSelectionInput;
};


export type MutationUpdateUserItemTagsArgs = {
  tags: Array<Scalars['String']['input']>;
  userItemId: Scalars['ID']['input'];
};


export type MutationUpdateUserModel3DArgs = {
  architectureSymbolKey?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateVectorProfileArgs = {
  id: Scalars['ID']['input'];
  input: VectorProfileInput;
};


export type MutationUploadFloorplanBackdropImageArgs = {
  floorplanId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUploadProductsArgs = {
  input: ProductUploadInput;
};


export type MutationUploadRemovedBackgroundImageArgs = {
  image: Scalars['Upload']['input'];
  key: Scalars['String']['input'];
};


export type MutationUploadUserModel3DArgs = {
  model: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shareWithCommunity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUploadUserModel3DThumbnailArgs = {
  image: Scalars['Upload']['input'];
  modelId: Scalars['ID']['input'];
};


export type MutationUpscaleAiGeneratedImageArgs = {
  imageUrl: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
  itemType: Scalars['String']['input'];
  moodboardId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUserCounterUpdateArgs = {
  counter: Scalars['String']['input'];
};


export type MutationValidateUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationWaitlistEnterpriseMembershipArgs = {
  membershipId: Scalars['ID']['input'];
};

export type NewUserUsageStats = {
  __typename?: 'NewUserUsageStats';
  /** Median number of moodboards created per new user in the selected period. */
  medianMoodboardsCreatedPerUser: Scalars['Float']['output'];
  /** Median number of moodboards updated per new user in the selected period. */
  medianMoodboardsUpdatedPerUser: Scalars['Float']['output'];
  totalNewUsers: Scalars['Int']['output'];
};

export type News = {
  __typename?: 'News';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  targetSubscriptionTypes?: Maybe<Array<NewsSubscriptionTarget>>;
  targetTradeAccess: NewsTradeAccessTarget;
  text: Scalars['String']['output'];
};

export enum NewsSubscriptionTarget {
  Developer = 'DEVELOPER',
  Enterprise = 'ENTERPRISE',
  NoSubscription = 'NO_SUBSCRIPTION',
  Pro = 'PRO',
  ProYear = 'PRO_YEAR',
  Starter = 'STARTER'
}

export enum NewsTradeAccessTarget {
  All = 'ALL',
  WithoutTrade = 'WITHOUT_TRADE',
  WithTrade = 'WITH_TRADE'
}

export type ObjectMetadata = {
  __typename?: 'ObjectMetadata';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  billingAddress?: Maybe<Scalars['JSONObject']['output']>;
  brandOrders?: Maybe<Array<BrandOrder>>;
  brands?: Maybe<Array<Scalars['String']['output']>>;
  businessProfile: BusinessProfile;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['JSONObject']['output']>;
  paymentStatus: PaymentStatus;
  products?: Maybe<Array<Scalars['JSONObject']['output']>>;
  reference?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Scalars['JSONObject']['output']>;
  status: OrderStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type OrderBrandStat = {
  __typename?: 'OrderBrandStat';
  brandName: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type OrderChanged = {
  __typename?: 'OrderChanged';
  brandOrder?: Maybe<BrandOrder>;
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export enum OrderChannel {
  Direct = 'DIRECT',
  Noga = 'NOGA'
}

export type OrderCompanyStat = {
  __typename?: 'OrderCompanyStat';
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type OrderCustomerStat = {
  __typename?: 'OrderCustomerStat';
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['ID']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type OrderInput = {
  businessProfileId?: InputMaybe<Scalars['ID']['input']>;
  formData: Scalars['String']['input'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  available?: Maybe<Scalars['Boolean']['output']>;
  brandOrder: BrandOrder;
  brandOrderId: Scalars['ID']['output'];
  clientPrice: Scalars['Float']['output'];
  clientReferenceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  markup?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['JSON']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  removed?: Maybe<Scalars['Boolean']['output']>;
  retailPrice: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  tradePrice: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vatIncluded: Scalars['Boolean']['output'];
  vatRate: Scalars['Float']['output'];
};

export type OrderMonthStat = {
  __typename?: 'OrderMonthStat';
  month: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type OrderProductInput = {
  price: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderStats = {
  __typename?: 'OrderStats';
  averageOrderValue: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  ordersByBrand: Array<OrderBrandStat>;
  ordersByCompany: Array<OrderCompanyStat>;
  ordersByCustomer: Array<OrderCustomerStat>;
  ordersByMonth: Array<OrderMonthStat>;
  ordersByStatus: Array<OrderStatusStat>;
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type OrderStatsQueryInput = {
  businessProfileId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderStatus {
  BrandOfferReceived = 'BRAND_OFFER_RECEIVED',
  BrandOfferUpdated = 'BRAND_OFFER_UPDATED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Shipped = 'SHIPPED',
  WaitingForBrandConfirmation = 'WAITING_FOR_BRAND_CONFIRMATION'
}

export type OrderStatusStat = {
  __typename?: 'OrderStatusStat';
  count: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type OrderUpdateInput = {
  notes?: InputMaybe<Scalars['JSON']['input']>;
  productUpdates: Array<ProductUpdateInput>;
};

export type OrdersQueryInput = {
  brandId?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  businessProfileId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrdersResponse = {
  __typename?: 'OrdersResponse';
  data: Array<Order>;
  total: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemsPerPage: Scalars['Int']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaintVisibility = {
  __typename?: 'PaintVisibility';
  hide?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PaintVisibilityInput = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ParentOrder = {
  __typename?: 'ParentOrder';
  brandOrders: Array<BrandOrder>;
  businessProfile: BusinessProfile;
  businessProfileId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['JSON']['output']>;
  paymentStatus: PaymentStatus;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  subtotalAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
  vatAmount: Scalars['Float']['output'];
};

export type ParentOrdersResponse = {
  __typename?: 'ParentOrdersResponse';
  data: Array<ParentOrder>;
  total: Scalars['Int']['output'];
};

export type ParserJob = {
  __typename?: 'ParserJob';
  jobType?: Maybe<Scalars['String']['output']>;
};

export type ParserMessage = {
  __typename?: 'ParserMessage';
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ParserService = {
  __typename?: 'ParserService';
  arn: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ParserStatus = {
  __typename?: 'ParserStatus';
  job?: Maybe<ParserJob>;
  messages?: Maybe<Array<Maybe<ParserMessage>>>;
  parsedProducts?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Pattern = {
  __typename?: 'Pattern';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum PaymentStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type PaymentSubscription = {
  __typename?: 'PaymentSubscription';
  cancel_at_period_end?: Maybe<Scalars['Boolean']['output']>;
  current_period_end?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PaymentSubscriptionType>;
};

export enum PaymentSubscriptionType {
  Developer = 'DEVELOPER',
  Enterprise = 'ENTERPRISE',
  Pro = 'PRO',
  ProYear = 'PRO_YEAR',
  Starter = 'STARTER'
}

/** Performance monitoring statistics for search operations */
export type PerformanceStats = {
  __typename?: 'PerformanceStats';
  /** Average duration of all slow queries in milliseconds */
  averageDuration: Scalars['Int']['output'];
  /** Statistics for the last 6 hours */
  last6Hours: PerformanceWindow;
  /** Statistics for the last 24 hours */
  last24Hours: PerformanceWindow;
  /** Age of the oldest log entry */
  oldestLogAge: Scalars['String']['output'];
  /** Recent slow queries from the specified time period */
  recentQueries: Array<SlowQuery>;
  /** How many hours of logs are retained */
  retentionHours: Scalars['Int']['output'];
  /** Top 10 slowest queries ever recorded */
  slowestQueries: Array<SlowQuery>;
  /** Number of queries that timed out */
  timeoutQueries: Scalars['Int']['output'];
  /** Total number of logs currently stored */
  totalLogsStored: Scalars['Int']['output'];
  /** Total number of slow queries recorded */
  totalSlowQueries: Scalars['Int']['output'];
};

/** Performance statistics for a specific time window */
export type PerformanceWindow = {
  __typename?: 'PerformanceWindow';
  /** Average duration in milliseconds for this window */
  averageDuration: Scalars['Int']['output'];
  /** Number of timeouts in this window */
  timeoutCount: Scalars['Int']['output'];
  /** Total number of slow queries in this window */
  totalQueries: Scalars['Int']['output'];
};

export type Personalisation = {
  __typename?: 'Personalisation';
  id: Scalars['ID']['output'];
  usageType?: Maybe<PersonalisationUsageType>;
};

export enum PersonalisationUsageType {
  Personal = 'PERSONAL',
  Professional = 'PROFESSIONAL'
}

export type PreFilterField = {
  __typename?: 'PreFilterField';
  description?: Maybe<Scalars['String']['output']>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  example?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PriceListState = {
  __typename?: 'PriceListState';
  documentId: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PriceListStateChangedEvent = {
  __typename?: 'PriceListStateChangedEvent';
  documentId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type PriceRange = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type ProBrand = {
  __typename?: 'ProBrand';
  brand?: Maybe<Scalars['String']['output']>;
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type ProBrandInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProDesc = {
  __typename?: 'ProDesc';
  description?: Maybe<Scalars['String']['output']>;
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type ProDescInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProGroupLabel = {
  __typename?: 'ProGroupLabel';
  label?: Maybe<Scalars['String']['output']>;
  moodBoardId?: Maybe<Scalars['ID']['output']>;
};

export type ProGroupLabelInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  moodBoardId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProItem = {
  __typename?: 'ProItem';
  aiGeneratedImages?: Maybe<Array<ProItemAiImage>>;
  brand?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ProItemAiImage = {
  __typename?: 'ProItemAIImage';
  angle: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  imageUrl: Scalars['String']['output'];
  imageUrlNoBg?: Maybe<Scalars['String']['output']>;
  sourceImageUrl: Scalars['String']['output'];
};

export type ProItemEditInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  removeBG?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProItemInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  removeBG?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProItemsQueryInput = {
  /**
   * Deprecated: ignored. Personal library sharing is controlled by the enterprise
   * `customProducts` feature flag (all active enterprise members).
   */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When true, exclude the caller's own items (team libraries only).
   * Ignored when ownerUserId is set.
   */
  excludeCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Restrict results to items owned by this user. Must be the caller, or another
   * enterprise member whose library the caller may access via `customProducts`.
   */
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProItemsResponse = {
  __typename?: 'ProItemsResponse';
  data?: Maybe<Array<ProItem>>;
  total: Scalars['Int']['output'];
};

export type ProMarkup = {
  __typename?: 'ProMarkup';
  markup?: Maybe<Scalars['Float']['output']>;
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type ProMarkupInput = {
  markup?: InputMaybe<Scalars['Float']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProPrice = {
  __typename?: 'ProPrice';
  clientPrice?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  designerPrice?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  markup?: Maybe<Scalars['Float']['output']>;
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  storePrice?: Maybe<Scalars['Float']['output']>;
};

export type ProPriceInput = {
  clientPrice?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  designerPrice?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  storePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProQuantity = {
  __typename?: 'ProQuantity';
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ProQuantityInput = {
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ProSettingsInput = {
  visibilities?: InputMaybe<Array<VisibilityInput>>;
};

export type ProSupplier = {
  __typename?: 'ProSupplier';
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
};

export type ProSupplierInput = {
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type ProVisibility = {
  __typename?: 'ProVisibility';
  hide?: Maybe<Scalars['Boolean']['output']>;
  hideBrand?: Maybe<Scalars['Boolean']['output']>;
  hideClientPrice?: Maybe<Scalars['Boolean']['output']>;
  hideDesc?: Maybe<Scalars['Boolean']['output']>;
  hideLink?: Maybe<Scalars['Boolean']['output']>;
  hideStorePrice?: Maybe<Scalars['Boolean']['output']>;
  hideSupplier?: Maybe<Scalars['Boolean']['output']>;
  moodBoardProductId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
};

export type ProVisibilityInput = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideBrand?: InputMaybe<Scalars['Boolean']['input']>;
  hideClientPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hideDesc?: InputMaybe<Scalars['Boolean']['input']>;
  hideLink?: InputMaybe<Scalars['Boolean']['input']>;
  hideStorePrice?: InputMaybe<Scalars['Boolean']['input']>;
  hideSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};

export type Product = {
  __typename?: 'Product';
  active3DAsset?: Maybe<Product3DAsset>;
  active3DAssetId?: Maybe<Scalars['ID']['output']>;
  additionalImages?: Maybe<Array<Scalars['String']['output']>>;
  aiGeneratedImages?: Maybe<Array<ProductAiImage>>;
  brand?: Maybe<Scalars['String']['output']>;
  breakColors?: Maybe<Scalars['JSONObject']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  categoriesMeta?: Maybe<Array<Maybe<CategoryMeta>>>;
  categoriesMetaNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categorizationConfidence?: Maybe<Scalars['Float']['output']>;
  categorizationError?: Maybe<CategorizationProductError>;
  categorizationNeedsReview?: Maybe<Scalars['Boolean']['output']>;
  categorizationProvider?: Maybe<Scalars['String']['output']>;
  categorizationReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
  categorizationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  categorizationVersion?: Maybe<Scalars['String']['output']>;
  colors?: Maybe<Array<Maybe<Color>>>;
  depth?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  features3?: Maybe<Scalars['JSONObject']['output']>;
  featuresVectorIndex?: Maybe<Scalars['Boolean']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  haveDifferentTypes?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  related?: Maybe<Array<Scalars['ID']['output']>>;
  supplier?: Maybe<Supplier>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type Product3DAsset = {
  __typename?: 'Product3DAsset';
  architectureSymbolKey?: Maybe<Scalars['String']['output']>;
  attemptCount: Scalars['Int']['output'];
  bounds?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dimensionAnchor?: Maybe<Product3DDimensionAnchor>;
  dimensionScale?: Maybe<Scalars['Float']['output']>;
  dimensionSource?: Maybe<Product3DDimensionSource>;
  dimensions?: Maybe<Scalars['JSONObject']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileBytes?: Maybe<Scalars['Int']['output']>;
  footprintSource?: Maybe<Scalars['String']['output']>;
  footprintSvg?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  generatedFootprintSvg?: Maybe<Scalars['String']['output']>;
  generationQuality: Scalars['String']['output'];
  generationSettings?: Maybe<Scalars['JSONObject']['output']>;
  glbUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  materialSlots?: Maybe<Scalars['JSONObject']['output']>;
  modelDimensions?: Maybe<Scalars['JSONObject']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  pipelineVersion?: Maybe<Scalars['String']['output']>;
  placement?: Maybe<Scalars['JSONObject']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  providerCost?: Maybe<Scalars['Float']['output']>;
  providerPollCount: Scalars['Int']['output'];
  providerTaskUuid?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  quality?: Maybe<Scalars['JSONObject']['output']>;
  review?: Maybe<Scalars['JSONObject']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  textureMaxSize?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  triangleCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variantId?: Maybe<Scalars['String']['output']>;
  vertexCount?: Maybe<Scalars['Int']['output']>;
};

export enum Product3DDimensionAnchor {
  Depth = 'DEPTH',
  Height = 'HEIGHT',
  Width = 'WIDTH'
}

export type Product3DDimensionInput = {
  anchor?: InputMaybe<Product3DDimensionAnchor>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  source: Product3DDimensionSource;
  value?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum Product3DDimensionSource {
  Legacy = 'LEGACY',
  Manual = 'MANUAL',
  Model = 'MODEL',
  ProductFeed = 'PRODUCT_FEED'
}

export type Product3DFootprintInput = {
  architectureSymbolKey?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};

export type Product3DFootprintModelCandidate = {
  __typename?: 'Product3DFootprintModelCandidate';
  /** Final byte length (footprintSvg). */
  bytes: Scalars['Int']['output'];
  /** Per-model failure message; other candidates may still succeed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Final SVG: mesh-locked when meshLocked, else pure model (after budget constrain). */
  footprintSvg?: Maybe<Scalars['String']['output']>;
  /** Stable slot id: claude | gemini | gpt */
  label: Scalars['String']['output'];
  /** True when footprintSvg used the mesh outer silhouette (AI interiors grafted). */
  meshLocked: Scalars['Boolean']['output'];
  /** OpenRouter model id used for this candidate. */
  model: Scalars['String']['output'];
  /** Byte length of pure model SVG (rawFootprintSvg). */
  rawBytes: Scalars['Int']['output'];
  /** Pure model SVG before mesh lock (after budget constrain). Compare with footprintSvg. */
  rawFootprintSvg?: Maybe<Scalars['String']['output']>;
  /** True when bytes <= 10240 and SVG was produced. */
  underBudget: Scalars['Boolean']['output'];
  /** True when budget constrain reduced either variant. */
  wasCompressed: Scalars['Boolean']['output'];
};

export type Product3DFootprintModelCompare = {
  __typename?: 'Product3DFootprintModelCompare';
  assetId: Scalars['ID']['output'];
  candidates: Array<Product3DFootprintModelCandidate>;
  previousFootprintSvg?: Maybe<Scalars['String']['output']>;
  previousFootprintSvgBytes: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  topImageUrl?: Maybe<Scalars['String']['output']>;
  topImageUrlNoBg?: Maybe<Scalars['String']['output']>;
};

/**
 * Preview result of adminOptimizeProduct3DFootprintSvg (SVGO path packing).
 * Does not write until adminApplyProduct3DFootprintSvg.
 */
export type Product3DFootprintOptimizeResult = {
  __typename?: 'Product3DFootprintOptimizeResult';
  assetId: Scalars['ID']['output'];
  optimizedBytes: Scalars['Int']['output'];
  previousBytes: Scalars['Int']['output'];
  previousFootprintSvg: Scalars['String']['output'];
  proposedFootprintSvg: Scalars['String']['output'];
  savedBytes: Scalars['Int']['output'];
};

export enum Product3DFootprintRegenerationMethod {
  /**
   * Deterministic height-band silhouette from the optimized GLB
   * (4 adaptive nested bands — experiment winner b4-adaptive-nested).
   */
  HeightBandsB4AdaptiveNested = 'HEIGHT_BANDS_B4_ADAPTIVE_NESTED',
  /** Mesh outer silhouette from the GLB (default). Edit interiors in admin. */
  Mesh = 'MESH',
  /**
   * Same source-photo path as TOP_DOWN_IMAGE, but forces Gemini
   * (google/gemini-2.5-pro, overridable via PRODUCT_3D_TOPDOWN_GEMINI_SVG_MODEL)
   * to write the SVG — matches the Gemini-chat style prompt path.
   */
  TopDownGemini = 'TOP_DOWN_GEMINI',
  /**
   * Same source-photo path as TOP_DOWN_IMAGE, but forces GPT
   * (openai/gpt-4.1, overridable via PRODUCT_3D_TOPDOWN_GPT_SVG_MODEL)
   * to write the SVG.
   */
  TopDownGpt = 'TOP_DOWN_GPT',
  /**
   * Catalog/source product photo → default vision model
   * (Claude Sonnet 4 unless PRODUCT_3D_TOPDOWN_VISION_SVG_MODEL is set) draws SVG.
   */
  TopDownImage = 'TOP_DOWN_IMAGE',
  /**
   * TOP orthographic cutout → google/nano-banana-pro (black line art) →
   * Recraft vectorize on Replicate (recraft-ai/recraft-vectorize).
   * No resize / patternless / down-quality post-processing — raw vectorize SVG.
   * Admins should validate/regenerate the TOP via adminPreviewProduct3DTopImage
   * before running this method.
   */
  TopDownNanoBananaRecraft = 'TOP_DOWN_NANO_BANANA_RECRAFT',
  /**
   * Same Nano Banana → Recraft path, but the TOP input is a software-rendered
   * orthographic top-down PNG from the optimized GLB (not an AI photo from the
   * catalog image). Skips Validate TOP.
   */
  TopDownNanoBananaRecraft_3D = 'TOP_DOWN_NANO_BANANA_RECRAFT_3D',
  /**
   * TOP orthographic cutout → patternless black-and-white flatten →
   * Recraft vectorize on Replicate (recraft-ai/recraft-vectorize).
   */
  TopDownRecraftVectorize = 'TOP_DOWN_RECRAFT_VECTORIZE'
}

export type Product3DFootprintRegenerationPreview = {
  __typename?: 'Product3DFootprintRegenerationPreview';
  assetId: Scalars['ID']['output'];
  /**
   * Intermediate Nano Banana Pro line-art raster (TOP_DOWN_NANO_BANANA_RECRAFT).
   * Shown so admins can verify pattern removal before accepting the SVG.
   */
  lineArtImageUrl?: Maybe<Scalars['String']['output']>;
  /** Which regeneration method produced the proposal. */
  method: Product3DFootprintRegenerationMethod;
  previousFootprintSvg?: Maybe<Scalars['String']['output']>;
  previousFootprintSvgBytes: Scalars['Int']['output'];
  proposedFootprintSvg: Scalars['String']['output'];
  proposedFootprintSvgBytes: Scalars['Int']['output'];
  /** TOP cutout used as input (when available). */
  topImageUrl?: Maybe<Scalars['String']['output']>;
};

export type Product3DFootprintSvgLog = {
  __typename?: 'Product3DFootprintSvgLog';
  assetId: Scalars['ID']['output'];
  candidates: Array<Product3DFootprintModelCandidate>;
  createdAt: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  previousFootprintSvgBytes?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['String']['output']>;
  sourceMethod: Scalars['String']['output'];
  topImageUrl?: Maybe<Scalars['String']['output']>;
  topImageUrlNoBg?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Product3DFootprintSvgLogsInput = {
  limit: Scalars['Int']['input'];
  /** Optional product id filter. */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Optional free-text match on productName. */
  productName?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  /** Optional: compare | TOP_DOWN_IMAGE | TOP_DOWN_GEMINI | TOP_DOWN_GPT */
  sourceMethod?: InputMaybe<Scalars['String']['input']>;
};

export type Product3DFootprintSvgLogsResponse = {
  __typename?: 'Product3DFootprintSvgLogsResponse';
  data: Array<Product3DFootprintSvgLog>;
  total: Scalars['Int']['output'];
};

export enum Product3DGenerationQuality {
  Detailed = 'DETAILED',
  Standard = 'STANDARD'
}

export enum Product3DLibraryOrigin {
  Boni = 'BONI',
  Brand = 'BRAND'
}

export type Product3DPlacementInput = {
  elevation: Scalars['Float']['input'];
  mode: Scalars['String']['input'];
  rotationXQuarterTurns?: InputMaybe<Scalars['Int']['input']>;
  rotationYQuarterTurns?: InputMaybe<Scalars['Int']['input']>;
  rotationZQuarterTurns?: InputMaybe<Scalars['Int']['input']>;
};

/** Admin TOP-angle preview before Nano Banana → Recraft (or other TOP pipelines). */
export type Product3DTopImagePreview = {
  __typename?: 'Product3DTopImagePreview';
  assetId: Scalars['ID']['output'];
  /** Image model used when a TOP was generated (e.g. google/gemini-2.5-flash-image). */
  modelUsed?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  /** True when this TOP was generated with the simplified architecture prompt. */
  simplifiedArchitecture: Scalars['Boolean']['output'];
  /** Catalog / source product photo used to generate the TOP view. */
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  /** existing_nobg | existing | generated */
  topImageSource: Scalars['String']['output'];
  /** TOP with background (when available). */
  topImageUrl?: Maybe<Scalars['String']['output']>;
  /** TOP cutout (no background) — preferred Nano Banana input. */
  topImageUrlNoBg?: Maybe<Scalars['String']['output']>;
};

export type ProductAiImage = {
  __typename?: 'ProductAIImage';
  angle: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  imageUrl: Scalars['String']['output'];
  imageUrlNoBg?: Maybe<Scalars['String']['output']>;
  sourceImageUrl: Scalars['String']['output'];
};

export enum ProductAngle {
  Back = 'BACK',
  Back_45 = 'BACK_45',
  Front = 'FRONT',
  Side = 'SIDE',
  Side_45 = 'SIDE_45',
  Top = 'TOP'
}

export type ProductAvailabilityInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['ID']['input'];
  removed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductEditInput = {
  addAdditionalImages?: InputMaybe<Array<Scalars['Upload']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoriesMeta?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productImage?: InputMaybe<Scalars['Upload']['input']>;
  productImageNoBg?: InputMaybe<Scalars['Upload']['input']>;
  related?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAdditionalImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  removeBackground?: InputMaybe<Scalars['Boolean']['input']>;
  supplier?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductInput = {
  brand: Scalars['String']['input'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoriesMeta?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  productImageNb?: InputMaybe<Scalars['Upload']['input']>;
  related?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBackground?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductUpdateInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['JSON']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductUploadInput = {
  reRunCategories?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['ID']['input'];
  upload: Scalars['Upload']['input'];
};

export type ProductsInput = {
  products: Array<ProductInput>;
  supplier: Scalars['ID']['input'];
};

export type ProductsPriceMinMaxRespone = {
  __typename?: 'ProductsPriceMinMaxRespone';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type ProductsQueryInput = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  client?: InputMaybe<Scalars['String']['input']>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When set, product prices are converted from the stored base currency to this currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  numberOfCategories?: InputMaybe<Scalars['String']['input']>;
  priceRange?: InputMaybe<PriceRange>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  sortBy?: InputMaybe<SortOption>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductsQueryInputMeta = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  client?: InputMaybe<Scalars['String']['input']>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When set, product prices are converted from the stored base currency to this currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Scalars['Int']['input']>;
  filterQuotableSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  fullTextSearch?: InputMaybe<Scalars['String']['input']>;
  /** Only return products with an active, published 3D asset. */
  hasPublished3DAsset?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  materialIds?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfCategories?: InputMaybe<Scalars['String']['input']>;
  patternIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priceRange?: InputMaybe<PriceRange>;
  /** Restrict published 3D products to supplier uploads or BONI-generated assets. */
  product3DLibraryOrigin?: InputMaybe<Product3DLibraryOrigin>;
  productNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  roomIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchInstructions?: InputMaybe<SearchInstructionsInput>;
  shapeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  skip: Scalars['Int']['input'];
  sortBy?: InputMaybe<SortOption>;
  styleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierNames?: InputMaybe<Array<Scalars['String']['input']>>;
  useFullTextSearch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  data?: Maybe<Array<Product>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProfileInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileReindexOptionsInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  parallelism?: InputMaybe<Scalars['Int']['input']>;
  skipExisting?: InputMaybe<Scalars['Boolean']['input']>;
  throttleMs?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfileUsageStats = {
  __typename?: 'ProfileUsageStats';
  averageRating: Scalars['Float']['output'];
  profileId: Scalars['ID']['output'];
  profileName: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type ProjectActivityByPeriod = {
  __typename?: 'ProjectActivityByPeriod';
  documentsCreated: Scalars['Int']['output'];
  /** Share links created via createShareDocument (count of ShareDocument rows). */
  documentsShared: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  moodBoardsCreated: Scalars['Int']['output'];
  moodBoardsUpdated: Scalars['Int']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type ProviderHealth = {
  __typename?: 'ProviderHealth';
  error?: Maybe<Scalars['String']['output']>;
  lastCheck: Scalars['DateTime']['output'];
  lastChecked?: Maybe<Scalars['DateTime']['output']>;
  latency: Scalars['Int']['output'];
  latencyMs?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type ProviderHealthSummary = {
  __typename?: 'ProviderHealthSummary';
  error?: Maybe<Scalars['String']['output']>;
  health: ProviderHealth;
  lastChecked?: Maybe<Scalars['DateTime']['output']>;
  latencyMs?: Maybe<Scalars['Float']['output']>;
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  providerType: Scalars['String']['output'];
  status: ProviderStatus;
  usage: ProviderUsageSummary;
};

export type ProviderModel = {
  __typename?: 'ProviderModel';
  costPer1kTokens: Scalars['Float']['output'];
  dimension: Scalars['Int']['output'];
  embeddingsPath?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  maxTokens: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rerankPath?: Maybe<Scalars['String']['output']>;
  supportedLanguages: Array<Scalars['String']['output']>;
};

export type ProviderModelInput = {
  costPer1kTokens: Scalars['Float']['input'];
  dimension: Scalars['Int']['input'];
  embeddingsPath?: InputMaybe<Scalars['String']['input']>;
  features: Array<Scalars['String']['input']>;
  maxTokens: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  rerankPath?: InputMaybe<Scalars['String']['input']>;
  supportedLanguages: Array<Scalars['String']['input']>;
};

export enum ProviderStatus {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE'
}

export type ProviderUsage = {
  __typename?: 'ProviderUsage';
  failedRequests: Scalars['Int']['output'];
  lastRequest: Scalars['DateTime']['output'];
  totalRequests: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type ProviderUsageSummary = {
  __typename?: 'ProviderUsageSummary';
  averageLatency: Scalars['Int']['output'];
  requestsToday: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
};

export type PublishNewsInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  targetSubscriptionTypes?: InputMaybe<Array<NewsSubscriptionTarget>>;
  targetTradeAccess?: InputMaybe<NewsTradeAccessTarget>;
  text: Scalars['String']['input'];
};

/**
 * Facet options derived only from products with a published (ready) 3D model.
 * `categories` is a pruned tree (root → mid-level → leaf) of furniture groups.
 * Color/shape/material/style/pattern/room entries are CategoryMeta children,
 * not Color-collection rows, so they can be passed as productsMeta categoryIds.
 */
export type PublishedProduct3DLibraryFilters = {
  __typename?: 'PublishedProduct3DLibraryFilters';
  brands: Array<Brand>;
  categories: Array<CategoryMeta>;
  colors: Array<CategoryMeta>;
  materials: Array<CategoryMeta>;
  patterns: Array<CategoryMeta>;
  priceMax?: Maybe<Scalars['Float']['output']>;
  priceMin?: Maybe<Scalars['Float']['output']>;
  productCount: Scalars['Int']['output'];
  rooms: Array<CategoryMeta>;
  shapes: Array<CategoryMeta>;
  styles: Array<CategoryMeta>;
  suppliers: Array<Supplier>;
};

export type Query = {
  __typename?: 'Query';
  adminCommunityUserModels3D: UserModels3DResponse;
  adminCuratedSet?: Maybe<CuratedSet>;
  adminCuratedSets: Array<CuratedSet>;
  /** Admin: manage example images. */
  adminExampleImages: ExampleImagesResponse;
  adminFloorplannerPublic3DAssets: Array<UserModel3D>;
  adminFloorplannerSymbol3DDefaults: Array<FloorplannerSymbol3DDefault>;
  adminGetParserMessages?: Maybe<Array<Maybe<ParserMessage>>>;
  adminGetParserServices?: Maybe<Array<Maybe<ParserService>>>;
  adminGetParserStatus?: Maybe<ParserStatus>;
  /**
   * Admin gallery of product 3D footprint SVGs (review/ready). Pass minBytes
   * (default 0) to list all, or 10240 to list only oversized symbols.
   */
  adminOversizedProduct3DFootprints: Array<AdminOversizedProduct3DFootprint>;
  adminProduct3DAssets: Array<Product3DAsset>;
  adminProduct3DJobs: AdminProduct3DJobsResponse;
  affiliates: Array<Maybe<Affiliate>>;
  aiRenderLogs: AiRenderLogsResponse;
  /** Poll a video generation job started by `generateAiVideo`. Owner only. */
  aiVideoJob?: Maybe<GenerateAiVideoResult>;
  /** Analyze products for categorization issues (Admin/Parser only) */
  analyzeCategorizationQuality: Array<CategorizationAnalysisResult>;
  /** Get batch job status and results (Admin/Parser only) */
  batchCategorizationJob?: Maybe<BatchCategorizationJob>;
  /** List recent batch jobs (Admin/Parser only) */
  batchCategorizationJobs: Array<BatchCategorizationJob>;
  boardSetting: BoardSetting;
  brand?: Maybe<Brand>;
  /** Admin-only brand-scoped usage (moodboard snapshot, AI logs, searches with brand filter). */
  brandInsights: BrandInsights;
  brandOrder?: Maybe<BrandOrder>;
  brandOrdersByParent: Array<BrandOrder>;
  brandProduct?: Maybe<BrandProduct>;
  brandProducts: BrandProductsResponse;
  brands: Array<Brand>;
  businessApplication?: Maybe<BusinessApplication>;
  businessApplications: Array<BusinessApplication>;
  businessProfile?: Maybe<BusinessProfile>;
  businessProfiles: Array<BusinessProfile>;
  categories: Array<Maybe<Category>>;
  categoriesMeta: Array<Maybe<CategoryMeta>>;
  /** Get categorization statistics (Admin/Parser only) */
  categorizationStatistics: CategorizationStatistics;
  category?: Maybe<Category>;
  categoryMeta?: Maybe<CategoryMeta>;
  colors?: Maybe<Array<Color>>;
  colorsMeta?: Maybe<Array<Color>>;
  communityUserModels3D: UserModels3DResponse;
  convertCurrency: CurrencyConversion;
  creditPacks: Array<CreditPack>;
  currencyRates: CurrencyRatesResponse;
  currentUser: User;
  debugVectorSearch: VectorSearchDebugResponse;
  /** When currency is provided, nested product prices (e.g. moodBoards[].products[].product.price) are returned in that currency. */
  documentById: Document;
  documentLockStatus?: Maybe<DocumentLockStatus>;
  documentMembers: DocumentMembersResponse;
  enterprise?: Maybe<Enterprise>;
  enterprises: EnterprisesResponse;
  /** Active example images for editor users. */
  exampleImages: ExampleImagesResponse;
  filterFieldValues: Array<FilterFieldValue>;
  /** Find products that might be miscategorized (Admin/Parser only) */
  findPotentialMiscategorizations: Array<CategorizationAnalysisResult>;
  flaggedProductMessages?: Maybe<Array<Maybe<FlaggedProductMessage>>>;
  flaggedProductsMeta?: Maybe<ProductsResponse>;
  floorplan?: Maybe<Floorplan>;
  floorplanCollabState: FloorplanCollabState;
  floorplanImageImport: FloorplanImageImport;
  floorplanImageImportCreditCost: Scalars['Int']['output'];
  floorplanImageImports: Array<FloorplanImageImport>;
  /**
   * Surfaces assigned to child categories of the "Floorplanner materials" parent.
   * Pack membership is the publish switch. Admins receive all pack rows; non-admins
   * receive pack rows that have a primary photo. Soft-launch: remove unfinished
   * materials from the pack. Bake is optional tileable quality, not visibility.
   */
  floorplannerMaterialSurfaces: Array<Surface>;
  floorplannerSymbol3DDefaults: Array<FloorplannerSymbol3DDefault>;
  floorplans?: Maybe<Array<Maybe<Floorplan>>>;
  folderById?: Maybe<Folder>;
  galleryBoardById: GalleryBoard;
  galleryBoards?: Maybe<Array<GalleryBoard>>;
  galleryCount: Scalars['Int']['output'];
  generateApiKey: GenerateApiKeyResponse;
  getAllApiKeyStats: ApiKeyStatsResponse;
  getAllOrders: OrdersResponse;
  getApiKeyStats: ApiKeyStatsResponse;
  getBrandReplacement?: Maybe<BrandReplacement>;
  getBrandsWithOrders: Array<BrandWithOrders>;
  getEmbeddingProviders: Array<EmbeddingProvidersResponse>;
  getIndexVersions: Array<IndexVersion>;
  getLinkAccessLogs: Array<LinkAccessLog>;
  getLinkDetails: Array<LinkAccess>;
  getOrderById: Order;
  getOrderStats?: Maybe<OrderStats>;
  getOrdersByUser: OrdersResponse;
  getReindexJobs: Array<ReindexJobResponse>;
  getReplacementList?: Maybe<ReplacementListResponse>;
  getReplacementLists: Array<ReplacementListResponse>;
  getRerankerProviders: Array<RerankerProvidersResponse>;
  getRoomElements?: Maybe<RoomElements>;
  getUnreadBrandOrders: Array<BrandOrder>;
  getVectorProfile?: Maybe<VectorProfileResponse>;
  getVectorProfiles: Array<VectorProfileResponse>;
  getVectorSearchDashboard: VectorSearchDashboard;
  imageSearch: ImageSearchResponse;
  listBrandReplacements: Array<BrandReplacement>;
  materialById: Material;
  materialCategories: Array<Maybe<MaterialCategory>>;
  materialCategory?: Maybe<MaterialCategory>;
  materials?: Maybe<MaterialResponse>;
  materialsMeta?: Maybe<Array<Material>>;
  moodBoardById: MoodBoard;
  myBasket: Basket;
  myBusinessApplication?: Maybe<BusinessApplication>;
  myBusinessProfile?: Maybe<BusinessProfile>;
  myBusinessProfiles: Array<BusinessProfile>;
  myPendingDocumentInvites: Array<DocumentInvite>;
  myPersonalisation?: Maybe<Personalisation>;
  /** Share projects created by the current user (createShareDocument). */
  myShareDocuments: Array<ShareDocumentListItem>;
  /** Fast lookup of the authenticated user's item tags. Avoids the heavy currentUser resolver. */
  myUserItemTags: Array<UserItemTag>;
  order?: Maybe<Order>;
  orderItem?: Maybe<OrderItem>;
  orderItemsByBrandOrder: Array<OrderItem>;
  orders: Array<Order>;
  parentOrder?: Maybe<ParentOrder>;
  parentOrders: ParentOrdersResponse;
  patternsMeta?: Maybe<Array<Pattern>>;
  pendingBusinessProfiles: Array<BusinessProfile>;
  /** Get search performance statistics and slow query logs (Admin only) */
  performanceStats: PerformanceStats;
  preFilterFields: Array<PreFilterField>;
  priceListState?: Maybe<PriceListState>;
  proItems?: Maybe<ProItemsResponse>;
  product3DAssets: Array<Product3DAsset>;
  /** Admin log of vision SVG generations (compare + single-model TOP runs). */
  product3DFootprintSvgLogs: Product3DFootprintSvgLogsResponse;
  productBrands: Array<BrandInfo>;
  productById: Product;
  /** Get categorization status for a product (Admin/Parser only) */
  productCategorization?: Maybe<CategorizationResult>;
  products?: Maybe<ProductsResponse>;
  productsCount: Scalars['Int']['output'];
  productsCountMeta: Scalars['Int']['output'];
  productsMeta?: Maybe<ProductsResponse>;
  productsMetaExtract?: Maybe<ProductsResponse>;
  /** Get products that need manual review of their AI categorization (Admin only) */
  productsNeedingReview: Array<Product>;
  productsPriceMinMax: ProductsPriceMinMaxRespone;
  profileById?: Maybe<Profile>;
  profiles?: Maybe<Array<Profile>>;
  publishedProduct3DLibraryFilters: PublishedProduct3DLibraryFilters;
  /** News items from the last 30 days, newest first. Authenticated users only. */
  recentNews: Array<News>;
  roomsMeta?: Maybe<Array<Room>>;
  scanRoomElements?: Maybe<ScanRoomElementsResponse>;
  searchDebugHistory: SearchDebugHistoryResponse;
  searchDebugSession: SearchDebugSession;
  searchDebugStats: SearchDebugStats;
  searchHistories?: Maybe<SearchHistoriesResponse>;
  searchPerformanceStats: SearchPerformanceStatsResponse;
  searchSuggestions: SearchSuggestionsResponse;
  searchSuggestionsExtended: SearchSuggestionsExtendedResponse;
  shapesMeta?: Maybe<Array<Shape>>;
  shareBoardById: ShareBoard;
  /** When currency is provided, nested product prices (e.g. moodBoards[].products[].product.price) are returned in that currency. */
  shareDocumentById: ShareDocument;
  shareDocumentHeader: ShareDocument;
  stylesMeta?: Maybe<Array<Style>>;
  supplierById: Supplier;
  supplierStats?: Maybe<SupplierStatsResponse>;
  suppliers: Array<Supplier>;
  /**
   * Curated FAQ prompts for the support chat empty state.
   * Public list (no auth required); answers still go through askSupportBot.
   */
  supportChatFaqs: Array<SupportChatFaq>;
  /** Admin: one session with full transcript. */
  supportChatSession?: Maybe<SupportChatSessionDetail>;
  /** Admin: paginated support chat sessions (newest activity first). */
  supportChatSessions: SupportChatSessionsResponse;
  surfaceById: Surface;
  surfaceCategories: Array<Maybe<SurfaceCategory>>;
  surfaceCategory?: Maybe<SurfaceCategory>;
  surfaces?: Maybe<SurfaceResponse>;
  templateBoards?: Maybe<Array<GalleryBoard>>;
  testDiscountRules?: Maybe<TestDiscountRulesResult>;
  /** Admin-only aggregated product usage and feature analytics for dashboards. */
  usageInsights: UsageInsights;
  user?: Maybe<User>;
  userDocuments?: Maybe<UserDocumentsResponse>;
  userDocumentsMerged: UserDocumentsMergedResponse;
  userExists?: Maybe<Scalars['Boolean']['output']>;
  userFavoriteProducts: Array<Product>;
  /** Current user's upload by id. Null if missing or not owned — use for lazy fields e.g. sourceProducts. */
  userItem?: Maybe<UserItem>;
  userItems?: Maybe<UserItemsResponse>;
  userModels3D: Array<UserModel3D>;
  users?: Maybe<UsersResponse>;
  usersExports?: Maybe<UsersExportResponse>;
  usersSummary: UsersSummary;
  validateLinkAccess?: Maybe<LinkAccess>;
};


export type QueryAdminCommunityUserModels3DArgs = {
  input?: InputMaybe<AdminCommunityUserModels3DInput>;
};


export type QueryAdminCuratedSetArgs = {
  key: Scalars['String']['input'];
};


export type QueryAdminCuratedSetsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminExampleImagesArgs = {
  input?: InputMaybe<AdminExampleImagesQueryInput>;
};


export type QueryAdminGetParserMessagesArgs = {
  supplierId: Scalars['String']['input'];
};


export type QueryAdminGetParserStatusArgs = {
  serviceUrl: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
};


export type QueryAdminOversizedProduct3DFootprintsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minBytes?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminProduct3DAssetsArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryAdminProduct3DJobsArgs = {
  input?: InputMaybe<AdminProduct3DJobsInput>;
};


export type QueryAiRenderLogsArgs = {
  input: AiRenderLogsInput;
};


export type QueryAiVideoJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyzeCategorizationQualityArgs = {
  filter?: InputMaybe<CategorizationFilterInput>;
  options?: InputMaybe<AnalysisOptionsInput>;
};


export type QueryBatchCategorizationJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryBatchCategorizationJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BatchJobStatus>;
};


export type QueryBoardSettingArgs = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandInsightsArgs = {
  input: BrandInsightsInput;
};


export type QueryBrandOrderArgs = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandOrdersByParentArgs = {
  parentOrderId: Scalars['ID']['input'];
};


export type QueryBrandProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandProductsArgs = {
  input: BrandProductsQueryInput;
};


export type QueryBrandsArgs = {
  categoriesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterQuotableSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBusinessApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessProfilesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<ApplicationStatus>>>;
};


export type QueryCategorizationStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCategoryMetaArgs = {
  id: Scalars['String']['input'];
};


export type QueryColorsMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QueryCommunityUserModels3DArgs = {
  input?: InputMaybe<CommunityUserModels3DInput>;
};


export type QueryConvertCurrencyArgs = {
  amount: Scalars['Float']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryDebugVectorSearchArgs = {
  request: SearchDebugInput;
};


export type QueryDocumentByIdArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryDocumentLockStatusArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryDocumentMembersArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryEnterpriseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnterprisesArgs = {
  input?: InputMaybe<EnterprisesQueryInput>;
};


export type QueryExampleImagesArgs = {
  input?: InputMaybe<ExampleImagesQueryInput>;
};


export type QueryFilterFieldValuesArgs = {
  field: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryFindPotentialMiscategorizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type QueryFlaggedProductMessagesArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryFlaggedProductsMetaArgs = {
  input?: InputMaybe<ProductsQueryInputMeta>;
};


export type QueryFloorplanArgs = {
  id: Scalars['String']['input'];
};


export type QueryFloorplanCollabStateArgs = {
  floorplanId: Scalars['String']['input'];
};


export type QueryFloorplanImageImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFloorplanImageImportsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  floorplanId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFloorplannerSymbol3DDefaultsArgs = {
  symbolKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFolderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGalleryBoardByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGalleryBoardsArgs = {
  input?: InputMaybe<GalleryBoardsInput>;
};


export type QueryGalleryCountArgs = {
  input?: InputMaybe<GalleryBoardsInput>;
};


export type QueryGenerateApiKeyArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllOrdersArgs = {
  input: OrdersQueryInput;
};


export type QueryGetApiKeyStatsArgs = {
  apiKey: Scalars['String']['input'];
};


export type QueryGetBrandReplacementArgs = {
  misspelling: Scalars['String']['input'];
};


export type QueryGetIndexVersionsArgs = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  vectorProfileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLinkAccessLogsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetLinkDetailsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrderStatsArgs = {
  input: OrderStatsQueryInput;
};


export type QueryGetOrdersByUserArgs = {
  input: OrdersQueryInput;
};


export type QueryGetReindexJobsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ReindexJobStatus>;
};


export type QueryGetReplacementListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetReplacementListsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  vectorProfileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRoomElementsArgs = {
  surfaceId: Scalars['String']['input'];
};


export type QueryGetUnreadBrandOrdersArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetVectorProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVectorProfilesArgs = {
  filters?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryImageSearchArgs = {
  input: ImageSearchInput;
};


export type QueryMaterialByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMaterialCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryMaterialsArgs = {
  input?: InputMaybe<MaterialsQueryInput>;
};


export type QueryMaterialsMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QueryMoodBoardByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderItemsByBrandOrderArgs = {
  brandOrderId: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  options?: InputMaybe<QueryOptions>;
};


export type QueryParentOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParentOrdersArgs = {
  input: OrdersQueryInput;
};


export type QueryPatternsMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QueryPerformanceStatsArgs = {
  hours?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreFilterFieldsArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPriceListStateArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryProItemsArgs = {
  input?: InputMaybe<ProItemsQueryInput>;
};


export type QueryProduct3DAssetsArgs = {
  productIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProduct3DFootprintSvgLogsArgs = {
  input: Product3DFootprintSvgLogsInput;
};


export type QueryProductBrandsArgs = {
  categoriesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterQuotableSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductByIdArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryProductCategorizationArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  input?: InputMaybe<ProductsQueryInput>;
};


export type QueryProductsCountArgs = {
  input?: InputMaybe<ProductsQueryInput>;
};


export type QueryProductsCountMetaArgs = {
  input?: InputMaybe<ProductsQueryInputMeta>;
};


export type QueryProductsMetaArgs = {
  input?: InputMaybe<ProductsQueryInputMeta>;
};


export type QueryProductsMetaExtractArgs = {
  input?: InputMaybe<ProductsQueryInputMeta>;
};


export type QueryProductsNeedingReviewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProfileByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProfilesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublishedProduct3DLibraryFiltersArgs = {
  origin?: InputMaybe<Product3DLibraryOrigin>;
};


export type QueryRecentNewsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoomsMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QueryScanRoomElementsArgs = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  dilate?: InputMaybe<Scalars['Int']['input']>;
  granuality?: InputMaybe<Scalars['Int']['input']>;
  image_max_size?: InputMaybe<Scalars['Int']['input']>;
  mask_max_size?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};


export type QuerySearchDebugHistoryArgs = {
  filter?: InputMaybe<SearchDebugHistoryFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SearchDebugHistorySort>;
};


export type QuerySearchDebugSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchHistoriesArgs = {
  input?: InputMaybe<SearchHistoriesQueryInput>;
};


export type QuerySearchSuggestionsArgs = {
  input: SearchSuggestionsInput;
};


export type QuerySearchSuggestionsExtendedArgs = {
  input: SearchSuggestionsExtendedInput;
};


export type QueryShapesMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QueryShareBoardByIdArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  shareBoardId: Scalars['String']['input'];
  shareDocumentId: Scalars['String']['input'];
};


export type QueryShareDocumentByIdArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryShareDocumentHeaderArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryStylesMetaArgs = {
  input?: InputMaybe<WhichMeta>;
};


export type QuerySupplierByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySupplierStatsArgs = {
  input?: InputMaybe<SupplierStatsQueryInput>;
};


export type QuerySuppliersArgs = {
  categoriesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterQuotableSuppliers?: InputMaybe<Scalars['Boolean']['input']>;
  onlyListedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  onlyQuotable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupportChatSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupportChatSessionsArgs = {
  input: SupportChatSessionsInput;
};


export type QuerySurfaceByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySurfaceCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QuerySurfacesArgs = {
  input?: InputMaybe<SurfacesQueryInput>;
};


export type QueryUsageInsightsArgs = {
  input: UsageInsightsInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDocumentsArgs = {
  input?: InputMaybe<UserDocumentsQueryInput>;
};


export type QueryUserDocumentsMergedArgs = {
  itemType?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  skip: Scalars['Int']['input'];
};


export type QueryUserExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserFavoriteProductsArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserItemsArgs = {
  input?: InputMaybe<UserItemsQueryInput>;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UsersQueryInput>;
};


export type QueryUsersExportsArgs = {
  input?: InputMaybe<UsersQueryInput>;
};


export type QueryUsersSummaryArgs = {
  rangeDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateLinkAccessArgs = {
  key: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type QueryOptions = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};

export type RateLimitConfig = {
  __typename?: 'RateLimitConfig';
  documentsPerRequest: Scalars['Int']['output'];
  requestsPerMinute: Scalars['Int']['output'];
  tokensPerMinute: Scalars['Int']['output'];
};

export type RateLimitConfigInput = {
  documentsPerRequest: Scalars['Int']['input'];
  requestsPerMinute: Scalars['Int']['input'];
  tokensPerMinute: Scalars['Int']['input'];
};

export type ReindexJob = {
  __typename?: 'ReindexJob';
  auditLog: Array<JobAuditLogEntry>;
  collection: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  config: JobConfig;
  configuration: JobConfiguration;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  failures: Array<JobFailure>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  performance: JobPerformance;
  profileId: Scalars['String']['output'];
  progress: JobProgress;
  resumedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ReindexJobStatus;
  targetIndex: Scalars['String']['output'];
  throughput?: Maybe<ThroughputStats>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  vectorProfile: VectorProfile;
  workerId?: Maybe<Scalars['String']['output']>;
};

export type ReindexJobInput = {
  collection: Scalars['String']['input'];
  configuration: JobConfigurationInput;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  targetIndex: Scalars['String']['input'];
  vectorProfileId: Scalars['String']['input'];
};

export type ReindexJobResponse = {
  __typename?: 'ReindexJobResponse';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  collection: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  config: JobConfig;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  failures?: Maybe<Array<JobFailure>>;
  id: Scalars['ID']['output'];
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  profileId: Scalars['String']['output'];
  progress: JobProgress;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatus;
  targetIndex: Scalars['String']['output'];
  throughput?: Maybe<ThroughputStats>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export enum ReindexJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type ReplacementApplied = {
  __typename?: 'ReplacementApplied';
  listName: Scalars['String']['output'];
  original: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  replacement: Scalars['String']['output'];
};

export type ReplacementAppliedInput = {
  count: Scalars['Int']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type ReplacementList = {
  __typename?: 'ReplacementList';
  audit: AuditInfo;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  metadata: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  rules: Array<ReplacementRule>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usage: ReplacementListUsage;
  vectorProfile: VectorProfile;
};

export type ReplacementListInput = {
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<ReplacementRuleInput>;
  vectorProfileId: Scalars['String']['input'];
};

export type ReplacementListResponse = {
  __typename?: 'ReplacementListResponse';
  audit: AuditInfo;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profile: VectorProfile;
  rules: Array<ReplacementRule>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReplacementListUsage = {
  __typename?: 'ReplacementListUsage';
  lastUsed: Scalars['DateTime']['output'];
  totalReplacements: Scalars['Int']['output'];
};

export type ReplacementRule = {
  __typename?: 'ReplacementRule';
  caseSensitive: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  regex: Scalars['Boolean']['output'];
  to: Scalars['String']['output'];
};

export type ReplacementRuleInput = {
  caseSensitive: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  regex: Scalars['Boolean']['input'];
  to: Scalars['String']['input'];
};

export type RerankerConfig = {
  __typename?: 'RerankerConfig';
  enabled: Scalars['Boolean']['output'];
  fieldOrder?: Maybe<Array<Scalars['String']['output']>>;
  fields?: Maybe<Array<RerankerField>>;
  model?: Maybe<Scalars['String']['output']>;
  parameters: Scalars['JSONObject']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  textField?: Maybe<Scalars['String']['output']>;
  topK?: Maybe<Scalars['Int']['output']>;
};

export type RerankerConfigInput = {
  enabled: Scalars['Boolean']['input'];
  fieldOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  fields?: InputMaybe<Array<RerankerFieldInput>>;
  model?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSONObject']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  textField?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['Int']['input']>;
};

export type RerankerField = {
  __typename?: 'RerankerField';
  boost: Scalars['Float']['output'];
  path: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export type RerankerFieldInput = {
  boost: Scalars['Float']['input'];
  path: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  weight: Scalars['Float']['input'];
};

export type RerankerModel = {
  __typename?: 'RerankerModel';
  costPer1kDocuments: Scalars['Float']['output'];
  features: Array<Scalars['String']['output']>;
  maxDocuments: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  supportedLanguages: Array<Scalars['String']['output']>;
};

export type RerankerModelInput = {
  costPer1kDocuments: Scalars['Float']['input'];
  features: Array<Scalars['String']['input']>;
  maxDocuments: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  supportedLanguages: Array<Scalars['String']['input']>;
};

export type RerankerProvider = {
  __typename?: 'RerankerProvider';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSONObject']['output'];
  health: ProviderHealth;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  models: Array<RerankerModel>;
  name: Scalars['String']['output'];
  rateLimit: RateLimitConfig;
  status: ProviderStatus;
  type: RerankerProviderType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  usage: RerankerUsage;
  version: Scalars['Int']['output'];
};

export type RerankerProviderInput = {
  authSecretKeyRef: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  headers: Scalars['JSONObject']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  models: Array<RerankerModelInput>;
  name: Scalars['String']['input'];
  rateLimit: RateLimitConfigInput;
  type: RerankerProviderType;
};

export type RerankerProviderResponse = {
  __typename?: 'RerankerProviderResponse';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  models: Array<Scalars['String']['output']>;
  rateLimit?: Maybe<RateLimitConfig>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum RerankerProviderType {
  Cohere = 'COHERE',
  Custom = 'CUSTOM',
  Voyageai = 'VOYAGEAI'
}

export type RerankerProvidersResponse = {
  __typename?: 'RerankerProvidersResponse';
  authSecretKeyRef: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  models: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rateLimit?: Maybe<RateLimitConfig>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RerankerUsage = {
  __typename?: 'RerankerUsage';
  failedRequests: Scalars['Int']['output'];
  lastRequest: Scalars['DateTime']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalRequests: Scalars['Int']['output'];
};

export type ReviewBusinessApplicationInput = {
  id: Scalars['ID']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  status: ApplicationStatus;
};

export type ReviewBusinessProfileInput = {
  id: Scalars['ID']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  status: ApplicationStatus;
};

export type Room = {
  __typename?: 'Room';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RoomElements = {
  __typename?: 'RoomElements';
  height?: Maybe<Scalars['Int']['output']>;
  segments?: Maybe<Array<Maybe<RoomElementsDataType>>>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type RoomElementsDataType = {
  __typename?: 'RoomElementsDataType';
  name?: Maybe<Scalars['String']['output']>;
  projectiveBottomLeft?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  projectiveBottomRight?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  projectiveTopLeft?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  projectiveTopRight?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  svgs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RoomElementsInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Array<InputMaybe<RoomElementsInputDataType>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type RoomElementsInputDataType = {
  name?: InputMaybe<Scalars['String']['input']>;
  projectiveBottomLeft?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  projectiveBottomRight?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  projectiveTopLeft?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  projectiveTopRight?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  svgs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RoomElementsMutationInput = {
  roomElements: RoomElementsInput;
  surfaceId: Scalars['String']['input'];
};

export type ScanRoomElementsResponse = {
  __typename?: 'ScanRoomElementsResponse';
  error: Scalars['String']['output'];
  svg: Array<Maybe<Scalars['String']['output']>>;
};

export type SearchConfig = {
  __typename?: 'SearchConfig';
  k: Scalars['Int']['output'];
  numCandidates: Scalars['Int']['output'];
  preFilter: Scalars['JSONObject']['output'];
  returnFields: Array<Scalars['String']['output']>;
  scoreThreshold?: Maybe<Scalars['Float']['output']>;
};

export type SearchConfigInput = {
  k: Scalars['Int']['input'];
  numCandidates: Scalars['Int']['input'];
  preFilter: Scalars['JSONObject']['input'];
  returnFields: Array<Scalars['String']['input']>;
  scoreThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchContext = {
  __typename?: 'SearchContext';
  collectionUsed: Scalars['String']['output'];
  embeddingDimension: Scalars['Int']['output'];
  embeddingModel: Scalars['String']['output'];
  embeddingProvider: Scalars['String']['output'];
  indexUsed: Scalars['String']['output'];
  profileUsed: Scalars['String']['output'];
  rerankerEnabled: Scalars['Boolean']['output'];
  rerankerModel?: Maybe<Scalars['String']['output']>;
  rerankerProvider?: Maybe<Scalars['String']['output']>;
};

export type SearchDebugComment = {
  __typename?: 'SearchDebugComment';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type SearchDebugConfig = {
  __typename?: 'SearchDebugConfig';
  embedding: EmbeddingConfig;
  k: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  numCandidates: Scalars['Int']['output'];
  rerank: Scalars['Boolean']['output'];
  reranker: RerankerConfig;
  scoreThreshold: Scalars['Float']['output'];
  search: SearchConfig;
};

export type SearchDebugConfigInput = {
  embedding: EmbeddingConfigInput;
  k: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  numCandidates: Scalars['Int']['input'];
  rerank: Scalars['Boolean']['input'];
  reranker: RerankerConfigInput;
  scoreThreshold: Scalars['Float']['input'];
  search: SearchConfigInput;
};

export type SearchDebugHistory = {
  __typename?: 'SearchDebugHistory';
  audit: AuditMetadata;
  comments?: Maybe<Array<SearchDebugComment>>;
  config: SearchDebugConfig;
  createdAt: Scalars['DateTime']['output'];
  favorite?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  preFilters?: Maybe<Scalars['JSON']['output']>;
  profileId: Scalars['ID']['output'];
  profileName: Scalars['String']['output'];
  queryText: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  results: SearchDebugResults;
  saved?: Maybe<Scalars['Boolean']['output']>;
  sessionId: Scalars['String']['output'];
  shareToken?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchDebugHistoryFilter = {
  dateRange?: InputMaybe<DateRangeInput>;
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  profileId?: InputMaybe<Scalars['ID']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchDebugHistoryResponse = {
  __typename?: 'SearchDebugHistoryResponse';
  items: Array<SearchDebugHistory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SearchDebugHistorySort = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export type SearchDebugInput = {
  includeReranking?: InputMaybe<Scalars['Boolean']['input']>;
  k?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numCandidates?: InputMaybe<Scalars['Int']['input']>;
  preFilters?: InputMaybe<Scalars['JSON']['input']>;
  profileId: Scalars['String']['input'];
  query: Scalars['String']['input'];
  scoreThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchDebugMetadata = {
  __typename?: 'SearchDebugMetadata';
  actualK: Scalars['Int']['output'];
  index: Scalars['String']['output'];
  numCandidates: Scalars['Int']['output'];
};

export type SearchDebugMetadataInput = {
  actualK: Scalars['Int']['input'];
  index: Scalars['String']['input'];
  numCandidates: Scalars['Int']['input'];
};

export type SearchDebugQuery = {
  __typename?: 'SearchDebugQuery';
  embedding: EmbeddingInfo;
  finalProcessedText: Scalars['String']['output'];
  originalText: Scalars['String']['output'];
  processedText: Scalars['String']['output'];
  replacementsApplied: Array<ReplacementApplied>;
  textProcessing: TextProcessingInfo;
  translationInfo?: Maybe<TranslationInfo>;
};

export type SearchDebugQueryInput = {
  embedding: EmbeddingInfoInput;
  processedText: Scalars['String']['input'];
  replacementsApplied: Array<ReplacementAppliedInput>;
};

export type SearchDebugResults = {
  __typename?: 'SearchDebugResults';
  metadata: SearchDebugMetadata;
  query: SearchDebugQuery;
  rawResults: Array<SearchResult>;
  rerankedResults?: Maybe<Array<SearchResult>>;
  timing: SearchDebugTiming;
};

export type SearchDebugResultsInput = {
  metadata: SearchDebugMetadataInput;
  query: SearchDebugQueryInput;
  rawResults: Array<SearchResultInput>;
  rerankedResults?: InputMaybe<Array<SearchResultInput>>;
  timing: SearchDebugTimingInput;
};

export type SearchDebugSession = {
  __typename?: 'SearchDebugSession';
  audit: AuditMetadata;
  comments?: Maybe<Array<SearchDebugComment>>;
  config: SearchDebugConfig;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  preFilters?: Maybe<Scalars['JSON']['output']>;
  profileId: Scalars['ID']['output'];
  profileName: Scalars['String']['output'];
  queryText: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  results: SearchDebugResults;
  saved?: Maybe<Scalars['Boolean']['output']>;
  sessionId: Scalars['String']['output'];
  shareToken?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchDebugStats = {
  __typename?: 'SearchDebugStats';
  averageRating: Scalars['Float']['output'];
  recentActivity: Array<ActivityStats>;
  savedSessions: Scalars['Int']['output'];
  topProfiles: Array<ProfileUsageStats>;
  topTags: Array<TagUsageStats>;
  totalSessions: Scalars['Int']['output'];
};

export type SearchDebugTiming = {
  __typename?: 'SearchDebugTiming';
  embedding: Scalars['Float']['output'];
  reranking: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  vectorSearch: Scalars['Float']['output'];
};

export type SearchDebugTimingInput = {
  embedding: Scalars['Float']['input'];
  reranking: Scalars['Float']['input'];
  total: Scalars['Float']['input'];
  vectorSearch: Scalars['Float']['input'];
};

export type SearchHistoriesQueryInput = {
  limit: Scalars['Int']['input'];
  moreCategories: Scalars['Boolean']['input'];
  skip: Scalars['Int']['input'];
};

export type SearchHistoriesResponse = {
  __typename?: 'SearchHistoriesResponse';
  data?: Maybe<Array<SearchHistory>>;
  totalSearchHistories?: Maybe<Scalars['Int']['output']>;
};

export type SearchHistory = {
  __typename?: 'SearchHistory';
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categories?: Maybe<Array<Maybe<CategoryMeta>>>;
  colors?: Maybe<Array<Maybe<CategoryMeta>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  materials?: Maybe<Array<Maybe<CategoryMeta>>>;
  patterns?: Maybe<Array<Maybe<CategoryMeta>>>;
  priceRange?: Maybe<Scalars['JSONObject']['output']>;
  rooms?: Maybe<Array<Maybe<CategoryMeta>>>;
  searchPhrase?: Maybe<Scalars['String']['output']>;
  shapes?: Maybe<Array<Maybe<CategoryMeta>>>;
  styles?: Maybe<Array<Maybe<CategoryMeta>>>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  user: User;
};

export type SearchHistoryInput = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  materials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patterns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceRange?: InputMaybe<Scalars['JSONObject']['input']>;
  rooms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchPhrase?: InputMaybe<Scalars['String']['input']>;
  shapes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  styles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SearchIndexStats = {
  __typename?: 'SearchIndexStats';
  actualK: Scalars['Int']['output'];
  avgVectorDistance: Scalars['Float']['output'];
  documentsSearched: Scalars['Int']['output'];
  numCandidates: Scalars['Int']['output'];
  searchMethod: Scalars['String']['output'];
};

export type SearchInstructions = {
  __typename?: 'SearchInstructions';
  brandFilter?: Maybe<Scalars['String']['output']>;
  categoryFilter?: Maybe<Scalars['String']['output']>;
  fullTextSearch: Scalars['String']['output'];
  searchQuery: Scalars['String']['output'];
  searchType: Scalars['String']['output'];
  supplierFilter?: Maybe<Scalars['String']['output']>;
};

export type SearchInstructionsInput = {
  brandFilter?: InputMaybe<Scalars['String']['input']>;
  categoryFilter?: InputMaybe<Scalars['String']['input']>;
  fullTextSearch?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierFilter?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPerformanceStats = {
  __typename?: 'SearchPerformanceStats';
  averageDuration: Scalars['Int']['output'];
  recentSlowQueries: Array<SlowQueryEntry>;
  slowestQueries: Array<SlowQueryEntry>;
  timeoutQueries: Scalars['Int']['output'];
  totalSlowQueries: Scalars['Int']['output'];
};

export type SearchPerformanceStatsResponse = {
  __typename?: 'SearchPerformanceStatsResponse';
  error?: Maybe<Scalars['String']['output']>;
  recommendations: Array<Scalars['String']['output']>;
  stats?: Maybe<SearchPerformanceStats>;
  success: Scalars['Boolean']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  _id: Scalars['ID']['output'];
  document: Scalars['JSON']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
};

export type SearchResultInput = {
  _id: Scalars['ID']['input'];
  document: Scalars['JSON']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
  score: Scalars['Float']['input'];
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  searchInstructions?: Maybe<SearchInstructions>;
  type: SearchSuggestionType;
};

export enum SearchSuggestionType {
  Brand = 'BRAND',
  Category = 'CATEGORY',
  FullTextSearch = 'FULL_TEXT_SEARCH',
  Popular = 'POPULAR',
  Product = 'PRODUCT',
  Retailer = 'RETAILER'
}

export type SearchSuggestionsExtendedInput = {
  existingFilters?: InputMaybe<ExistingFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  searchType?: InputMaybe<SearchType>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchSuggestionsExtendedResponse = {
  __typename?: 'SearchSuggestionsExtendedResponse';
  error?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  isLoading: Scalars['Boolean']['output'];
  pageInfo: PageInfo;
  suggestions: Array<SearchSuggestion>;
  totalCount: Scalars['Int']['output'];
};

export type SearchSuggestionsInput = {
  existingFilters?: InputMaybe<ExistingFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  useAI?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchSuggestionsResponse = {
  __typename?: 'SearchSuggestionsResponse';
  error?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  isLoading: Scalars['Boolean']['output'];
  suggestions: Array<SearchSuggestion>;
  totalCount: Scalars['Int']['output'];
};

export type SearchTestResponse = {
  __typename?: 'SearchTestResponse';
  error?: Maybe<Scalars['String']['output']>;
  logs: Array<TestLogEntry>;
  query: Scalars['String']['output'];
  results: Array<SearchTestResult>;
  success: Scalars['Boolean']['output'];
  summary?: Maybe<SearchTestSummary>;
};

export type SearchTestResult = {
  __typename?: 'SearchTestResult';
  document: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  matchedFields: Array<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  processingTime?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type SearchTestSummary = {
  __typename?: 'SearchTestSummary';
  embeddingDimension?: Maybe<Scalars['Int']['output']>;
  embeddingProvider?: Maybe<Scalars['String']['output']>;
  embeddingTime: Scalars['Int']['output'];
  indexStats?: Maybe<SearchIndexStats>;
  model?: Maybe<Scalars['String']['output']>;
  rerankTime?: Maybe<Scalars['Int']['output']>;
  rerankerModel?: Maybe<Scalars['String']['output']>;
  rerankerProvider?: Maybe<Scalars['String']['output']>;
  searchTime: Scalars['Int']['output'];
  totalResults: Scalars['Int']['output'];
  totalTime: Scalars['Int']['output'];
  vectorSearchTime: Scalars['Int']['output'];
};

export enum SearchType {
  All = 'ALL',
  BrandsOnly = 'BRANDS_ONLY',
  CategoriesOnly = 'CATEGORIES_ONLY',
  ProductsOnly = 'PRODUCTS_ONLY',
  RetailersOnly = 'RETAILERS_ONLY'
}

export type SearchUsageTopPhrase = {
  __typename?: 'SearchUsageTopPhrase';
  count: Scalars['Int']['output'];
  phrase: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  user?: Maybe<User>;
};

export type SetupStatusInput = {
  createdFirstProject?: InputMaybe<Scalars['Boolean']['input']>;
  introVideoWatched?: InputMaybe<Scalars['Boolean']['input']>;
  visitedExampleFloorplan?: InputMaybe<Scalars['Boolean']['input']>;
  visitedExampleProject?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetupStatusResponse = {
  __typename?: 'SetupStatusResponse';
  createdFirstProject?: Maybe<Scalars['Boolean']['output']>;
  introVideoWatched?: Maybe<Scalars['Boolean']['output']>;
  visitedExampleFloorplan?: Maybe<Scalars['Boolean']['output']>;
  visitedExampleProject?: Maybe<Scalars['Boolean']['output']>;
};

export type Shape = {
  __typename?: 'Shape';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ShareBoard = {
  __typename?: 'ShareBoard';
  createdBy: User;
  height?: Maybe<Scalars['Int']['output']>;
  hideProductList?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  json?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<MoodBoardNote>>;
  paints?: Maybe<Array<MoodboardPaint>>;
  proItems?: Maybe<Array<MoodboardProItem>>;
  proSettings?: Maybe<BoardProSettings>;
  products?: Maybe<Array<MoodboardProduct>>;
  sourceMoodBoardId?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ShareDocument = {
  __typename?: 'ShareDocument';
  checkedNotes: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: User;
  currency?: Maybe<Scalars['String']['output']>;
  finalComments: Array<MoodBoardNote>;
  /**
   * When true, the client share view hides board images/notes but still loads
   * boards so the product list can be rebuilt from them.
   */
  hideMoodBoards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  moodBoards?: Maybe<Array<ShareBoard>>;
  name?: Maybe<Scalars['String']['output']>;
  priceListSelections: Array<SharePriceListSelection>;
  priceListState?: Maybe<Scalars['String']['output']>;
  /** Distinct recipient emails this shareproject has been sent to. */
  recipientEmails: Array<Scalars['String']['output']>;
};

export type ShareDocumentListItem = {
  __typename?: 'ShareDocumentListItem';
  checkedNotes?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Distinct recipient emails this shareproject has been sent to. */
  recipientEmails: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SharePriceListSelection = {
  __typename?: 'SharePriceListSelection';
  moodBoardProductId: Scalars['ID']['output'];
  shareBoardId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  value: SharePriceListSelectionValue;
};

export enum SharePriceListSelectionValue {
  Maybe = 'MAYBE',
  No = 'NO',
  Yes = 'YES'
}

/** Details of a slow query */
export type SlowQuery = {
  __typename?: 'SlowQuery';
  /** Duration in milliseconds */
  duration: Scalars['Int']['output'];
  /** Error type if the query failed (e.g., 'TIMEOUT') */
  error?: Maybe<Scalars['String']['output']>;
  /** Additional metadata as JSON string */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Type of operation (e.g., 'product-suggestions', 'category-suggestions') */
  operation: Scalars['String']['output'];
  /** The search query that was slow */
  query: Scalars['String']['output'];
  /** When the query occurred (ISO timestamp) */
  timestamp: Scalars['String']['output'];
};

export type SlowQueryEntry = {
  __typename?: 'SlowQueryEntry';
  duration: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  operation: Scalars['String']['output'];
  query: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export enum SortOption {
  Name = 'name',
  PriceHigh = 'priceHigh',
  PriceLow = 'priceLow',
  UpdatedAt = 'updatedAt'
}

export type StartFloorplanImageImportInput = {
  calibration?: InputMaybe<FloorplanImportCalibrationInput>;
  floorplanId?: InputMaybe<Scalars['ID']['input']>;
  mode: FloorplanImageImportMode;
  name: Scalars['String']['input'];
  symbolCatalog: Array<FloorplanImportSymbolCatalogEntryInput>;
};

export type Style = {
  __typename?: 'Style';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  documentLockChanged: DocumentLockEvent;
  documentUpdated: DocumentUpdatedEvent;
  floorplanCollabChanged: FloorplanCollabEvent;
  moodBoardLockChanged?: Maybe<MoodBoardLockEvent>;
  moodBoardUpdated: MoodBoardUpdatedEvent;
  orderChanged: OrderChanged;
  priceListStateChanged: PriceListStateChangedEvent;
  userChanged?: Maybe<SubscriptionResult>;
};


export type SubscriptionDocumentLockChangedArgs = {
  documentId: Scalars['ID']['input'];
};


export type SubscriptionDocumentUpdatedArgs = {
  documentId: Scalars['ID']['input'];
};


export type SubscriptionFloorplanCollabChangedArgs = {
  floorplanId: Scalars['String']['input'];
};


export type SubscriptionMoodBoardLockChangedArgs = {
  documentId: Scalars['ID']['input'];
};


export type SubscriptionMoodBoardUpdatedArgs = {
  documentId: Scalars['ID']['input'];
};


export type SubscriptionPriceListStateChangedArgs = {
  documentId: Scalars['ID']['input'];
};

export type SubscriptionResult = {
  __typename?: 'SubscriptionResult';
  id?: Maybe<Scalars['String']['output']>;
};

export enum SuggestionActionType {
  AppliedFilter = 'APPLIED_FILTER',
  Clicked = 'CLICKED',
  Ignored = 'IGNORED'
}

export type SuggestionInteractionRow = {
  __typename?: 'SuggestionInteractionRow';
  actionType: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  suggestionType: Scalars['String']['output'];
};

export type SuggestionInteractionsByPeriod = {
  __typename?: 'SuggestionInteractionsByPeriod';
  label: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
  rows: Array<SuggestionInteractionRow>;
};

export type Supplier = {
  __typename?: 'Supplier';
  UTMTag?: Maybe<Scalars['String']['output']>;
  affiliate?: Maybe<Affiliate>;
  affiliateUrl?: Maybe<Scalars['String']['output']>;
  /**
   * AI Category Scope - limits the category tree used for AI categorization.
   * When null/undefined, the full category tree is used.
   * rootIds = CategoryMeta IDs for root-level categories (Furniture, Lighting, etc.)
   */
  aiCategoryScope?: Maybe<Scalars['JSON']['output']>;
  brandContact?: Maybe<Scalars['String']['output']>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  calculateToExcludeVAT?: Maybe<Scalars['Boolean']['output']>;
  calculateToIncludeVAT?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountInformation?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  discountRules?: Maybe<Array<DiscountRule>>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  importAllTypes?: Maybe<Scalars['Boolean']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isParsing?: Maybe<Scalars['Boolean']['output']>;
  isQuotable?: Maybe<Scalars['Boolean']['output']>;
  lastFeedHealthCheck?: Maybe<Scalars['JSON']['output']>;
  lastParsed?: Maybe<Scalars['DateTime']['output']>;
  lastParsedCategory?: Maybe<Scalars['DateTime']['output']>;
  lastParsedColor?: Maybe<Scalars['DateTime']['output']>;
  lastParsedRemoveAi?: Maybe<Scalars['DateTime']['output']>;
  lastParsedUtm?: Maybe<Scalars['DateTime']['output']>;
  lastParserSummary?: Maybe<Scalars['JSON']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parserAcceptedCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parserAction?: Maybe<Scalars['String']['output']>;
  parserCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parserKeepBG?: Maybe<Scalars['Boolean']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Product>>;
  purchaseTerms?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use discountRules instead */
  quoteDiscount?: Maybe<Scalars['Float']['output']>;
  requiresQuoteAccess?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SupplierInput = {
  UTMTag?: InputMaybe<Scalars['String']['input']>;
  affiliate?: InputMaybe<Scalars['ID']['input']>;
  affiliateUrl?: InputMaybe<Scalars['String']['input']>;
  aiCategoryScope?: InputMaybe<Scalars['JSON']['input']>;
  brandContact?: InputMaybe<Scalars['String']['input']>;
  brandDescription?: InputMaybe<Scalars['String']['input']>;
  calculateToExcludeVAT?: InputMaybe<Scalars['Boolean']['input']>;
  calculateToIncludeVAT?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountInformation?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountRules?: InputMaybe<Array<DiscountRuleInput>>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  importAllTypes?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isQuotable?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  parserKeepBG?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  purchaseTerms?: InputMaybe<Scalars['String']['input']>;
  quoteDiscount?: InputMaybe<Scalars['Float']['input']>;
  requiresQuoteAccess?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierResponseInput = {
  notes?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['ID']['input'];
  status: OrderStatus;
};

export type SupplierStats = {
  __typename?: 'SupplierStats';
  supplier?: Maybe<Supplier>;
  totalActiveProducts: Scalars['Int']['output'];
  totalExpiredProducts: Scalars['Int']['output'];
  totalHiddenProducts: Scalars['Int']['output'];
  totalParsedProducts: Scalars['Int']['output'];
  totalProducts: Scalars['Int']['output'];
};

export type SupplierStatsQueryInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  sortBy: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type SupplierStatsResponse = {
  __typename?: 'SupplierStatsResponse';
  supplierStats?: Maybe<Array<SupplierStats>>;
  totalStats: SupplierStats;
  totalSuppliers: Scalars['Int']['output'];
};

/** FAQ item: starter question for support chat, and answer for the FAQ page. */
export type SupportChatFaq = {
  __typename?: 'SupportChatFaq';
  /** Short markdown answer for the FAQ page accordion. */
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type SupportChatMessageInput = {
  content: Scalars['String']['input'];
  role: SupportChatRole;
};

/** Compact product card returned when the support bot searches the catalog. */
export type SupportChatProduct = {
  __typename?: 'SupportChatProduct';
  brand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupportChatReply = {
  __typename?: 'SupportChatReply';
  /**
   * Top catalog matches when the user asked a product-library question.
   * Empty/null for normal help answers.
   */
  products?: Maybe<Array<SupportChatProduct>>;
  reply: Scalars['String']['output'];
  /** Exact catalog brand names applied to the product search (for Products deep-link). */
  resolvedBrands?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Search query used for catalog results (useful for “see more” links).
   * Product criteria only — brand filters are in resolvedBrands.
   */
  searchQuery?: Maybe<Scalars['String']['output']>;
  /** Persistent conversation id for admin history. Pass back on the next askSupportBot call. */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /**
   * Brand names the user asked about that were not found in the catalog
   * (for deep-linking into Products even when the brand is unknown).
   */
  unresolvedBrandHints?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SupportChatRole {
  Assistant = 'assistant',
  User = 'user'
}

/** Admin: one support chat conversation thread. */
export type SupportChatSession = {
  __typename?: 'SupportChatSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastIntent?: Maybe<Scalars['String']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  lastUserMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type SupportChatSessionDetail = {
  __typename?: 'SupportChatSessionDetail';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastIntent?: Maybe<Scalars['String']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  lastUserMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  messages: Array<SupportChatStoredMessage>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type SupportChatSessionsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type SupportChatSessionsResponse = {
  __typename?: 'SupportChatSessionsResponse';
  data: Array<SupportChatSession>;
  total: Scalars['Int']['output'];
};

/** Admin: a single stored support chat message. */
export type SupportChatStoredMessage = {
  __typename?: 'SupportChatStoredMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Scalars['ID']['output']>>;
  resolvedBrands?: Maybe<Array<Scalars['String']['output']>>;
  role: SupportChatRole;
  searchQuery?: Maybe<Scalars['String']['output']>;
};

export type Surface = {
  __typename?: 'Surface';
  categories?: Maybe<Array<Maybe<SurfaceCategory>>>;
  colors?: Maybe<Array<Maybe<Color>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** Optional UV repeat scale for catalog albedo. */
  repeatScale?: Maybe<Scalars['Float']['output']>;
  roomElements?: Maybe<RoomElements>;
  /** Optional floorplanner PBR override. Null = use category defaults. */
  roughness?: Maybe<Scalars['Float']['output']>;
  /** Optional cloth sheen (0–1). Null = category default / none. */
  sheen?: Maybe<Scalars['Float']['output']>;
  /** Optional sheen roughness (0–1). */
  sheenRoughness?: Maybe<Scalars['Float']['output']>;
};

export type SurfaceCategory = {
  __typename?: 'SurfaceCategory';
  children?: Maybe<Array<Maybe<SurfaceCategory>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<SurfaceCategory>;
};

export type SurfaceCategoryInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type SurfaceEditInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productImage?: InputMaybe<Scalars['Upload']['input']>;
  productImageNoBg?: InputMaybe<Scalars['Upload']['input']>;
  repeatScale?: InputMaybe<Scalars['Float']['input']>;
  /** Pass null to clear and fall back to category defaults. */
  roughness?: InputMaybe<Scalars['Float']['input']>;
  sheen?: InputMaybe<Scalars['Float']['input']>;
  sheenRoughness?: InputMaybe<Scalars['Float']['input']>;
};

export type SurfaceInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
};

export type SurfaceResponse = {
  __typename?: 'SurfaceResponse';
  data?: Maybe<Array<Surface>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum SurfaceType {
  Fabric = 'FABRIC',
  Flooring = 'FLOORING',
  Wallpaper = 'WALLPAPER'
}

export type SurfacesQueryInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  useOrLogic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagUsageStats = {
  __typename?: 'TagUsageStats';
  tag: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type TestDiscountRulesResult = {
  __typename?: 'TestDiscountRulesResult';
  count?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<DiscountRule>>;
  success: Scalars['Boolean']['output'];
};

export type TestLogEntry = {
  __typename?: 'TestLogEntry';
  category: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  level: Scalars['String']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TestReindexResponse = {
  __typename?: 'TestReindexResponse';
  error?: Maybe<Scalars['String']['output']>;
  jobFailures: Array<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  jobProgress?: Maybe<JobProgress>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  logs: Array<TestLogEntry>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  summary?: Maybe<TestSummary>;
};

export type TestSummary = {
  __typename?: 'TestSummary';
  averageProcessingTime: Scalars['Int']['output'];
  embeddingDimension?: Maybe<Scalars['Int']['output']>;
  embeddingProvider?: Maybe<Scalars['String']['output']>;
  failedProducts: Scalars['Int']['output'];
  model?: Maybe<Scalars['String']['output']>;
  processedProducts: Scalars['Int']['output'];
  skippedProducts: Scalars['Int']['output'];
  totalProcessingTime: Scalars['Int']['output'];
  totalProducts: Scalars['Int']['output'];
};

export type TextProcessingInfo = {
  __typename?: 'TextProcessingInfo';
  finalProcessedText: Scalars['String']['output'];
  replacementsApplied: Array<ReplacementApplied>;
};

export type ThroughputStats = {
  __typename?: 'ThroughputStats';
  avgBatchSize?: Maybe<Scalars['Float']['output']>;
  docsPerMin: Scalars['Float']['output'];
  tokensPerSec: Scalars['Float']['output'];
};

export type TokenUsage = {
  __typename?: 'TokenUsage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  user: User;
  userItem?: Maybe<UserItem>;
};

export type TokensResponse = {
  __typename?: 'TokensResponse';
  accessToken?: Maybe<Scalars['Token']['output']>;
  refreshToken?: Maybe<Scalars['Token']['output']>;
};

export type TrackSuggestionInteractionInput = {
  actionType: SuggestionActionType;
  originalQuery: Scalars['String']['input'];
  suggestionId: Scalars['String']['input'];
  suggestionLabel: Scalars['String']['input'];
  suggestionType: Scalars['String']['input'];
};

export type TransformImageWithPromptResult = {
  __typename?: 'TransformImageWithPromptResult';
  imageUrl: Scalars['String']['output'];
};

export type TranslationConfig = {
  __typename?: 'TranslationConfig';
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  targetLanguage?: Maybe<Scalars['String']['output']>;
};

export type TranslationConfigInput = {
  enabled: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationInfo = {
  __typename?: 'TranslationInfo';
  confidence?: Maybe<Scalars['Float']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  translatedText?: Maybe<Scalars['String']['output']>;
};

export type TranslationInput = {
  to: Scalars['String']['input'];
  words: Array<Scalars['String']['input']>;
};

export type TranslationResponse = {
  __typename?: 'TranslationResponse';
  words: Array<Scalars['String']['output']>;
};

export type UpdateBasketItemInput = {
  clientPrice?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  itemId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  retailPrice?: InputMaybe<Scalars['Float']['input']>;
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
  vatIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBrandOrderInput = {
  actualDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedDelivery?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  orderChannel?: InputMaybe<OrderChannel>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingDescription?: InputMaybe<Scalars['String']['input']>;
  sourceSupplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OrderStatus>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  vatIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBrandReplacementInput = {
  correctName?: InputMaybe<Scalars['String']['input']>;
  misspelling?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessProfileInput = {
  billingAddress?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<AddressInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnterpriseInput = {
  billingCycleAnchorDay?: InputMaybe<Scalars['Int']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<EnterpriseFeatureFlagsInput>;
  id: Scalars['ID']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<EnterpriseLimitsInput>;
  maxActiveUsers?: InputMaybe<Scalars['Int']['input']>;
  monthlyAiCreditLimit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnterpriseStatus>;
};

export type UpdateOrderInput = {
  formData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  status?: InputMaybe<OrderStatus>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderItemInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  clientPrice?: InputMaybe<Scalars['Float']['input']>;
  clientReferenceId?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  markup?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['JSON']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  retailPrice?: InputMaybe<Scalars['Float']['input']>;
  tradePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrderWithBrandInput = {
  brandName: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  updates: OrderUpdateInput;
};

export type UpdateParentOrderInput = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
};

export type UpdateProductEmbeddingInput = {
  apiKey: Scalars['String']['input'];
  collection: Scalars['String']['input'];
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductEmbeddingResponse = {
  __typename?: 'UpdateProductEmbeddingResponse';
  embeddingGenerated?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  processingTime?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSearchDebugHistoryInput = {
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSetupStatusInput = {
  createdFirstProject?: InputMaybe<Scalars['Boolean']['input']>;
  introVideoWatched?: InputMaybe<Scalars['Boolean']['input']>;
  visitedExampleFloorplan?: InputMaybe<Scalars['Boolean']['input']>;
  visitedExampleProject?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShareDocumentPriceListSelectionInput = {
  moodBoardProductId: Scalars['ID']['input'];
  shareBoardId: Scalars['ID']['input'];
  shareDocumentId: Scalars['String']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<SharePriceListSelectionValue>;
};

export type UpscaleAiGeneratedImageResult = ProItem | Product | UserItem;

export type UsageCountByPeriod = {
  __typename?: 'UsageCountByPeriod';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type UsageInsights = {
  __typename?: 'UsageInsights';
  aiFeatureUsageByPeriod: Array<AiFeatureUsageByPeriod>;
  from: Scalars['DateTime']['output'];
  granularity: UsageInsightsGranularity;
  moodboardProductSnapshot?: Maybe<Array<MoodboardProductSnapshotRow>>;
  /** Explains that moodboard product rows are a snapshot of current boards, not time-series drag events. */
  moodboardProductSnapshotNote: Scalars['String']['output'];
  /** Aggregated stats focused on users who signed up during the selected period. */
  newUserUsageStats: NewUserUsageStats;
  projectActivityByPeriod: Array<ProjectActivityByPeriod>;
  searchTopPhrases: Array<SearchUsageTopPhrase>;
  searchUsageByPeriod: Array<UsageCountByPeriod>;
  suggestionInteractionsByPeriod: Array<SuggestionInteractionsByPeriod>;
  to: Scalars['DateTime']['output'];
  userSignupsByPeriod: Array<UsageCountByPeriod>;
};

export enum UsageInsightsGranularity {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type UsageInsightsInput = {
  from: Scalars['DateTime']['input'];
  granularity: UsageInsightsGranularity;
  /** When true, scans up to moodboardSnapshotLimit mood boards and ranks product IDs by how often they appear on boards (current state, not historical drags). */
  includeMoodboardProductSnapshot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Caps work for snapshot; default 5000. */
  moodboardSnapshotLimit?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['DateTime']['input'];
};

export type User = {
  __typename?: 'User';
  betaProgram?: Maybe<Array<Scalars['String']['output']>>;
  boardSetting?: Maybe<BoardSetting>;
  company?: Maybe<Scalars['String']['output']>;
  countCustomProducts?: Maybe<Scalars['Int']['output']>;
  countDesigns?: Maybe<Scalars['Int']['output']>;
  countSharedDesigns?: Maybe<Scalars['Int']['output']>;
  countUploadedAIImages?: Maybe<Scalars['Int']['output']>;
  countUploadedImages?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  email?: Maybe<Scalars['String']['output']>;
  enterprise?: Maybe<Enterprise>;
  enterpriseMembership?: Maybe<EnterpriseMembership>;
  entitlements?: Maybe<UserEntitlements>;
  favoriteBoards?: Maybe<Array<GalleryBoard>>;
  favoriteBrands?: Maybe<Array<Scalars['String']['output']>>;
  favoriteCategories?: Maybe<Array<CategoryMeta>>;
  favoriteMaterials?: Maybe<Array<Material>>;
  favoriteProducts?: Maybe<Array<Product>>;
  favoriteProfiles?: Maybe<Array<Profile>>;
  favoriteSuppliers?: Maybe<Array<Supplier>>;
  favoriteSurfaces?: Maybe<Array<Surface>>;
  firstName?: Maybe<Scalars['String']['output']>;
  floorplans?: Maybe<Array<Floorplan>>;
  folders?: Maybe<Array<Folder>>;
  galleryBoards?: Maybe<Array<GalleryBoard>>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeenNewsAt?: Maybe<Scalars['DateTime']['output']>;
  moodBoards?: Maybe<Array<MoodBoard>>;
  phone?: Maybe<Scalars['String']['output']>;
  proItems?: Maybe<Array<ProItem>>;
  profile?: Maybe<Profile>;
  quoteAccess?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<UserRole>;
  setupStatus?: Maybe<SetupStatusResponse>;
  subscription?: Maybe<PaymentSubscription>;
  termsAccepted?: Maybe<Scalars['Boolean']['output']>;
  trialActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  trialEndViewShownAt?: Maybe<Scalars['DateTime']['output']>;
  userItemTags?: Maybe<Array<UserItemTag>>;
  userItems?: Maybe<Array<UserItem>>;
  userName?: Maybe<Scalars['String']['output']>;
  usingBoni?: Maybe<UsingBoniOption>;
  usingRole?: Maybe<UsingRole>;
  verificationLinkEmailedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationLinkShownAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UserFavoriteProductsArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type UserDocumentMergedItem = Document | Floorplan;

export type UserDocumentsMergedResponse = {
  __typename?: 'UserDocumentsMergedResponse';
  items: Array<UserDocumentMergedItem>;
  total: Scalars['Int']['output'];
};

export type UserDocumentsQueryInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type UserDocumentsResponse = {
  __typename?: 'UserDocumentsResponse';
  documents?: Maybe<Array<Document>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UserEntitlements = {
  __typename?: 'UserEntitlements';
  aiCredits: AiCreditEntitlement;
  enterprise?: Maybe<Enterprise>;
  featureFlags: EnterpriseFeatureFlags;
  isActive: Scalars['Boolean']['output'];
  limits: EnterpriseLimits;
  membership?: Maybe<EnterpriseMembership>;
  plan: EntitlementPlan;
};

export type UserItem = {
  __typename?: 'UserItem';
  aiGeneratedImages?: Maybe<Array<UserItemAiImage>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Scalars['ID']['output']>>;
  sourceProductId1?: Maybe<Scalars['ID']['output']>;
  sourceProductId2?: Maybe<Scalars['ID']['output']>;
  sourceProducts?: Maybe<Array<Product>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tokenUsage?: Maybe<TokenUsage>;
  user: User;
  /** AI-generated or uploaded video URLs (e.g. MP4). Poster/thumbnail stays in images. */
  videos?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserItemAiImage = {
  __typename?: 'UserItemAIImage';
  angle: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  imageUrl: Scalars['String']['output'];
  imageUrlNoBg?: Maybe<Scalars['String']['output']>;
  sourceImageUrl: Scalars['String']['output'];
};

export type UserItemTag = {
  __typename?: 'UserItemTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserItemsQueryInput = {
  /**
   * Deprecated: ignored. Upload sharing is controlled by the enterprise
   * `sharedUploads` feature flag (all active enterprise members).
   */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When true, exclude the caller's own items (team libraries only).
   * Ignored when ownerUserId is set.
   */
  excludeCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional array of tags to exclude. Items whose tags contain any of these values are filtered out. */
  excludeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional array of tags to include. Only items whose tags contain all of these values are returned. */
  includeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When false, skip the total count query to improve performance. */
  includeTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  /**
   * Restrict results to items owned by this user. Must be the caller, or another
   * enterprise member whose uploads the caller may access via `sharedUploads`.
   */
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Case-insensitive substring match against the upload's `name`. Trimmed; ignored when empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
};

export type UserItemsResponse = {
  __typename?: 'UserItemsResponse';
  data?: Maybe<Array<UserItem>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UserModel3D = {
  __typename?: 'UserModel3D';
  architectureSymbolKey?: Maybe<Scalars['String']['output']>;
  bounds?: Maybe<UserModel3DBounds>;
  communityListingState: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dimensions?: Maybe<UserModel3DDimensions>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayTitle: Scalars['String']['output'];
  embeddedMetadata?: Maybe<Scalars['JSONObject']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileBytes?: Maybe<Scalars['Int']['output']>;
  firstSharedAt?: Maybe<Scalars['DateTime']['output']>;
  footprintSvg?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCommunityListed: Scalars['Boolean']['output'];
  isPublicFloorplannerAsset: Scalars['Boolean']['output'];
  moderatedAt?: Maybe<Scalars['DateTime']['output']>;
  moderatedByUserId?: Maybe<Scalars['String']['output']>;
  moderationReason?: Maybe<Scalars['String']['output']>;
  moderationState: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optimizedUrl?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  ownerArchivedAt?: Maybe<Scalars['DateTime']['output']>;
  pipelineVersion: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  shareWithCommunity: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  sourceImageUrl?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  textureMaxSize?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  triangleCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Owner account email. Resolved only for admin callers; null otherwise. */
  uploaderEmail?: Maybe<Scalars['String']['output']>;
  uploaderId: Scalars['String']['output'];
  uploaderName: Scalars['String']['output'];
  vertexCount?: Maybe<Scalars['Int']['output']>;
};

export type UserModel3DBounds = {
  __typename?: 'UserModel3DBounds';
  center?: Maybe<Array<Scalars['Float']['output']>>;
  max?: Maybe<Array<Scalars['Float']['output']>>;
  min?: Maybe<Array<Scalars['Float']['output']>>;
  size?: Maybe<UserModel3DDimensions>;
};

export type UserModel3DDimensions = {
  __typename?: 'UserModel3DDimensions';
  depth?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UserModels3DResponse = {
  __typename?: 'UserModels3DResponse';
  data: Array<UserModel3D>;
  total: Scalars['Int']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserSignupInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  urlProps?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  usingBoni?: InputMaybe<UsingBoniOption>;
  usingRole?: InputMaybe<UsingRole>;
};

export type UsersExportResponse = {
  __typename?: 'UsersExportResponse';
  data?: Maybe<Array<User>>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UsersQueryInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
};

export type UsersResponse = {
  __typename?: 'UsersResponse';
  data?: Maybe<Array<User>>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

export type UsersSummary = {
  __typename?: 'UsersSummary';
  recentCount?: Maybe<Scalars['Int']['output']>;
  totalUsers: Scalars['Int']['output'];
};

export enum UsingBoniOption {
  Noanswer = 'NOANSWER',
  Private = 'PRIVATE',
  Professionally = 'PROFESSIONALLY',
  Student = 'STUDENT'
}

export enum UsingRole {
  Interior = 'INTERIOR',
  Interiorarchitect = 'INTERIORARCHITECT',
  Interiordesigner = 'INTERIORDESIGNER',
  Other = 'OTHER',
  PrivateCustomer = 'PRIVATE_CUSTOMER',
  Store = 'STORE',
  Student = 'STUDENT',
  Stylist = 'STYLIST'
}

export type ValidateSession = {
  __typename?: 'ValidateSession';
  email?: Maybe<Scalars['String']['output']>;
  enterprise?: Maybe<Enterprise>;
  enterpriseMembership?: Maybe<EnterpriseMembership>;
  entitlements?: Maybe<UserEntitlements>;
  id: Scalars['ID']['output'];
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  quoteAccess?: Maybe<Scalars['Boolean']['output']>;
  role: UserRole;
  subscription?: Maybe<PaymentSubscription>;
  trialActivatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VectorProfile = {
  __typename?: 'VectorProfile';
  activeIndex: Scalars['String']['output'];
  audit: AuditInfo;
  auditLog: Array<AuditLogEntry>;
  canPerformOperations?: Maybe<Scalars['Boolean']['output']>;
  collection: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  currentJob?: Maybe<ReindexJob>;
  description: Scalars['String']['output'];
  embeddingConfig: EmbeddingConfig;
  embeddingProvider?: Maybe<EmbeddingProvider>;
  id: Scalars['ID']['output'];
  indexVersions: Array<IndexVersion>;
  isDefault: Scalars['Boolean']['output'];
  metadata: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
  reindexJobs: Array<ReindexJob>;
  replacementLists: Array<ReplacementList>;
  rerankerConfig: RerankerConfig;
  rerankerProvider?: Maybe<RerankerProvider>;
  searchConfig: SearchConfig;
  status: VectorProfileStatus;
  syncStatus?: Maybe<Scalars['String']['output']>;
  translationConfig: TranslationConfig;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type VectorProfileInput = {
  activeIndex: Scalars['String']['input'];
  collection: Scalars['String']['input'];
  description: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  embeddingConfig: EmbeddingConfigInput;
  indexes: IndexConfigInput;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  rerankerConfig: RerankerConfigInput;
  searchConfig: SearchConfigInput;
  status?: InputMaybe<VectorProfileStatus>;
  translationConfig: TranslationConfigInput;
};

export type VectorProfileResponse = {
  __typename?: 'VectorProfileResponse';
  activeIndex: Scalars['String']['output'];
  audit: AuditInfo;
  canPerformOperations?: Maybe<Scalars['Boolean']['output']>;
  collection: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentJob?: Maybe<ReindexJob>;
  disabled: Scalars['Boolean']['output'];
  embedding: EmbeddingConfig;
  id: Scalars['ID']['output'];
  indexConfig: IndexConfig;
  indexes: IndexInfo;
  name: Scalars['String']['output'];
  reranker: RerankerConfig;
  search: SearchConfig;
  status: VectorProfileStatus;
  syncStatus?: Maybe<Scalars['String']['output']>;
  translation: TranslationConfig;
  updatedAt: Scalars['DateTime']['output'];
};

export enum VectorProfileStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type VectorSearchDashboard = {
  __typename?: 'VectorSearchDashboard';
  activeIndex?: Maybe<IndexVersionInfo>;
  activeProfile?: Maybe<VectorProfile>;
  providerHealth: Array<ProviderHealthSummary>;
  recentJobs: Array<ReindexJob>;
  stats?: Maybe<DashboardStats>;
};

export type VectorSearchDebugResponse = {
  __typename?: 'VectorSearchDebugResponse';
  explanation: Scalars['String']['output'];
  hybridResults: Array<VectorSearchResult>;
  performance: DebugPerformance;
  profileUsed: VectorProfile;
  query: SearchDebugQuery;
  rawResults: Array<VectorSearchResult>;
  rerankedResults: Array<VectorSearchResult>;
  searchContext: SearchContext;
};

export type VectorSearchResult = {
  __typename?: 'VectorSearchResult';
  _id: Scalars['ID']['output'];
  document: Scalars['JSONObject']['output'];
  matchedFields: Array<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type VisibilityInput = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideBrand?: InputMaybe<Scalars['Boolean']['input']>;
  hideDesc?: InputMaybe<Scalars['Boolean']['input']>;
  hideLink?: InputMaybe<Scalars['Boolean']['input']>;
  hideStorePrice?: InputMaybe<Scalars['Boolean']['input']>;
  hideSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  moodBoardProductId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type WhichMeta = {
  feature?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDocumentsQueryVariables = Exact<{
  input?: InputMaybe<UserDocumentsQueryInput>;
}>;


export type UserDocumentsQuery = { __typename?: 'Query', userDocuments?: { __typename?: 'UserDocumentsResponse', total?: number | null, documents?: Array<{ __typename?: 'Document', id: string, name?: string | null, image?: string | null, updatedAt?: any | null, moodBoards?: Array<{ __typename?: 'MoodBoard', id: string, name?: string | null, image?: string | null, updatedAt?: any | null }> | null }> | null } | null };

export type FloorplannerProduct3DAssetFieldsFragment = { __typename?: 'Product3DAsset', id: string, productId: string, variantId?: string | null, source: string, status: string, glbUrl?: string | null, thumbnailUrl?: string | null, footprintSvg?: string | null, footprintSource?: string | null, architectureSymbolKey?: string | null, dimensions?: any | null, modelDimensions?: any | null, dimensionSource?: Product3DDimensionSource | null, dimensionAnchor?: Product3DDimensionAnchor | null, dimensionScale?: number | null, bounds?: any | null, placement?: any | null, materialSlots?: any | null, quality?: any | null, review?: any | null };

export type FloorplannerCatalogProductFieldsFragment = { __typename?: 'Product', id: string, name?: string | null, brand?: string | null, price?: number | null, description?: string | null, width?: number | null, height?: number | null, depth?: number | null, images?: Array<string> | null, additionalImages?: Array<string> | null, url?: string | null, features3?: any | null, breakColors?: any | null, aiGeneratedImages?: Array<{ __typename?: 'ProductAIImage', angle: string, imageUrl: string, imageUrlNoBg?: string | null, sourceImageUrl: string }> | null, supplier?: { __typename?: 'Supplier', id: string, name?: string | null, logo?: string | null } | null, categoriesMeta?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null, active3DAsset?: { __typename?: 'Product3DAsset', id: string, productId: string, variantId?: string | null, source: string, status: string, glbUrl?: string | null, thumbnailUrl?: string | null, footprintSvg?: string | null, footprintSource?: string | null, architectureSymbolKey?: string | null, dimensions?: any | null, modelDimensions?: any | null, dimensionSource?: Product3DDimensionSource | null, dimensionAnchor?: Product3DDimensionAnchor | null, dimensionScale?: number | null, bounds?: any | null, placement?: any | null, materialSlots?: any | null, quality?: any | null, review?: any | null } | null };

export type FloorplannerProductsMetaQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  materialIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  patternIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  styleIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  supplierNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  priceRange?: InputMaybe<PriceRange>;
  sortBy?: InputMaybe<SortOption>;
  hasPublished3DAsset?: InputMaybe<Scalars['Boolean']['input']>;
  product3DLibraryOrigin?: InputMaybe<Product3DLibraryOrigin>;
}>;


export type FloorplannerProductsMetaQuery = { __typename?: 'Query', productsMeta?: { __typename?: 'ProductsResponse', total?: number | null, data?: Array<{ __typename?: 'Product', id: string, name?: string | null, brand?: string | null, price?: number | null, description?: string | null, width?: number | null, height?: number | null, depth?: number | null, images?: Array<string> | null, additionalImages?: Array<string> | null, url?: string | null, features3?: any | null, breakColors?: any | null, aiGeneratedImages?: Array<{ __typename?: 'ProductAIImage', angle: string, imageUrl: string, imageUrlNoBg?: string | null, sourceImageUrl: string }> | null, supplier?: { __typename?: 'Supplier', id: string, name?: string | null, logo?: string | null } | null, categoriesMeta?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null, active3DAsset?: { __typename?: 'Product3DAsset', id: string, productId: string, variantId?: string | null, source: string, status: string, glbUrl?: string | null, thumbnailUrl?: string | null, footprintSvg?: string | null, footprintSource?: string | null, architectureSymbolKey?: string | null, dimensions?: any | null, modelDimensions?: any | null, dimensionSource?: Product3DDimensionSource | null, dimensionAnchor?: Product3DDimensionAnchor | null, dimensionScale?: number | null, bounds?: any | null, placement?: any | null, materialSlots?: any | null, quality?: any | null, review?: any | null } | null }> | null } | null };

export type FloorplannerProduct3DAssetsQueryVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type FloorplannerProduct3DAssetsQuery = { __typename?: 'Query', product3DAssets: Array<{ __typename?: 'Product3DAsset', id: string, productId: string, variantId?: string | null, source: string, status: string, glbUrl?: string | null, thumbnailUrl?: string | null, footprintSvg?: string | null, footprintSource?: string | null, architectureSymbolKey?: string | null, dimensions?: any | null, modelDimensions?: any | null, dimensionSource?: Product3DDimensionSource | null, dimensionAnchor?: Product3DDimensionAnchor | null, dimensionScale?: number | null, bounds?: any | null, placement?: any | null, materialSlots?: any | null, quality?: any | null, review?: any | null }> };

export type FloorplannerProductLibraryFiltersQueryVariables = Exact<{
  origin?: InputMaybe<Product3DLibraryOrigin>;
}>;


export type FloorplannerProductLibraryFiltersQuery = { __typename?: 'Query', publishedProduct3DLibraryFilters: { __typename?: 'PublishedProduct3DLibraryFilters', productCount: number, priceMin?: number | null, priceMax?: number | null, categories: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null, children?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null, children?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null } | null> | null } | null> | null }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, suppliers: Array<{ __typename?: 'Supplier', id: string, name?: string | null, logo?: string | null }>, colors: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }>, shapes: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }>, materials: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }>, styles: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }>, patterns: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }>, rooms: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null }> } };

export type FloorplannerProductByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FloorplannerProductByIdQuery = { __typename?: 'Query', productById: { __typename?: 'Product', id: string, name?: string | null, brand?: string | null, price?: number | null, description?: string | null, width?: number | null, height?: number | null, depth?: number | null, images?: Array<string> | null, additionalImages?: Array<string> | null, url?: string | null, features3?: any | null, breakColors?: any | null, aiGeneratedImages?: Array<{ __typename?: 'ProductAIImage', angle: string, imageUrl: string, imageUrlNoBg?: string | null, sourceImageUrl: string }> | null, supplier?: { __typename?: 'Supplier', id: string, name?: string | null, logo?: string | null } | null, categoriesMeta?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', id: string, name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null, active3DAsset?: { __typename?: 'Product3DAsset', id: string, productId: string, variantId?: string | null, source: string, status: string, glbUrl?: string | null, thumbnailUrl?: string | null, footprintSvg?: string | null, footprintSource?: string | null, architectureSymbolKey?: string | null, dimensions?: any | null, modelDimensions?: any | null, dimensionSource?: Product3DDimensionSource | null, dimensionAnchor?: Product3DDimensionAnchor | null, dimensionScale?: number | null, bounds?: any | null, placement?: any | null, materialSlots?: any | null, quality?: any | null, review?: any | null } | null } };

export type FloorplannerSurfacesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  colorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FloorplannerSurfacesQuery = { __typename?: 'Query', surfaces?: { __typename?: 'SurfaceResponse', total?: number | null, data?: Array<{ __typename?: 'Surface', id: string, name?: string | null, description?: string | null, images?: Array<string> | null, categories?: Array<{ __typename?: 'SurfaceCategory', id: string, name?: string | null, parent?: { __typename?: 'SurfaceCategory', name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null, roomElements?: { __typename?: 'RoomElements', height?: number | null, width?: number | null, segments?: Array<{ __typename?: 'RoomElementsDataType', name?: string | null, type?: string | null } | null> | null } | null }> | null } | null };

export type FloorplannerSurfaceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FloorplannerSurfaceByIdQuery = { __typename?: 'Query', surfaceById: { __typename?: 'Surface', id: string, name?: string | null, description?: string | null, images?: Array<string> | null, categories?: Array<{ __typename?: 'SurfaceCategory', id: string, name?: string | null, parent?: { __typename?: 'SurfaceCategory', name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null, roomElements?: { __typename?: 'RoomElements', height?: number | null, width?: number | null, segments?: Array<{ __typename?: 'RoomElementsDataType', name?: string | null, type?: string | null } | null> | null } | null } };

export type FloorplannerSurfaceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplannerSurfaceCategoriesQuery = { __typename?: 'Query', surfaceCategories: Array<{ __typename?: 'SurfaceCategory', id: string, name?: string | null, order?: number | null, parent?: { __typename?: 'SurfaceCategory', id: string, name?: string | null } | null, children?: Array<{ __typename?: 'SurfaceCategory', id: string, name?: string | null } | null> | null } | null> };

export type FloorplannerMaterialsMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplannerMaterialsMetaQuery = { __typename?: 'Query', materialsMeta?: Array<{ __typename?: 'Material', id: string, name?: string | null, description?: string | null, images?: Array<string> | null, categories?: Array<{ __typename?: 'MaterialCategory', id: string, name?: string | null, parent?: { __typename?: 'MaterialCategory', name?: string | null } | null } | null> | null, colors?: Array<{ __typename?: 'Color', id: string, name: string, hex: string } | null> | null }> | null };

export type FloorplannerCategoriesMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplannerCategoriesMetaQuery = { __typename?: 'Query', categoriesMeta: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, label?: string | null, children?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, label?: string | null, children?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, label?: string | null, children?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, label?: string | null } | null> | null } | null> | null } | null> | null } | null> };

export type FloorplannerProductBrandsQueryVariables = Exact<{
  categoriesIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type FloorplannerProductBrandsQuery = { __typename?: 'Query', productBrands: Array<{ __typename?: 'BrandInfo', id: string, name: string }> };

export type FloorplannerMaterialSurfacesQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplannerMaterialSurfacesQuery = { __typename?: 'Query', floorplannerMaterialSurfaces: Array<{ __typename?: 'Surface', id: string, name?: string | null, images?: Array<string> | null, roughness?: number | null, sheen?: number | null, sheenRoughness?: number | null, repeatScale?: number | null, categories?: Array<{ __typename?: 'SurfaceCategory', id: string, name?: string | null, order?: number | null } | null> | null }> };

export type FloorplannerSymbol3DDefaultsQueryVariables = Exact<{
  symbolKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FloorplannerSymbol3DDefaultsQuery = { __typename?: 'Query', floorplannerSymbol3DDefaults: Array<{ __typename?: 'FloorplannerSymbol3DDefault', id: string, symbolKey: string, standardModelKey?: string | null, productId?: string | null, variantId?: string | null, publicModelId?: string | null, modelPitchOffsetDeg?: number | null, modelRollOffsetDeg?: number | null, modelYawOffsetDeg?: number | null, enabled: boolean, publicModel?: { __typename?: 'UserModel3D', id: string, name: string, status: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sha256?: string | null, pipelineVersion: string, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, height?: number | null, depth?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, height?: number | null, depth?: number | null } | null } | null } | null, product?: { __typename?: 'Product', id: string, name?: string | null, brand?: string | null, description?: string | null, width?: number | null, height?: number | null, depth?: number | null, images?: Array<string> | null, features3?: any | null, breakColors?: any | null, supplier?: { __typename?: 'Supplier', id: string, name?: string | null } | null, categoriesMeta?: Array<{ __typename?: 'CategoryMeta', id: string, name?: string | null, parent?: { __typename?: 'CategoryMeta', name?: string | null } | null } | null> | null } | null }> };

export type CurrencyRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrencyRatesQuery = { __typename?: 'Query', currencyRates: { __typename?: 'CurrencyRatesResponse', base: string, supported: Array<string>, lastUpdated: string, rates: Array<{ __typename?: 'CurrencyRateEntry', currency: string, rate: number }> } };

export type RenderFloorplanSceneWithAiMutationVariables = Exact<{
  manifest: Scalars['JSONObject']['input'];
  snapshot: Scalars['Upload']['input'];
  stylePreset?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenderFloorplanSceneWithAiMutation = { __typename?: 'Mutation', renderFloorplanSceneWithAI: { __typename?: 'FloorplanSceneRenderResult', imageUrl: string, model: string, manifestDigest: string, createdAt: any, userItemId: string } };

export type LogFloorplanAiRenderErrorMutationVariables = Exact<{
  input: LogFloorplanAiRenderErrorInput;
}>;


export type LogFloorplanAiRenderErrorMutation = { __typename?: 'Mutation', logFloorplanAiRenderError: boolean };

export type GenerateAiVideoMutationVariables = Exact<{
  moodBoardId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateAiVideoMutation = { __typename?: 'Mutation', generateAiVideo: { __typename?: 'GenerateAiVideoResult', jobId: string, status: AiVideoJobStatus, videoUrl?: string | null, creditsConsumed: number, errorMessage?: string | null, userItem?: { __typename?: 'UserItem', id: string, name?: string | null, images?: Array<string> | null, videos?: Array<string> | null, tags?: Array<string> | null } | null } };

export type AiVideoJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiVideoJobQuery = { __typename?: 'Query', aiVideoJob?: { __typename?: 'GenerateAiVideoResult', jobId: string, status: AiVideoJobStatus, videoUrl?: string | null, creditsConsumed: number, errorMessage?: string | null, userItem?: { __typename?: 'UserItem', id: string, name?: string | null, images?: Array<string> | null, videos?: Array<string> | null, tags?: Array<string> | null } | null } | null };

export type UploadFloorplanBackdropImageMutationVariables = Exact<{
  floorplanId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
}>;


export type UploadFloorplanBackdropImageMutation = { __typename?: 'Mutation', uploadFloorplanBackdropImage: string };

export type DeleteFloorplanBackdropImageMutationVariables = Exact<{
  floorplanId: Scalars['ID']['input'];
  imageUrl: Scalars['String']['input'];
}>;


export type DeleteFloorplanBackdropImageMutation = { __typename?: 'Mutation', deleteFloorplanBackdropImage: boolean };

export type FloorplanWithSharingQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FloorplanWithSharingQuery = { __typename?: 'Query', floorplan?: { __typename?: 'Floorplan', id: string, name?: string | null, json?: string | null, backdropImage?: string | null, backdropRatio?: number | null, backdropSize?: number | null, currency?: string | null, updatedAt?: any | null, isOwner: boolean, editingExpiresAt?: any | null, user?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null, sharedWith?: Array<{ __typename?: 'User', id: string, userName?: string | null, email?: string | null }> | null, editingBy?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null } | null };

export type FloorplansWithSharingQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplansWithSharingQuery = { __typename?: 'Query', floorplans?: Array<{ __typename?: 'Floorplan', id: string, name?: string | null, isOwner: boolean, user?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null, sharedWith?: Array<{ __typename?: 'User', id: string, userName?: string | null, email?: string | null }> | null } | null> | null };

export type ShareFloorplanMutationVariables = Exact<{
  floorplanId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type ShareFloorplanMutation = { __typename?: 'Mutation', shareFloorplan: { __typename?: 'Floorplan', id: string, sharedWith?: Array<{ __typename?: 'User', id: string, userName?: string | null, email?: string | null }> | null } };

export type UnshareFloorplanMutationVariables = Exact<{
  floorplanId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type UnshareFloorplanMutation = { __typename?: 'Mutation', unshareFloorplan: { __typename?: 'Floorplan', id: string, sharedWith?: Array<{ __typename?: 'User', id: string, userName?: string | null, email?: string | null }> | null } };

export type ClaimFloorplanEditorMutationVariables = Exact<{
  floorplanId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ClaimFloorplanEditorMutation = { __typename?: 'Mutation', claimFloorplanEditor: { __typename?: 'FloorplanCollabState', isMine: boolean, updatedAt?: any | null, editingExpiresAt?: any | null, editingBy?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null } };

export type ReleaseFloorplanEditorMutationVariables = Exact<{
  floorplanId: Scalars['String']['input'];
}>;


export type ReleaseFloorplanEditorMutation = { __typename?: 'Mutation', releaseFloorplanEditor: boolean };

export type FloorplanCollabChangedSubscriptionVariables = Exact<{
  floorplanId: Scalars['String']['input'];
}>;


export type FloorplanCollabChangedSubscription = { __typename?: 'Subscription', floorplanCollabChanged: { __typename?: 'FloorplanCollabEvent', floorplanId: string, updatedAt?: any | null, editingBy?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null } };

export type EditFloorplanWithVersionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type EditFloorplanWithVersionMutation = { __typename?: 'Mutation', editFloorplan: { __typename?: 'Floorplan', id: string, name?: string | null, image?: string | null, thumbnail?: string | null, currency?: string | null, updatedAt?: any | null } };

export type AddUserItemToNewMoodBoardMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  userItemId: Scalars['ID']['input'];
}>;


export type AddUserItemToNewMoodBoardMutation = { __typename?: 'Mutation', addUserItemToNewMoodBoard: { __typename?: 'MoodBoard', id: string, name?: string | null, index?: number | null } };

export type AddUserItemMutationVariables = Exact<{
  image: Scalars['Upload']['input'];
  removeBG?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AddUserItemMutation = { __typename?: 'Mutation', addUserItem: { __typename?: 'UserItem', id: string, images?: Array<string> | null, tags?: Array<string> | null, productIds?: Array<string> | null, sourceProductId1?: string | null, sourceProductId2?: string | null } };

export type UserModel3DFieldsFragment = { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null };

export type UserModels3DQueryVariables = Exact<{ [key: string]: never; }>;


export type UserModels3DQuery = { __typename?: 'Query', userModels3D: Array<{ __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null }> };

export type UploadUserModel3DMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['Upload']['input'];
  shareWithCommunity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UploadUserModel3DMutation = { __typename?: 'Mutation', uploadUserModel3D: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type GenerateUserModel3DFromImageMutationVariables = Exact<{
  name: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
  shareWithCommunity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GenerateUserModel3DFromImageMutation = { __typename?: 'Mutation', generateUserModel3DFromImage: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type RetryUserModel3DGenerationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetryUserModel3DGenerationMutation = { __typename?: 'Mutation', retryUserModel3DGeneration: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type CommunityUserModels3DQueryVariables = Exact<{
  input?: InputMaybe<CommunityUserModels3DInput>;
}>;


export type CommunityUserModels3DQuery = { __typename?: 'Query', communityUserModels3D: { __typename?: 'UserModels3DResponse', total: number, data: Array<{ __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null }> } };

export type UploadUserModel3DThumbnailMutationVariables = Exact<{
  modelId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
}>;


export type UploadUserModel3DThumbnailMutation = { __typename?: 'Mutation', uploadUserModel3DThumbnail: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type DeleteUserModel3DMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserModel3DMutation = { __typename?: 'Mutation', deleteUserModel3D: boolean };

export type RenameUserModel3DMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameUserModel3DMutation = { __typename?: 'Mutation', renameUserModel3D: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type UpdateUserModel3DMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
  depth?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  architectureSymbolKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserModel3DMutation = { __typename?: 'Mutation', updateUserModel3D: { __typename?: 'UserModel3D', id: string, name: string, displayTitle: string, displayDescription?: string | null, uploaderId: string, uploaderName: string, originalFilename: string, status: string, source: string, stage?: string | null, progress?: number | null, errorMessage?: string | null, shareWithCommunity: boolean, isCommunityListed: boolean, communityListingState: string, firstSharedAt?: any | null, ownerArchivedAt?: any | null, moderationState: string, optimizedUrl?: string | null, thumbnailUrl?: string | null, sourceImageUrl?: string | null, footprintSvg?: string | null, architectureSymbolKey?: string | null, fileBytes?: number | null, triangleCount?: number | null, vertexCount?: number | null, textureMaxSize?: number | null, sha256?: string | null, pipelineVersion: string, createdAt?: any | null, updatedAt?: any | null, dimensions?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null, bounds?: { __typename?: 'UserModel3DBounds', min?: Array<number> | null, max?: Array<number> | null, center?: Array<number> | null, size?: { __typename?: 'UserModel3DDimensions', width?: number | null, depth?: number | null, height?: number | null } | null } | null } };

export type FloorplanQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FloorplanQuery = { __typename?: 'Query', floorplan?: { __typename?: 'Floorplan', id: string, name?: string | null, json?: string | null, backdropImage?: string | null, backdropRatio?: number | null, backdropSize?: number | null, currency?: string | null, updatedAt?: any | null, isOwner: boolean, user?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null, sharedWith?: Array<{ __typename?: 'User', id: string, userName?: string | null, email?: string | null }> | null } | null };

export type FloorplansQueryVariables = Exact<{ [key: string]: never; }>;


export type FloorplansQuery = { __typename?: 'Query', floorplans?: Array<{ __typename?: 'Floorplan', id: string, name?: string | null, json?: string | null, backdropImage?: string | null, backdropRatio?: number | null, backdropSize?: number | null, isOwner: boolean, user?: { __typename?: 'User', id: string, userName?: string | null, email?: string | null } | null } | null> | null };

export type EditFloorplanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  json?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type EditFloorplanMutation = { __typename?: 'Mutation', editFloorplan: { __typename?: 'Floorplan', id: string, name?: string | null, image?: string | null, thumbnail?: string | null, currency?: string | null, updatedAt?: any | null } };

export type DeleteFloorplanMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteFloorplanMutation = { __typename?: 'Mutation', deleteFloorplan: { __typename?: 'Floorplan', id: string } };

export type CurrentUserWithFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWithFeatureFlagsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email?: string | null, role?: UserRole | null, entitlements?: { __typename?: 'UserEntitlements', plan: EntitlementPlan, isActive: boolean, limits: { __typename?: 'EnterpriseLimits', maxFloorplans?: number | null, maxFloorplanShapes?: number | null }, aiCredits: { __typename?: 'AICreditEntitlement', monthlyLimit?: number | null, used: number, remaining?: number | null, resetAt: any, unlimited: boolean, topupCredits: number }, featureFlags: { __typename?: 'EnterpriseFeatureFlags', floorplannerCatalogMaterials: boolean, floorplannerProduct3DAssets: boolean, shareDocuments: boolean } } | null } };

export type ValidateSessionWithFeatureFlagsMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateSessionWithFeatureFlagsMutation = { __typename?: 'Mutation', validateSession?: { __typename?: 'ValidateSession', id: string, role: UserRole, entitlements?: { __typename?: 'UserEntitlements', plan: EntitlementPlan, isActive: boolean, limits: { __typename?: 'EnterpriseLimits', maxFloorplans?: number | null, maxFloorplanShapes?: number | null }, aiCredits: { __typename?: 'AICreditEntitlement', monthlyLimit?: number | null, used: number, remaining?: number | null, resetAt: any, unlimited: boolean, topupCredits: number }, featureFlags: { __typename?: 'EnterpriseFeatureFlags', floorplannerCatalogMaterials: boolean, floorplannerProduct3DAssets: boolean, shareDocuments: boolean } } | null } | null };

export type ValidateSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateSessionMutation = { __typename?: 'Mutation', validateSession?: { __typename?: 'ValidateSession', id: string, role: UserRole, entitlements?: { __typename?: 'UserEntitlements', plan: EntitlementPlan, isActive: boolean, limits: { __typename?: 'EnterpriseLimits', maxFloorplans?: number | null, maxFloorplanShapes?: number | null }, aiCredits: { __typename?: 'AICreditEntitlement', monthlyLimit?: number | null, used: number, remaining?: number | null, resetAt: any, unlimited: boolean, topupCredits: number }, featureFlags: { __typename?: 'EnterpriseFeatureFlags', floorplannerCatalogMaterials: boolean, floorplannerProduct3DAssets: boolean, shareDocuments: boolean } } | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email?: string | null, role?: UserRole | null, entitlements?: { __typename?: 'UserEntitlements', plan: EntitlementPlan, isActive: boolean, limits: { __typename?: 'EnterpriseLimits', maxFloorplans?: number | null, maxFloorplanShapes?: number | null }, aiCredits: { __typename?: 'AICreditEntitlement', monthlyLimit?: number | null, used: number, remaining?: number | null, resetAt: any, unlimited: boolean, topupCredits: number }, featureFlags: { __typename?: 'EnterpriseFeatureFlags', floorplannerCatalogMaterials: boolean, floorplannerProduct3DAssets: boolean, shareDocuments: boolean } } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RefreshTokensMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'TokensResponse', accessToken?: any | null, refreshToken?: any | null } };

export const FloorplannerProduct3DAssetFieldsFragmentDoc = gql`
    fragment FloorplannerProduct3DAssetFields on Product3DAsset {
  id
  productId
  variantId
  source
  status
  glbUrl
  thumbnailUrl
  footprintSvg
  footprintSource
  architectureSymbolKey
  dimensions
  modelDimensions
  dimensionSource
  dimensionAnchor
  dimensionScale
  bounds
  placement
  materialSlots
  quality
  review
}
    `;
export const FloorplannerCatalogProductFieldsFragmentDoc = gql`
    fragment FloorplannerCatalogProductFields on Product {
  id
  name
  brand
  price
  description
  width
  height
  depth
  images
  additionalImages
  aiGeneratedImages {
    angle
    imageUrl
    imageUrlNoBg
    sourceImageUrl
  }
  url
  supplier {
    id
    name
    logo
  }
  categoriesMeta {
    id
    name
    parent {
      id
      name
    }
  }
  colors {
    id
    name
    hex
  }
  features3
  breakColors
  active3DAsset {
    ...FloorplannerProduct3DAssetFields
  }
}
    ${FloorplannerProduct3DAssetFieldsFragmentDoc}`;
export const UserModel3DFieldsFragmentDoc = gql`
    fragment UserModel3DFields on UserModel3D {
  id
  name
  displayTitle
  displayDescription
  uploaderId
  uploaderName
  originalFilename
  status
  source
  stage
  progress
  errorMessage
  shareWithCommunity
  isCommunityListed
  communityListingState
  firstSharedAt
  ownerArchivedAt
  moderationState
  optimizedUrl
  thumbnailUrl
  sourceImageUrl
  footprintSvg
  architectureSymbolKey
  dimensions {
    width
    depth
    height
  }
  bounds {
    min
    max
    center
    size {
      width
      depth
      height
    }
  }
  fileBytes
  triangleCount
  vertexCount
  textureMaxSize
  sha256
  pipelineVersion
  createdAt
  updatedAt
}
    `;
export const UserDocumentsDocument = gql`
    query userDocuments($input: UserDocumentsQueryInput) {
  userDocuments(input: $input) {
    documents {
      id
      name
      image
      updatedAt
      moodBoards {
        id
        name
        image
        updatedAt
      }
    }
    total
  }
}
    `;

/**
 * __useUserDocumentsQuery__
 *
 * To run a query within a React component, call `useUserDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDocumentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
      }
export function useUserDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
        }
export function useUserDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
        }
export type UserDocumentsQueryHookResult = ReturnType<typeof useUserDocumentsQuery>;
export type UserDocumentsLazyQueryHookResult = ReturnType<typeof useUserDocumentsLazyQuery>;
export type UserDocumentsSuspenseQueryHookResult = ReturnType<typeof useUserDocumentsSuspenseQuery>;
export type UserDocumentsQueryResult = Apollo.QueryResult<UserDocumentsQuery, UserDocumentsQueryVariables>;
export const FloorplannerProductsMetaDocument = gql`
    query FloorplannerProductsMeta($limit: Int!, $skip: Int!, $search: String, $categoryIds: [String!], $colorIds: [String!], $materialIds: [String!], $patternIds: [String!], $styleIds: [String!], $supplierIds: [ID], $supplierNames: [String!], $brands: [String], $priceRange: PriceRange, $sortBy: SortOption, $hasPublished3DAsset: Boolean, $product3DLibraryOrigin: Product3DLibraryOrigin) {
  productsMeta(
    input: {limit: $limit, skip: $skip, search: $search, categoryIds: $categoryIds, colorIds: $colorIds, materialIds: $materialIds, patternIds: $patternIds, styleIds: $styleIds, supplierIds: $supplierIds, supplierNames: $supplierNames, brands: $brands, priceRange: $priceRange, sortBy: $sortBy, hasPublished3DAsset: $hasPublished3DAsset, product3DLibraryOrigin: $product3DLibraryOrigin}
  ) {
    data {
      ...FloorplannerCatalogProductFields
    }
    total
  }
}
    ${FloorplannerCatalogProductFieldsFragmentDoc}`;

/**
 * __useFloorplannerProductsMetaQuery__
 *
 * To run a query within a React component, call `useFloorplannerProductsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerProductsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerProductsMetaQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      categoryIds: // value for 'categoryIds'
 *      colorIds: // value for 'colorIds'
 *      materialIds: // value for 'materialIds'
 *      patternIds: // value for 'patternIds'
 *      styleIds: // value for 'styleIds'
 *      supplierIds: // value for 'supplierIds'
 *      supplierNames: // value for 'supplierNames'
 *      brands: // value for 'brands'
 *      priceRange: // value for 'priceRange'
 *      sortBy: // value for 'sortBy'
 *      hasPublished3DAsset: // value for 'hasPublished3DAsset'
 *      product3DLibraryOrigin: // value for 'product3DLibraryOrigin'
 *   },
 * });
 */
export function useFloorplannerProductsMetaQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables> & ({ variables: FloorplannerProductsMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>(FloorplannerProductsMetaDocument, options);
      }
export function useFloorplannerProductsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>(FloorplannerProductsMetaDocument, options);
        }
export function useFloorplannerProductsMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>(FloorplannerProductsMetaDocument, options);
        }
export type FloorplannerProductsMetaQueryHookResult = ReturnType<typeof useFloorplannerProductsMetaQuery>;
export type FloorplannerProductsMetaLazyQueryHookResult = ReturnType<typeof useFloorplannerProductsMetaLazyQuery>;
export type FloorplannerProductsMetaSuspenseQueryHookResult = ReturnType<typeof useFloorplannerProductsMetaSuspenseQuery>;
export type FloorplannerProductsMetaQueryResult = Apollo.QueryResult<FloorplannerProductsMetaQuery, FloorplannerProductsMetaQueryVariables>;
export const FloorplannerProduct3DAssetsDocument = gql`
    query FloorplannerProduct3DAssets($productIds: [ID!]!, $status: String) {
  product3DAssets(productIds: $productIds, status: $status) {
    ...FloorplannerProduct3DAssetFields
  }
}
    ${FloorplannerProduct3DAssetFieldsFragmentDoc}`;

/**
 * __useFloorplannerProduct3DAssetsQuery__
 *
 * To run a query within a React component, call `useFloorplannerProduct3DAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerProduct3DAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerProduct3DAssetsQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFloorplannerProduct3DAssetsQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables> & ({ variables: FloorplannerProduct3DAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>(FloorplannerProduct3DAssetsDocument, options);
      }
export function useFloorplannerProduct3DAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>(FloorplannerProduct3DAssetsDocument, options);
        }
export function useFloorplannerProduct3DAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>(FloorplannerProduct3DAssetsDocument, options);
        }
export type FloorplannerProduct3DAssetsQueryHookResult = ReturnType<typeof useFloorplannerProduct3DAssetsQuery>;
export type FloorplannerProduct3DAssetsLazyQueryHookResult = ReturnType<typeof useFloorplannerProduct3DAssetsLazyQuery>;
export type FloorplannerProduct3DAssetsSuspenseQueryHookResult = ReturnType<typeof useFloorplannerProduct3DAssetsSuspenseQuery>;
export type FloorplannerProduct3DAssetsQueryResult = Apollo.QueryResult<FloorplannerProduct3DAssetsQuery, FloorplannerProduct3DAssetsQueryVariables>;
export const FloorplannerProductLibraryFiltersDocument = gql`
    query FloorplannerProductLibraryFilters($origin: Product3DLibraryOrigin) {
  publishedProduct3DLibraryFilters(origin: $origin) {
    productCount
    priceMin
    priceMax
    categories {
      id
      name
      parent {
        id
        name
      }
      children {
        id
        name
        parent {
          id
          name
        }
        children {
          id
          name
          parent {
            id
            name
          }
        }
      }
    }
    brands {
      id
      name
    }
    suppliers {
      id
      name
      logo
    }
    colors {
      id
      name
      parent {
        id
        name
      }
    }
    shapes {
      id
      name
      parent {
        id
        name
      }
    }
    materials {
      id
      name
      parent {
        id
        name
      }
    }
    styles {
      id
      name
      parent {
        id
        name
      }
    }
    patterns {
      id
      name
      parent {
        id
        name
      }
    }
    rooms {
      id
      name
      parent {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFloorplannerProductLibraryFiltersQuery__
 *
 * To run a query within a React component, call `useFloorplannerProductLibraryFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerProductLibraryFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerProductLibraryFiltersQuery({
 *   variables: {
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useFloorplannerProductLibraryFiltersQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>(FloorplannerProductLibraryFiltersDocument, options);
      }
export function useFloorplannerProductLibraryFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>(FloorplannerProductLibraryFiltersDocument, options);
        }
export function useFloorplannerProductLibraryFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>(FloorplannerProductLibraryFiltersDocument, options);
        }
export type FloorplannerProductLibraryFiltersQueryHookResult = ReturnType<typeof useFloorplannerProductLibraryFiltersQuery>;
export type FloorplannerProductLibraryFiltersLazyQueryHookResult = ReturnType<typeof useFloorplannerProductLibraryFiltersLazyQuery>;
export type FloorplannerProductLibraryFiltersSuspenseQueryHookResult = ReturnType<typeof useFloorplannerProductLibraryFiltersSuspenseQuery>;
export type FloorplannerProductLibraryFiltersQueryResult = Apollo.QueryResult<FloorplannerProductLibraryFiltersQuery, FloorplannerProductLibraryFiltersQueryVariables>;
export const FloorplannerProductByIdDocument = gql`
    query FloorplannerProductById($id: String!) {
  productById(id: $id) {
    ...FloorplannerCatalogProductFields
  }
}
    ${FloorplannerCatalogProductFieldsFragmentDoc}`;

/**
 * __useFloorplannerProductByIdQuery__
 *
 * To run a query within a React component, call `useFloorplannerProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorplannerProductByIdQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables> & ({ variables: FloorplannerProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>(FloorplannerProductByIdDocument, options);
      }
export function useFloorplannerProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>(FloorplannerProductByIdDocument, options);
        }
export function useFloorplannerProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>(FloorplannerProductByIdDocument, options);
        }
export type FloorplannerProductByIdQueryHookResult = ReturnType<typeof useFloorplannerProductByIdQuery>;
export type FloorplannerProductByIdLazyQueryHookResult = ReturnType<typeof useFloorplannerProductByIdLazyQuery>;
export type FloorplannerProductByIdSuspenseQueryHookResult = ReturnType<typeof useFloorplannerProductByIdSuspenseQuery>;
export type FloorplannerProductByIdQueryResult = Apollo.QueryResult<FloorplannerProductByIdQuery, FloorplannerProductByIdQueryVariables>;
export const FloorplannerSurfacesDocument = gql`
    query FloorplannerSurfaces($limit: Int!, $skip: Int!, $categoryIds: [String!], $colorIds: [String!]) {
  surfaces(
    input: {limit: $limit, skip: $skip, categoryIds: $categoryIds, colorIds: $colorIds}
  ) {
    data {
      id
      name
      description
      images
      categories {
        id
        name
        parent {
          name
        }
      }
      colors {
        id
        name
        hex
      }
      roomElements {
        height
        width
        segments {
          name
          type
        }
      }
    }
    total
  }
}
    `;

/**
 * __useFloorplannerSurfacesQuery__
 *
 * To run a query within a React component, call `useFloorplannerSurfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerSurfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerSurfacesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      categoryIds: // value for 'categoryIds'
 *      colorIds: // value for 'colorIds'
 *   },
 * });
 */
export function useFloorplannerSurfacesQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables> & ({ variables: FloorplannerSurfacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>(FloorplannerSurfacesDocument, options);
      }
export function useFloorplannerSurfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>(FloorplannerSurfacesDocument, options);
        }
export function useFloorplannerSurfacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>(FloorplannerSurfacesDocument, options);
        }
export type FloorplannerSurfacesQueryHookResult = ReturnType<typeof useFloorplannerSurfacesQuery>;
export type FloorplannerSurfacesLazyQueryHookResult = ReturnType<typeof useFloorplannerSurfacesLazyQuery>;
export type FloorplannerSurfacesSuspenseQueryHookResult = ReturnType<typeof useFloorplannerSurfacesSuspenseQuery>;
export type FloorplannerSurfacesQueryResult = Apollo.QueryResult<FloorplannerSurfacesQuery, FloorplannerSurfacesQueryVariables>;
export const FloorplannerSurfaceByIdDocument = gql`
    query FloorplannerSurfaceById($id: String!) {
  surfaceById(id: $id) {
    id
    name
    description
    images
    categories {
      id
      name
      parent {
        name
      }
    }
    colors {
      id
      name
      hex
    }
    roomElements {
      height
      width
      segments {
        name
        type
      }
    }
  }
}
    `;

/**
 * __useFloorplannerSurfaceByIdQuery__
 *
 * To run a query within a React component, call `useFloorplannerSurfaceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerSurfaceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerSurfaceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorplannerSurfaceByIdQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables> & ({ variables: FloorplannerSurfaceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>(FloorplannerSurfaceByIdDocument, options);
      }
export function useFloorplannerSurfaceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>(FloorplannerSurfaceByIdDocument, options);
        }
export function useFloorplannerSurfaceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>(FloorplannerSurfaceByIdDocument, options);
        }
export type FloorplannerSurfaceByIdQueryHookResult = ReturnType<typeof useFloorplannerSurfaceByIdQuery>;
export type FloorplannerSurfaceByIdLazyQueryHookResult = ReturnType<typeof useFloorplannerSurfaceByIdLazyQuery>;
export type FloorplannerSurfaceByIdSuspenseQueryHookResult = ReturnType<typeof useFloorplannerSurfaceByIdSuspenseQuery>;
export type FloorplannerSurfaceByIdQueryResult = Apollo.QueryResult<FloorplannerSurfaceByIdQuery, FloorplannerSurfaceByIdQueryVariables>;
export const FloorplannerSurfaceCategoriesDocument = gql`
    query FloorplannerSurfaceCategories {
  surfaceCategories {
    id
    name
    order
    parent {
      id
      name
    }
    children {
      id
      name
    }
  }
}
    `;

/**
 * __useFloorplannerSurfaceCategoriesQuery__
 *
 * To run a query within a React component, call `useFloorplannerSurfaceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerSurfaceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerSurfaceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplannerSurfaceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>(FloorplannerSurfaceCategoriesDocument, options);
      }
export function useFloorplannerSurfaceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>(FloorplannerSurfaceCategoriesDocument, options);
        }
export function useFloorplannerSurfaceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>(FloorplannerSurfaceCategoriesDocument, options);
        }
export type FloorplannerSurfaceCategoriesQueryHookResult = ReturnType<typeof useFloorplannerSurfaceCategoriesQuery>;
export type FloorplannerSurfaceCategoriesLazyQueryHookResult = ReturnType<typeof useFloorplannerSurfaceCategoriesLazyQuery>;
export type FloorplannerSurfaceCategoriesSuspenseQueryHookResult = ReturnType<typeof useFloorplannerSurfaceCategoriesSuspenseQuery>;
export type FloorplannerSurfaceCategoriesQueryResult = Apollo.QueryResult<FloorplannerSurfaceCategoriesQuery, FloorplannerSurfaceCategoriesQueryVariables>;
export const FloorplannerMaterialsMetaDocument = gql`
    query FloorplannerMaterialsMeta {
  materialsMeta {
    id
    name
    description
    images
    categories {
      id
      name
      parent {
        name
      }
    }
    colors {
      id
      name
      hex
    }
  }
}
    `;

/**
 * __useFloorplannerMaterialsMetaQuery__
 *
 * To run a query within a React component, call `useFloorplannerMaterialsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerMaterialsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerMaterialsMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplannerMaterialsMetaQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>(FloorplannerMaterialsMetaDocument, options);
      }
export function useFloorplannerMaterialsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>(FloorplannerMaterialsMetaDocument, options);
        }
export function useFloorplannerMaterialsMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>(FloorplannerMaterialsMetaDocument, options);
        }
export type FloorplannerMaterialsMetaQueryHookResult = ReturnType<typeof useFloorplannerMaterialsMetaQuery>;
export type FloorplannerMaterialsMetaLazyQueryHookResult = ReturnType<typeof useFloorplannerMaterialsMetaLazyQuery>;
export type FloorplannerMaterialsMetaSuspenseQueryHookResult = ReturnType<typeof useFloorplannerMaterialsMetaSuspenseQuery>;
export type FloorplannerMaterialsMetaQueryResult = Apollo.QueryResult<FloorplannerMaterialsMetaQuery, FloorplannerMaterialsMetaQueryVariables>;
export const FloorplannerCategoriesMetaDocument = gql`
    query FloorplannerCategoriesMeta {
  categoriesMeta {
    id
    name
    label
    children {
      id
      name
      label
      children {
        id
        name
        label
        children {
          id
          name
          label
        }
      }
    }
  }
}
    `;

/**
 * __useFloorplannerCategoriesMetaQuery__
 *
 * To run a query within a React component, call `useFloorplannerCategoriesMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerCategoriesMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerCategoriesMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplannerCategoriesMetaQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>(FloorplannerCategoriesMetaDocument, options);
      }
export function useFloorplannerCategoriesMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>(FloorplannerCategoriesMetaDocument, options);
        }
export function useFloorplannerCategoriesMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>(FloorplannerCategoriesMetaDocument, options);
        }
export type FloorplannerCategoriesMetaQueryHookResult = ReturnType<typeof useFloorplannerCategoriesMetaQuery>;
export type FloorplannerCategoriesMetaLazyQueryHookResult = ReturnType<typeof useFloorplannerCategoriesMetaLazyQuery>;
export type FloorplannerCategoriesMetaSuspenseQueryHookResult = ReturnType<typeof useFloorplannerCategoriesMetaSuspenseQuery>;
export type FloorplannerCategoriesMetaQueryResult = Apollo.QueryResult<FloorplannerCategoriesMetaQuery, FloorplannerCategoriesMetaQueryVariables>;
export const FloorplannerProductBrandsDocument = gql`
    query FloorplannerProductBrands($categoriesIds: [String]!) {
  productBrands(categoriesIds: $categoriesIds) {
    id
    name
  }
}
    `;

/**
 * __useFloorplannerProductBrandsQuery__
 *
 * To run a query within a React component, call `useFloorplannerProductBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerProductBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerProductBrandsQuery({
 *   variables: {
 *      categoriesIds: // value for 'categoriesIds'
 *   },
 * });
 */
export function useFloorplannerProductBrandsQuery(baseOptions: Apollo.QueryHookOptions<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables> & ({ variables: FloorplannerProductBrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>(FloorplannerProductBrandsDocument, options);
      }
export function useFloorplannerProductBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>(FloorplannerProductBrandsDocument, options);
        }
export function useFloorplannerProductBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>(FloorplannerProductBrandsDocument, options);
        }
export type FloorplannerProductBrandsQueryHookResult = ReturnType<typeof useFloorplannerProductBrandsQuery>;
export type FloorplannerProductBrandsLazyQueryHookResult = ReturnType<typeof useFloorplannerProductBrandsLazyQuery>;
export type FloorplannerProductBrandsSuspenseQueryHookResult = ReturnType<typeof useFloorplannerProductBrandsSuspenseQuery>;
export type FloorplannerProductBrandsQueryResult = Apollo.QueryResult<FloorplannerProductBrandsQuery, FloorplannerProductBrandsQueryVariables>;
export const FloorplannerMaterialSurfacesDocument = gql`
    query FloorplannerMaterialSurfaces {
  floorplannerMaterialSurfaces {
    id
    name
    images
    roughness
    sheen
    sheenRoughness
    repeatScale
    categories {
      id
      name
      order
    }
  }
}
    `;

/**
 * __useFloorplannerMaterialSurfacesQuery__
 *
 * To run a query within a React component, call `useFloorplannerMaterialSurfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerMaterialSurfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerMaterialSurfacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplannerMaterialSurfacesQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>(FloorplannerMaterialSurfacesDocument, options);
      }
export function useFloorplannerMaterialSurfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>(FloorplannerMaterialSurfacesDocument, options);
        }
export function useFloorplannerMaterialSurfacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>(FloorplannerMaterialSurfacesDocument, options);
        }
export type FloorplannerMaterialSurfacesQueryHookResult = ReturnType<typeof useFloorplannerMaterialSurfacesQuery>;
export type FloorplannerMaterialSurfacesLazyQueryHookResult = ReturnType<typeof useFloorplannerMaterialSurfacesLazyQuery>;
export type FloorplannerMaterialSurfacesSuspenseQueryHookResult = ReturnType<typeof useFloorplannerMaterialSurfacesSuspenseQuery>;
export type FloorplannerMaterialSurfacesQueryResult = Apollo.QueryResult<FloorplannerMaterialSurfacesQuery, FloorplannerMaterialSurfacesQueryVariables>;
export const FloorplannerSymbol3DDefaultsDocument = gql`
    query FloorplannerSymbol3DDefaults($symbolKeys: [String!]) {
  floorplannerSymbol3DDefaults(symbolKeys: $symbolKeys) {
    id
    symbolKey
    standardModelKey
    productId
    variantId
    publicModelId
    modelPitchOffsetDeg
    modelRollOffsetDeg
    modelYawOffsetDeg
    enabled
    publicModel {
      id
      name
      status
      optimizedUrl
      thumbnailUrl
      dimensions {
        width
        height
        depth
      }
      bounds {
        min
        max
        center
        size {
          width
          height
          depth
        }
      }
      sha256
      pipelineVersion
    }
    product {
      id
      name
      brand
      description
      width
      height
      depth
      images
      supplier {
        id
        name
      }
      categoriesMeta {
        id
        name
        parent {
          name
        }
      }
      features3
      breakColors
    }
  }
}
    `;

/**
 * __useFloorplannerSymbol3DDefaultsQuery__
 *
 * To run a query within a React component, call `useFloorplannerSymbol3DDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplannerSymbol3DDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplannerSymbol3DDefaultsQuery({
 *   variables: {
 *      symbolKeys: // value for 'symbolKeys'
 *   },
 * });
 */
export function useFloorplannerSymbol3DDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>(FloorplannerSymbol3DDefaultsDocument, options);
      }
export function useFloorplannerSymbol3DDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>(FloorplannerSymbol3DDefaultsDocument, options);
        }
export function useFloorplannerSymbol3DDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>(FloorplannerSymbol3DDefaultsDocument, options);
        }
export type FloorplannerSymbol3DDefaultsQueryHookResult = ReturnType<typeof useFloorplannerSymbol3DDefaultsQuery>;
export type FloorplannerSymbol3DDefaultsLazyQueryHookResult = ReturnType<typeof useFloorplannerSymbol3DDefaultsLazyQuery>;
export type FloorplannerSymbol3DDefaultsSuspenseQueryHookResult = ReturnType<typeof useFloorplannerSymbol3DDefaultsSuspenseQuery>;
export type FloorplannerSymbol3DDefaultsQueryResult = Apollo.QueryResult<FloorplannerSymbol3DDefaultsQuery, FloorplannerSymbol3DDefaultsQueryVariables>;
export const CurrencyRatesDocument = gql`
    query CurrencyRates {
  currencyRates {
    base
    supported
    lastUpdated
    rates {
      currency
      rate
    }
  }
}
    `;

/**
 * __useCurrencyRatesQuery__
 *
 * To run a query within a React component, call `useCurrencyRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrencyRatesQuery(baseOptions?: Apollo.QueryHookOptions<CurrencyRatesQuery, CurrencyRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyRatesQuery, CurrencyRatesQueryVariables>(CurrencyRatesDocument, options);
      }
export function useCurrencyRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyRatesQuery, CurrencyRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyRatesQuery, CurrencyRatesQueryVariables>(CurrencyRatesDocument, options);
        }
export function useCurrencyRatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrencyRatesQuery, CurrencyRatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrencyRatesQuery, CurrencyRatesQueryVariables>(CurrencyRatesDocument, options);
        }
export type CurrencyRatesQueryHookResult = ReturnType<typeof useCurrencyRatesQuery>;
export type CurrencyRatesLazyQueryHookResult = ReturnType<typeof useCurrencyRatesLazyQuery>;
export type CurrencyRatesSuspenseQueryHookResult = ReturnType<typeof useCurrencyRatesSuspenseQuery>;
export type CurrencyRatesQueryResult = Apollo.QueryResult<CurrencyRatesQuery, CurrencyRatesQueryVariables>;
export const RenderFloorplanSceneWithAiDocument = gql`
    mutation RenderFloorplanSceneWithAI($manifest: JSONObject!, $snapshot: Upload!, $stylePreset: String, $prompt: String, $model: String, $name: String) {
  renderFloorplanSceneWithAI(
    input: {manifest: $manifest, snapshot: $snapshot, stylePreset: $stylePreset, prompt: $prompt, model: $model, name: $name}
  ) {
    imageUrl
    model
    manifestDigest
    createdAt
    userItemId
  }
}
    `;
export type RenderFloorplanSceneWithAiMutationFn = Apollo.MutationFunction<RenderFloorplanSceneWithAiMutation, RenderFloorplanSceneWithAiMutationVariables>;

/**
 * __useRenderFloorplanSceneWithAiMutation__
 *
 * To run a mutation, you first call `useRenderFloorplanSceneWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderFloorplanSceneWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderFloorplanSceneWithAiMutation, { data, loading, error }] = useRenderFloorplanSceneWithAiMutation({
 *   variables: {
 *      manifest: // value for 'manifest'
 *      snapshot: // value for 'snapshot'
 *      stylePreset: // value for 'stylePreset'
 *      prompt: // value for 'prompt'
 *      model: // value for 'model'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenderFloorplanSceneWithAiMutation(baseOptions?: Apollo.MutationHookOptions<RenderFloorplanSceneWithAiMutation, RenderFloorplanSceneWithAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenderFloorplanSceneWithAiMutation, RenderFloorplanSceneWithAiMutationVariables>(RenderFloorplanSceneWithAiDocument, options);
      }
export type RenderFloorplanSceneWithAiMutationHookResult = ReturnType<typeof useRenderFloorplanSceneWithAiMutation>;
export type RenderFloorplanSceneWithAiMutationResult = Apollo.MutationResult<RenderFloorplanSceneWithAiMutation>;
export type RenderFloorplanSceneWithAiMutationOptions = Apollo.BaseMutationOptions<RenderFloorplanSceneWithAiMutation, RenderFloorplanSceneWithAiMutationVariables>;
export const LogFloorplanAiRenderErrorDocument = gql`
    mutation LogFloorplanAiRenderError($input: LogFloorplanAiRenderErrorInput!) {
  logFloorplanAiRenderError(input: $input)
}
    `;
export type LogFloorplanAiRenderErrorMutationFn = Apollo.MutationFunction<LogFloorplanAiRenderErrorMutation, LogFloorplanAiRenderErrorMutationVariables>;

/**
 * __useLogFloorplanAiRenderErrorMutation__
 *
 * To run a mutation, you first call `useLogFloorplanAiRenderErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogFloorplanAiRenderErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logFloorplanAiRenderErrorMutation, { data, loading, error }] = useLogFloorplanAiRenderErrorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogFloorplanAiRenderErrorMutation(baseOptions?: Apollo.MutationHookOptions<LogFloorplanAiRenderErrorMutation, LogFloorplanAiRenderErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogFloorplanAiRenderErrorMutation, LogFloorplanAiRenderErrorMutationVariables>(LogFloorplanAiRenderErrorDocument, options);
      }
export type LogFloorplanAiRenderErrorMutationHookResult = ReturnType<typeof useLogFloorplanAiRenderErrorMutation>;
export type LogFloorplanAiRenderErrorMutationResult = Apollo.MutationResult<LogFloorplanAiRenderErrorMutation>;
export type LogFloorplanAiRenderErrorMutationOptions = Apollo.BaseMutationOptions<LogFloorplanAiRenderErrorMutation, LogFloorplanAiRenderErrorMutationVariables>;
export const GenerateAiVideoDocument = gql`
    mutation GenerateAiVideo($moodBoardId: ID, $imageUrl: String, $prompt: String) {
  generateAiVideo(moodBoardId: $moodBoardId, imageUrl: $imageUrl, prompt: $prompt) {
    jobId
    status
    videoUrl
    creditsConsumed
    errorMessage
    userItem {
      id
      name
      images
      videos
      tags
    }
  }
}
    `;
export type GenerateAiVideoMutationFn = Apollo.MutationFunction<GenerateAiVideoMutation, GenerateAiVideoMutationVariables>;

/**
 * __useGenerateAiVideoMutation__
 *
 * To run a mutation, you first call `useGenerateAiVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiVideoMutation, { data, loading, error }] = useGenerateAiVideoMutation({
 *   variables: {
 *      moodBoardId: // value for 'moodBoardId'
 *      imageUrl: // value for 'imageUrl'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useGenerateAiVideoMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAiVideoMutation, GenerateAiVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAiVideoMutation, GenerateAiVideoMutationVariables>(GenerateAiVideoDocument, options);
      }
export type GenerateAiVideoMutationHookResult = ReturnType<typeof useGenerateAiVideoMutation>;
export type GenerateAiVideoMutationResult = Apollo.MutationResult<GenerateAiVideoMutation>;
export type GenerateAiVideoMutationOptions = Apollo.BaseMutationOptions<GenerateAiVideoMutation, GenerateAiVideoMutationVariables>;
export const AiVideoJobDocument = gql`
    query AiVideoJob($id: ID!) {
  aiVideoJob(id: $id) {
    jobId
    status
    videoUrl
    creditsConsumed
    errorMessage
    userItem {
      id
      name
      images
      videos
      tags
    }
  }
}
    `;

/**
 * __useAiVideoJobQuery__
 *
 * To run a query within a React component, call `useAiVideoJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiVideoJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiVideoJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiVideoJobQuery(baseOptions: Apollo.QueryHookOptions<AiVideoJobQuery, AiVideoJobQueryVariables> & ({ variables: AiVideoJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiVideoJobQuery, AiVideoJobQueryVariables>(AiVideoJobDocument, options);
      }
export function useAiVideoJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiVideoJobQuery, AiVideoJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiVideoJobQuery, AiVideoJobQueryVariables>(AiVideoJobDocument, options);
        }
export function useAiVideoJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiVideoJobQuery, AiVideoJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiVideoJobQuery, AiVideoJobQueryVariables>(AiVideoJobDocument, options);
        }
export type AiVideoJobQueryHookResult = ReturnType<typeof useAiVideoJobQuery>;
export type AiVideoJobLazyQueryHookResult = ReturnType<typeof useAiVideoJobLazyQuery>;
export type AiVideoJobSuspenseQueryHookResult = ReturnType<typeof useAiVideoJobSuspenseQuery>;
export type AiVideoJobQueryResult = Apollo.QueryResult<AiVideoJobQuery, AiVideoJobQueryVariables>;
export const UploadFloorplanBackdropImageDocument = gql`
    mutation UploadFloorplanBackdropImage($floorplanId: ID!, $image: Upload!) {
  uploadFloorplanBackdropImage(floorplanId: $floorplanId, image: $image)
}
    `;
export type UploadFloorplanBackdropImageMutationFn = Apollo.MutationFunction<UploadFloorplanBackdropImageMutation, UploadFloorplanBackdropImageMutationVariables>;

/**
 * __useUploadFloorplanBackdropImageMutation__
 *
 * To run a mutation, you first call `useUploadFloorplanBackdropImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFloorplanBackdropImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFloorplanBackdropImageMutation, { data, loading, error }] = useUploadFloorplanBackdropImageMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUploadFloorplanBackdropImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadFloorplanBackdropImageMutation, UploadFloorplanBackdropImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFloorplanBackdropImageMutation, UploadFloorplanBackdropImageMutationVariables>(UploadFloorplanBackdropImageDocument, options);
      }
export type UploadFloorplanBackdropImageMutationHookResult = ReturnType<typeof useUploadFloorplanBackdropImageMutation>;
export type UploadFloorplanBackdropImageMutationResult = Apollo.MutationResult<UploadFloorplanBackdropImageMutation>;
export type UploadFloorplanBackdropImageMutationOptions = Apollo.BaseMutationOptions<UploadFloorplanBackdropImageMutation, UploadFloorplanBackdropImageMutationVariables>;
export const DeleteFloorplanBackdropImageDocument = gql`
    mutation DeleteFloorplanBackdropImage($floorplanId: ID!, $imageUrl: String!) {
  deleteFloorplanBackdropImage(floorplanId: $floorplanId, imageUrl: $imageUrl)
}
    `;
export type DeleteFloorplanBackdropImageMutationFn = Apollo.MutationFunction<DeleteFloorplanBackdropImageMutation, DeleteFloorplanBackdropImageMutationVariables>;

/**
 * __useDeleteFloorplanBackdropImageMutation__
 *
 * To run a mutation, you first call `useDeleteFloorplanBackdropImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFloorplanBackdropImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFloorplanBackdropImageMutation, { data, loading, error }] = useDeleteFloorplanBackdropImageMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useDeleteFloorplanBackdropImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFloorplanBackdropImageMutation, DeleteFloorplanBackdropImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFloorplanBackdropImageMutation, DeleteFloorplanBackdropImageMutationVariables>(DeleteFloorplanBackdropImageDocument, options);
      }
export type DeleteFloorplanBackdropImageMutationHookResult = ReturnType<typeof useDeleteFloorplanBackdropImageMutation>;
export type DeleteFloorplanBackdropImageMutationResult = Apollo.MutationResult<DeleteFloorplanBackdropImageMutation>;
export type DeleteFloorplanBackdropImageMutationOptions = Apollo.BaseMutationOptions<DeleteFloorplanBackdropImageMutation, DeleteFloorplanBackdropImageMutationVariables>;
export const FloorplanWithSharingDocument = gql`
    query floorplanWithSharing($id: String!) {
  floorplan(id: $id) {
    id
    name
    json
    backdropImage
    backdropRatio
    backdropSize
    currency
    updatedAt
    isOwner
    user {
      id
      userName
      email
    }
    sharedWith {
      id
      userName
      email
    }
    editingBy {
      id
      userName
      email
    }
    editingExpiresAt
  }
}
    `;

/**
 * __useFloorplanWithSharingQuery__
 *
 * To run a query within a React component, call `useFloorplanWithSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplanWithSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplanWithSharingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorplanWithSharingQuery(baseOptions: Apollo.QueryHookOptions<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables> & ({ variables: FloorplanWithSharingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>(FloorplanWithSharingDocument, options);
      }
export function useFloorplanWithSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>(FloorplanWithSharingDocument, options);
        }
export function useFloorplanWithSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>(FloorplanWithSharingDocument, options);
        }
export type FloorplanWithSharingQueryHookResult = ReturnType<typeof useFloorplanWithSharingQuery>;
export type FloorplanWithSharingLazyQueryHookResult = ReturnType<typeof useFloorplanWithSharingLazyQuery>;
export type FloorplanWithSharingSuspenseQueryHookResult = ReturnType<typeof useFloorplanWithSharingSuspenseQuery>;
export type FloorplanWithSharingQueryResult = Apollo.QueryResult<FloorplanWithSharingQuery, FloorplanWithSharingQueryVariables>;
export const FloorplansWithSharingDocument = gql`
    query floorplansWithSharing {
  floorplans {
    id
    name
    isOwner
    user {
      id
      userName
      email
    }
    sharedWith {
      id
      userName
      email
    }
  }
}
    `;

/**
 * __useFloorplansWithSharingQuery__
 *
 * To run a query within a React component, call `useFloorplansWithSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplansWithSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplansWithSharingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplansWithSharingQuery(baseOptions?: Apollo.QueryHookOptions<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>(FloorplansWithSharingDocument, options);
      }
export function useFloorplansWithSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>(FloorplansWithSharingDocument, options);
        }
export function useFloorplansWithSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>(FloorplansWithSharingDocument, options);
        }
export type FloorplansWithSharingQueryHookResult = ReturnType<typeof useFloorplansWithSharingQuery>;
export type FloorplansWithSharingLazyQueryHookResult = ReturnType<typeof useFloorplansWithSharingLazyQuery>;
export type FloorplansWithSharingSuspenseQueryHookResult = ReturnType<typeof useFloorplansWithSharingSuspenseQuery>;
export type FloorplansWithSharingQueryResult = Apollo.QueryResult<FloorplansWithSharingQuery, FloorplansWithSharingQueryVariables>;
export const ShareFloorplanDocument = gql`
    mutation shareFloorplan($floorplanId: String!, $email: String!) {
  shareFloorplan(floorplanId: $floorplanId, email: $email) {
    id
    sharedWith {
      id
      userName
      email
    }
  }
}
    `;
export type ShareFloorplanMutationFn = Apollo.MutationFunction<ShareFloorplanMutation, ShareFloorplanMutationVariables>;

/**
 * __useShareFloorplanMutation__
 *
 * To run a mutation, you first call `useShareFloorplanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareFloorplanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareFloorplanMutation, { data, loading, error }] = useShareFloorplanMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useShareFloorplanMutation(baseOptions?: Apollo.MutationHookOptions<ShareFloorplanMutation, ShareFloorplanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareFloorplanMutation, ShareFloorplanMutationVariables>(ShareFloorplanDocument, options);
      }
export type ShareFloorplanMutationHookResult = ReturnType<typeof useShareFloorplanMutation>;
export type ShareFloorplanMutationResult = Apollo.MutationResult<ShareFloorplanMutation>;
export type ShareFloorplanMutationOptions = Apollo.BaseMutationOptions<ShareFloorplanMutation, ShareFloorplanMutationVariables>;
export const UnshareFloorplanDocument = gql`
    mutation unshareFloorplan($floorplanId: String!, $userId: String!) {
  unshareFloorplan(floorplanId: $floorplanId, userId: $userId) {
    id
    sharedWith {
      id
      userName
      email
    }
  }
}
    `;
export type UnshareFloorplanMutationFn = Apollo.MutationFunction<UnshareFloorplanMutation, UnshareFloorplanMutationVariables>;

/**
 * __useUnshareFloorplanMutation__
 *
 * To run a mutation, you first call `useUnshareFloorplanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareFloorplanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareFloorplanMutation, { data, loading, error }] = useUnshareFloorplanMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnshareFloorplanMutation(baseOptions?: Apollo.MutationHookOptions<UnshareFloorplanMutation, UnshareFloorplanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnshareFloorplanMutation, UnshareFloorplanMutationVariables>(UnshareFloorplanDocument, options);
      }
export type UnshareFloorplanMutationHookResult = ReturnType<typeof useUnshareFloorplanMutation>;
export type UnshareFloorplanMutationResult = Apollo.MutationResult<UnshareFloorplanMutation>;
export type UnshareFloorplanMutationOptions = Apollo.BaseMutationOptions<UnshareFloorplanMutation, UnshareFloorplanMutationVariables>;
export const ClaimFloorplanEditorDocument = gql`
    mutation claimFloorplanEditor($floorplanId: String!, $force: Boolean) {
  claimFloorplanEditor(floorplanId: $floorplanId, force: $force) {
    isMine
    updatedAt
    editingExpiresAt
    editingBy {
      id
      userName
      email
    }
  }
}
    `;
export type ClaimFloorplanEditorMutationFn = Apollo.MutationFunction<ClaimFloorplanEditorMutation, ClaimFloorplanEditorMutationVariables>;

/**
 * __useClaimFloorplanEditorMutation__
 *
 * To run a mutation, you first call `useClaimFloorplanEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimFloorplanEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimFloorplanEditorMutation, { data, loading, error }] = useClaimFloorplanEditorMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useClaimFloorplanEditorMutation(baseOptions?: Apollo.MutationHookOptions<ClaimFloorplanEditorMutation, ClaimFloorplanEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimFloorplanEditorMutation, ClaimFloorplanEditorMutationVariables>(ClaimFloorplanEditorDocument, options);
      }
export type ClaimFloorplanEditorMutationHookResult = ReturnType<typeof useClaimFloorplanEditorMutation>;
export type ClaimFloorplanEditorMutationResult = Apollo.MutationResult<ClaimFloorplanEditorMutation>;
export type ClaimFloorplanEditorMutationOptions = Apollo.BaseMutationOptions<ClaimFloorplanEditorMutation, ClaimFloorplanEditorMutationVariables>;
export const ReleaseFloorplanEditorDocument = gql`
    mutation releaseFloorplanEditor($floorplanId: String!) {
  releaseFloorplanEditor(floorplanId: $floorplanId)
}
    `;
export type ReleaseFloorplanEditorMutationFn = Apollo.MutationFunction<ReleaseFloorplanEditorMutation, ReleaseFloorplanEditorMutationVariables>;

/**
 * __useReleaseFloorplanEditorMutation__
 *
 * To run a mutation, you first call `useReleaseFloorplanEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseFloorplanEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseFloorplanEditorMutation, { data, loading, error }] = useReleaseFloorplanEditorMutation({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *   },
 * });
 */
export function useReleaseFloorplanEditorMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseFloorplanEditorMutation, ReleaseFloorplanEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleaseFloorplanEditorMutation, ReleaseFloorplanEditorMutationVariables>(ReleaseFloorplanEditorDocument, options);
      }
export type ReleaseFloorplanEditorMutationHookResult = ReturnType<typeof useReleaseFloorplanEditorMutation>;
export type ReleaseFloorplanEditorMutationResult = Apollo.MutationResult<ReleaseFloorplanEditorMutation>;
export type ReleaseFloorplanEditorMutationOptions = Apollo.BaseMutationOptions<ReleaseFloorplanEditorMutation, ReleaseFloorplanEditorMutationVariables>;
export const FloorplanCollabChangedDocument = gql`
    subscription floorplanCollabChanged($floorplanId: String!) {
  floorplanCollabChanged(floorplanId: $floorplanId) {
    floorplanId
    updatedAt
    editingBy {
      id
      userName
      email
    }
  }
}
    `;

/**
 * __useFloorplanCollabChangedSubscription__
 *
 * To run a query within a React component, call `useFloorplanCollabChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFloorplanCollabChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplanCollabChangedSubscription({
 *   variables: {
 *      floorplanId: // value for 'floorplanId'
 *   },
 * });
 */
export function useFloorplanCollabChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<FloorplanCollabChangedSubscription, FloorplanCollabChangedSubscriptionVariables> & ({ variables: FloorplanCollabChangedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<FloorplanCollabChangedSubscription, FloorplanCollabChangedSubscriptionVariables>(FloorplanCollabChangedDocument, options);
      }
export type FloorplanCollabChangedSubscriptionHookResult = ReturnType<typeof useFloorplanCollabChangedSubscription>;
export type FloorplanCollabChangedSubscriptionResult = Apollo.SubscriptionResult<FloorplanCollabChangedSubscription>;
export const EditFloorplanWithVersionDocument = gql`
    mutation editFloorplanWithVersion($id: ID!, $name: String, $json: String, $image: Upload, $currency: String, $expectedUpdatedAt: DateTime) {
  editFloorplan(
    input: {id: $id, name: $name, json: $json, image: $image, currency: $currency, expectedUpdatedAt: $expectedUpdatedAt}
  ) {
    id
    name
    image
    thumbnail
    currency
    updatedAt
  }
}
    `;
export type EditFloorplanWithVersionMutationFn = Apollo.MutationFunction<EditFloorplanWithVersionMutation, EditFloorplanWithVersionMutationVariables>;

/**
 * __useEditFloorplanWithVersionMutation__
 *
 * To run a mutation, you first call `useEditFloorplanWithVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFloorplanWithVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFloorplanWithVersionMutation, { data, loading, error }] = useEditFloorplanWithVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      json: // value for 'json'
 *      image: // value for 'image'
 *      currency: // value for 'currency'
 *      expectedUpdatedAt: // value for 'expectedUpdatedAt'
 *   },
 * });
 */
export function useEditFloorplanWithVersionMutation(baseOptions?: Apollo.MutationHookOptions<EditFloorplanWithVersionMutation, EditFloorplanWithVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFloorplanWithVersionMutation, EditFloorplanWithVersionMutationVariables>(EditFloorplanWithVersionDocument, options);
      }
export type EditFloorplanWithVersionMutationHookResult = ReturnType<typeof useEditFloorplanWithVersionMutation>;
export type EditFloorplanWithVersionMutationResult = Apollo.MutationResult<EditFloorplanWithVersionMutation>;
export type EditFloorplanWithVersionMutationOptions = Apollo.BaseMutationOptions<EditFloorplanWithVersionMutation, EditFloorplanWithVersionMutationVariables>;
export const AddUserItemToNewMoodBoardDocument = gql`
    mutation AddUserItemToNewMoodBoard($documentId: ID!, $userItemId: ID!) {
  addUserItemToNewMoodBoard(documentId: $documentId, userItemId: $userItemId) {
    id
    name
    index
  }
}
    `;
export type AddUserItemToNewMoodBoardMutationFn = Apollo.MutationFunction<AddUserItemToNewMoodBoardMutation, AddUserItemToNewMoodBoardMutationVariables>;

/**
 * __useAddUserItemToNewMoodBoardMutation__
 *
 * To run a mutation, you first call `useAddUserItemToNewMoodBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserItemToNewMoodBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserItemToNewMoodBoardMutation, { data, loading, error }] = useAddUserItemToNewMoodBoardMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      userItemId: // value for 'userItemId'
 *   },
 * });
 */
export function useAddUserItemToNewMoodBoardMutation(baseOptions?: Apollo.MutationHookOptions<AddUserItemToNewMoodBoardMutation, AddUserItemToNewMoodBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserItemToNewMoodBoardMutation, AddUserItemToNewMoodBoardMutationVariables>(AddUserItemToNewMoodBoardDocument, options);
      }
export type AddUserItemToNewMoodBoardMutationHookResult = ReturnType<typeof useAddUserItemToNewMoodBoardMutation>;
export type AddUserItemToNewMoodBoardMutationResult = Apollo.MutationResult<AddUserItemToNewMoodBoardMutation>;
export type AddUserItemToNewMoodBoardMutationOptions = Apollo.BaseMutationOptions<AddUserItemToNewMoodBoardMutation, AddUserItemToNewMoodBoardMutationVariables>;
export const AddUserItemDocument = gql`
    mutation AddUserItem($image: Upload!, $removeBG: Boolean, $tags: [String!], $productIds: [ID!]) {
  addUserItem(
    image: $image
    removeBG: $removeBG
    tags: $tags
    productIds: $productIds
  ) {
    id
    images
    tags
    productIds
    sourceProductId1
    sourceProductId2
  }
}
    `;
export type AddUserItemMutationFn = Apollo.MutationFunction<AddUserItemMutation, AddUserItemMutationVariables>;

/**
 * __useAddUserItemMutation__
 *
 * To run a mutation, you first call `useAddUserItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserItemMutation, { data, loading, error }] = useAddUserItemMutation({
 *   variables: {
 *      image: // value for 'image'
 *      removeBG: // value for 'removeBG'
 *      tags: // value for 'tags'
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useAddUserItemMutation(baseOptions?: Apollo.MutationHookOptions<AddUserItemMutation, AddUserItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserItemMutation, AddUserItemMutationVariables>(AddUserItemDocument, options);
      }
export type AddUserItemMutationHookResult = ReturnType<typeof useAddUserItemMutation>;
export type AddUserItemMutationResult = Apollo.MutationResult<AddUserItemMutation>;
export type AddUserItemMutationOptions = Apollo.BaseMutationOptions<AddUserItemMutation, AddUserItemMutationVariables>;
export const UserModels3DDocument = gql`
    query UserModels3D {
  userModels3D {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;

/**
 * __useUserModels3DQuery__
 *
 * To run a query within a React component, call `useUserModels3DQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserModels3DQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserModels3DQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserModels3DQuery(baseOptions?: Apollo.QueryHookOptions<UserModels3DQuery, UserModels3DQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserModels3DQuery, UserModels3DQueryVariables>(UserModels3DDocument, options);
      }
export function useUserModels3DLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserModels3DQuery, UserModels3DQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserModels3DQuery, UserModels3DQueryVariables>(UserModels3DDocument, options);
        }
export function useUserModels3DSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserModels3DQuery, UserModels3DQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserModels3DQuery, UserModels3DQueryVariables>(UserModels3DDocument, options);
        }
export type UserModels3DQueryHookResult = ReturnType<typeof useUserModels3DQuery>;
export type UserModels3DLazyQueryHookResult = ReturnType<typeof useUserModels3DLazyQuery>;
export type UserModels3DSuspenseQueryHookResult = ReturnType<typeof useUserModels3DSuspenseQuery>;
export type UserModels3DQueryResult = Apollo.QueryResult<UserModels3DQuery, UserModels3DQueryVariables>;
export const UploadUserModel3DDocument = gql`
    mutation UploadUserModel3D($name: String, $model: Upload!, $shareWithCommunity: Boolean) {
  uploadUserModel3D(
    name: $name
    model: $model
    shareWithCommunity: $shareWithCommunity
  ) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type UploadUserModel3DMutationFn = Apollo.MutationFunction<UploadUserModel3DMutation, UploadUserModel3DMutationVariables>;

/**
 * __useUploadUserModel3DMutation__
 *
 * To run a mutation, you first call `useUploadUserModel3DMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUserModel3DMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUserModel3DMutation, { data, loading, error }] = useUploadUserModel3DMutation({
 *   variables: {
 *      name: // value for 'name'
 *      model: // value for 'model'
 *      shareWithCommunity: // value for 'shareWithCommunity'
 *   },
 * });
 */
export function useUploadUserModel3DMutation(baseOptions?: Apollo.MutationHookOptions<UploadUserModel3DMutation, UploadUserModel3DMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUserModel3DMutation, UploadUserModel3DMutationVariables>(UploadUserModel3DDocument, options);
      }
export type UploadUserModel3DMutationHookResult = ReturnType<typeof useUploadUserModel3DMutation>;
export type UploadUserModel3DMutationResult = Apollo.MutationResult<UploadUserModel3DMutation>;
export type UploadUserModel3DMutationOptions = Apollo.BaseMutationOptions<UploadUserModel3DMutation, UploadUserModel3DMutationVariables>;
export const GenerateUserModel3DFromImageDocument = gql`
    mutation GenerateUserModel3DFromImage($name: String!, $image: Upload!, $shareWithCommunity: Boolean) {
  generateUserModel3DFromImage(
    name: $name
    image: $image
    shareWithCommunity: $shareWithCommunity
  ) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type GenerateUserModel3DFromImageMutationFn = Apollo.MutationFunction<GenerateUserModel3DFromImageMutation, GenerateUserModel3DFromImageMutationVariables>;

/**
 * __useGenerateUserModel3DFromImageMutation__
 *
 * To run a mutation, you first call `useGenerateUserModel3DFromImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUserModel3DFromImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUserModel3DFromImageMutation, { data, loading, error }] = useGenerateUserModel3DFromImageMutation({
 *   variables: {
 *      name: // value for 'name'
 *      image: // value for 'image'
 *      shareWithCommunity: // value for 'shareWithCommunity'
 *   },
 * });
 */
export function useGenerateUserModel3DFromImageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUserModel3DFromImageMutation, GenerateUserModel3DFromImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUserModel3DFromImageMutation, GenerateUserModel3DFromImageMutationVariables>(GenerateUserModel3DFromImageDocument, options);
      }
export type GenerateUserModel3DFromImageMutationHookResult = ReturnType<typeof useGenerateUserModel3DFromImageMutation>;
export type GenerateUserModel3DFromImageMutationResult = Apollo.MutationResult<GenerateUserModel3DFromImageMutation>;
export type GenerateUserModel3DFromImageMutationOptions = Apollo.BaseMutationOptions<GenerateUserModel3DFromImageMutation, GenerateUserModel3DFromImageMutationVariables>;
export const RetryUserModel3DGenerationDocument = gql`
    mutation RetryUserModel3DGeneration($id: ID!) {
  retryUserModel3DGeneration(id: $id) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type RetryUserModel3DGenerationMutationFn = Apollo.MutationFunction<RetryUserModel3DGenerationMutation, RetryUserModel3DGenerationMutationVariables>;

/**
 * __useRetryUserModel3DGenerationMutation__
 *
 * To run a mutation, you first call `useRetryUserModel3DGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryUserModel3DGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryUserModel3DGenerationMutation, { data, loading, error }] = useRetryUserModel3DGenerationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryUserModel3DGenerationMutation(baseOptions?: Apollo.MutationHookOptions<RetryUserModel3DGenerationMutation, RetryUserModel3DGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryUserModel3DGenerationMutation, RetryUserModel3DGenerationMutationVariables>(RetryUserModel3DGenerationDocument, options);
      }
export type RetryUserModel3DGenerationMutationHookResult = ReturnType<typeof useRetryUserModel3DGenerationMutation>;
export type RetryUserModel3DGenerationMutationResult = Apollo.MutationResult<RetryUserModel3DGenerationMutation>;
export type RetryUserModel3DGenerationMutationOptions = Apollo.BaseMutationOptions<RetryUserModel3DGenerationMutation, RetryUserModel3DGenerationMutationVariables>;
export const CommunityUserModels3DDocument = gql`
    query CommunityUserModels3D($input: CommunityUserModels3DInput) {
  communityUserModels3D(input: $input) {
    data {
      ...UserModel3DFields
    }
    total
  }
}
    ${UserModel3DFieldsFragmentDoc}`;

/**
 * __useCommunityUserModels3DQuery__
 *
 * To run a query within a React component, call `useCommunityUserModels3DQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUserModels3DQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUserModels3DQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommunityUserModels3DQuery(baseOptions?: Apollo.QueryHookOptions<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>(CommunityUserModels3DDocument, options);
      }
export function useCommunityUserModels3DLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>(CommunityUserModels3DDocument, options);
        }
export function useCommunityUserModels3DSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>(CommunityUserModels3DDocument, options);
        }
export type CommunityUserModels3DQueryHookResult = ReturnType<typeof useCommunityUserModels3DQuery>;
export type CommunityUserModels3DLazyQueryHookResult = ReturnType<typeof useCommunityUserModels3DLazyQuery>;
export type CommunityUserModels3DSuspenseQueryHookResult = ReturnType<typeof useCommunityUserModels3DSuspenseQuery>;
export type CommunityUserModels3DQueryResult = Apollo.QueryResult<CommunityUserModels3DQuery, CommunityUserModels3DQueryVariables>;
export const UploadUserModel3DThumbnailDocument = gql`
    mutation UploadUserModel3DThumbnail($modelId: ID!, $image: Upload!) {
  uploadUserModel3DThumbnail(modelId: $modelId, image: $image) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type UploadUserModel3DThumbnailMutationFn = Apollo.MutationFunction<UploadUserModel3DThumbnailMutation, UploadUserModel3DThumbnailMutationVariables>;

/**
 * __useUploadUserModel3DThumbnailMutation__
 *
 * To run a mutation, you first call `useUploadUserModel3DThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUserModel3DThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUserModel3DThumbnailMutation, { data, loading, error }] = useUploadUserModel3DThumbnailMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUploadUserModel3DThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<UploadUserModel3DThumbnailMutation, UploadUserModel3DThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUserModel3DThumbnailMutation, UploadUserModel3DThumbnailMutationVariables>(UploadUserModel3DThumbnailDocument, options);
      }
export type UploadUserModel3DThumbnailMutationHookResult = ReturnType<typeof useUploadUserModel3DThumbnailMutation>;
export type UploadUserModel3DThumbnailMutationResult = Apollo.MutationResult<UploadUserModel3DThumbnailMutation>;
export type UploadUserModel3DThumbnailMutationOptions = Apollo.BaseMutationOptions<UploadUserModel3DThumbnailMutation, UploadUserModel3DThumbnailMutationVariables>;
export const DeleteUserModel3DDocument = gql`
    mutation DeleteUserModel3D($id: ID!) {
  deleteUserModel3D(id: $id)
}
    `;
export type DeleteUserModel3DMutationFn = Apollo.MutationFunction<DeleteUserModel3DMutation, DeleteUserModel3DMutationVariables>;

/**
 * __useDeleteUserModel3DMutation__
 *
 * To run a mutation, you first call `useDeleteUserModel3DMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserModel3DMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserModel3DMutation, { data, loading, error }] = useDeleteUserModel3DMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserModel3DMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserModel3DMutation, DeleteUserModel3DMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserModel3DMutation, DeleteUserModel3DMutationVariables>(DeleteUserModel3DDocument, options);
      }
export type DeleteUserModel3DMutationHookResult = ReturnType<typeof useDeleteUserModel3DMutation>;
export type DeleteUserModel3DMutationResult = Apollo.MutationResult<DeleteUserModel3DMutation>;
export type DeleteUserModel3DMutationOptions = Apollo.BaseMutationOptions<DeleteUserModel3DMutation, DeleteUserModel3DMutationVariables>;
export const RenameUserModel3DDocument = gql`
    mutation RenameUserModel3D($id: ID!, $name: String!) {
  renameUserModel3D(id: $id, name: $name) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type RenameUserModel3DMutationFn = Apollo.MutationFunction<RenameUserModel3DMutation, RenameUserModel3DMutationVariables>;

/**
 * __useRenameUserModel3DMutation__
 *
 * To run a mutation, you first call `useRenameUserModel3DMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameUserModel3DMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameUserModel3DMutation, { data, loading, error }] = useRenameUserModel3DMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameUserModel3DMutation(baseOptions?: Apollo.MutationHookOptions<RenameUserModel3DMutation, RenameUserModel3DMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameUserModel3DMutation, RenameUserModel3DMutationVariables>(RenameUserModel3DDocument, options);
      }
export type RenameUserModel3DMutationHookResult = ReturnType<typeof useRenameUserModel3DMutation>;
export type RenameUserModel3DMutationResult = Apollo.MutationResult<RenameUserModel3DMutation>;
export type RenameUserModel3DMutationOptions = Apollo.BaseMutationOptions<RenameUserModel3DMutation, RenameUserModel3DMutationVariables>;
export const UpdateUserModel3DDocument = gql`
    mutation UpdateUserModel3D($id: ID!, $name: String!, $width: Float, $depth: Float, $height: Float, $architectureSymbolKey: String) {
  updateUserModel3D(
    id: $id
    name: $name
    width: $width
    depth: $depth
    height: $height
    architectureSymbolKey: $architectureSymbolKey
  ) {
    ...UserModel3DFields
  }
}
    ${UserModel3DFieldsFragmentDoc}`;
export type UpdateUserModel3DMutationFn = Apollo.MutationFunction<UpdateUserModel3DMutation, UpdateUserModel3DMutationVariables>;

/**
 * __useUpdateUserModel3DMutation__
 *
 * To run a mutation, you first call `useUpdateUserModel3DMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserModel3DMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserModel3DMutation, { data, loading, error }] = useUpdateUserModel3DMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      width: // value for 'width'
 *      depth: // value for 'depth'
 *      height: // value for 'height'
 *      architectureSymbolKey: // value for 'architectureSymbolKey'
 *   },
 * });
 */
export function useUpdateUserModel3DMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserModel3DMutation, UpdateUserModel3DMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserModel3DMutation, UpdateUserModel3DMutationVariables>(UpdateUserModel3DDocument, options);
      }
export type UpdateUserModel3DMutationHookResult = ReturnType<typeof useUpdateUserModel3DMutation>;
export type UpdateUserModel3DMutationResult = Apollo.MutationResult<UpdateUserModel3DMutation>;
export type UpdateUserModel3DMutationOptions = Apollo.BaseMutationOptions<UpdateUserModel3DMutation, UpdateUserModel3DMutationVariables>;
export const FloorplanDocument = gql`
    query floorplan($id: String!) {
  floorplan(id: $id) {
    id
    name
    json
    backdropImage
    backdropRatio
    backdropSize
    currency
    updatedAt
    isOwner
    user {
      id
      userName
      email
    }
    sharedWith {
      id
      userName
      email
    }
  }
}
    `;

/**
 * __useFloorplanQuery__
 *
 * To run a query within a React component, call `useFloorplanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorplanQuery(baseOptions: Apollo.QueryHookOptions<FloorplanQuery, FloorplanQueryVariables> & ({ variables: FloorplanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplanQuery, FloorplanQueryVariables>(FloorplanDocument, options);
      }
export function useFloorplanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplanQuery, FloorplanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplanQuery, FloorplanQueryVariables>(FloorplanDocument, options);
        }
export function useFloorplanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplanQuery, FloorplanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplanQuery, FloorplanQueryVariables>(FloorplanDocument, options);
        }
export type FloorplanQueryHookResult = ReturnType<typeof useFloorplanQuery>;
export type FloorplanLazyQueryHookResult = ReturnType<typeof useFloorplanLazyQuery>;
export type FloorplanSuspenseQueryHookResult = ReturnType<typeof useFloorplanSuspenseQuery>;
export type FloorplanQueryResult = Apollo.QueryResult<FloorplanQuery, FloorplanQueryVariables>;
export const FloorplansDocument = gql`
    query floorplans {
  floorplans {
    id
    name
    json
    backdropImage
    backdropRatio
    backdropSize
    isOwner
    user {
      id
      userName
      email
    }
  }
}
    `;

/**
 * __useFloorplansQuery__
 *
 * To run a query within a React component, call `useFloorplansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorplansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorplansQuery({
 *   variables: {
 *   },
 * });
 */
export function useFloorplansQuery(baseOptions?: Apollo.QueryHookOptions<FloorplansQuery, FloorplansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FloorplansQuery, FloorplansQueryVariables>(FloorplansDocument, options);
      }
export function useFloorplansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FloorplansQuery, FloorplansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FloorplansQuery, FloorplansQueryVariables>(FloorplansDocument, options);
        }
export function useFloorplansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FloorplansQuery, FloorplansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FloorplansQuery, FloorplansQueryVariables>(FloorplansDocument, options);
        }
export type FloorplansQueryHookResult = ReturnType<typeof useFloorplansQuery>;
export type FloorplansLazyQueryHookResult = ReturnType<typeof useFloorplansLazyQuery>;
export type FloorplansSuspenseQueryHookResult = ReturnType<typeof useFloorplansSuspenseQuery>;
export type FloorplansQueryResult = Apollo.QueryResult<FloorplansQuery, FloorplansQueryVariables>;
export const EditFloorplanDocument = gql`
    mutation editFloorplan($id: ID!, $name: String, $json: String, $image: Upload, $currency: String, $expectedUpdatedAt: DateTime) {
  editFloorplan(
    input: {id: $id, name: $name, json: $json, image: $image, currency: $currency, expectedUpdatedAt: $expectedUpdatedAt}
  ) {
    id
    name
    image
    thumbnail
    currency
    updatedAt
  }
}
    `;
export type EditFloorplanMutationFn = Apollo.MutationFunction<EditFloorplanMutation, EditFloorplanMutationVariables>;

/**
 * __useEditFloorplanMutation__
 *
 * To run a mutation, you first call `useEditFloorplanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFloorplanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFloorplanMutation, { data, loading, error }] = useEditFloorplanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      json: // value for 'json'
 *      image: // value for 'image'
 *      currency: // value for 'currency'
 *      expectedUpdatedAt: // value for 'expectedUpdatedAt'
 *   },
 * });
 */
export function useEditFloorplanMutation(baseOptions?: Apollo.MutationHookOptions<EditFloorplanMutation, EditFloorplanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFloorplanMutation, EditFloorplanMutationVariables>(EditFloorplanDocument, options);
      }
export type EditFloorplanMutationHookResult = ReturnType<typeof useEditFloorplanMutation>;
export type EditFloorplanMutationResult = Apollo.MutationResult<EditFloorplanMutation>;
export type EditFloorplanMutationOptions = Apollo.BaseMutationOptions<EditFloorplanMutation, EditFloorplanMutationVariables>;
export const DeleteFloorplanDocument = gql`
    mutation deleteFloorplan($id: String!) {
  deleteFloorplan(id: $id) {
    id
  }
}
    `;
export type DeleteFloorplanMutationFn = Apollo.MutationFunction<DeleteFloorplanMutation, DeleteFloorplanMutationVariables>;

/**
 * __useDeleteFloorplanMutation__
 *
 * To run a mutation, you first call `useDeleteFloorplanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFloorplanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFloorplanMutation, { data, loading, error }] = useDeleteFloorplanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFloorplanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFloorplanMutation, DeleteFloorplanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFloorplanMutation, DeleteFloorplanMutationVariables>(DeleteFloorplanDocument, options);
      }
export type DeleteFloorplanMutationHookResult = ReturnType<typeof useDeleteFloorplanMutation>;
export type DeleteFloorplanMutationResult = Apollo.MutationResult<DeleteFloorplanMutation>;
export type DeleteFloorplanMutationOptions = Apollo.BaseMutationOptions<DeleteFloorplanMutation, DeleteFloorplanMutationVariables>;
export const CurrentUserWithFeatureFlagsDocument = gql`
    query currentUserWithFeatureFlags {
  currentUser {
    id
    email
    role
    entitlements {
      plan
      isActive
      limits {
        maxFloorplans
        maxFloorplanShapes
      }
      aiCredits {
        monthlyLimit
        used
        remaining
        resetAt
        unlimited
        topupCredits
      }
      featureFlags {
        floorplannerCatalogMaterials
        floorplannerProduct3DAssets
        shareDocuments
      }
    }
  }
}
    `;

/**
 * __useCurrentUserWithFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useCurrentUserWithFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWithFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWithFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWithFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>(CurrentUserWithFeatureFlagsDocument, options);
      }
export function useCurrentUserWithFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>(CurrentUserWithFeatureFlagsDocument, options);
        }
export function useCurrentUserWithFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>(CurrentUserWithFeatureFlagsDocument, options);
        }
export type CurrentUserWithFeatureFlagsQueryHookResult = ReturnType<typeof useCurrentUserWithFeatureFlagsQuery>;
export type CurrentUserWithFeatureFlagsLazyQueryHookResult = ReturnType<typeof useCurrentUserWithFeatureFlagsLazyQuery>;
export type CurrentUserWithFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWithFeatureFlagsSuspenseQuery>;
export type CurrentUserWithFeatureFlagsQueryResult = Apollo.QueryResult<CurrentUserWithFeatureFlagsQuery, CurrentUserWithFeatureFlagsQueryVariables>;
export const ValidateSessionWithFeatureFlagsDocument = gql`
    mutation validateSessionWithFeatureFlags {
  validateSession {
    id
    role
    entitlements {
      plan
      isActive
      limits {
        maxFloorplans
        maxFloorplanShapes
      }
      aiCredits {
        monthlyLimit
        used
        remaining
        resetAt
        unlimited
        topupCredits
      }
      featureFlags {
        floorplannerCatalogMaterials
        floorplannerProduct3DAssets
        shareDocuments
      }
    }
  }
}
    `;
export type ValidateSessionWithFeatureFlagsMutationFn = Apollo.MutationFunction<ValidateSessionWithFeatureFlagsMutation, ValidateSessionWithFeatureFlagsMutationVariables>;

/**
 * __useValidateSessionWithFeatureFlagsMutation__
 *
 * To run a mutation, you first call `useValidateSessionWithFeatureFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionWithFeatureFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSessionWithFeatureFlagsMutation, { data, loading, error }] = useValidateSessionWithFeatureFlagsMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateSessionWithFeatureFlagsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSessionWithFeatureFlagsMutation, ValidateSessionWithFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSessionWithFeatureFlagsMutation, ValidateSessionWithFeatureFlagsMutationVariables>(ValidateSessionWithFeatureFlagsDocument, options);
      }
export type ValidateSessionWithFeatureFlagsMutationHookResult = ReturnType<typeof useValidateSessionWithFeatureFlagsMutation>;
export type ValidateSessionWithFeatureFlagsMutationResult = Apollo.MutationResult<ValidateSessionWithFeatureFlagsMutation>;
export type ValidateSessionWithFeatureFlagsMutationOptions = Apollo.BaseMutationOptions<ValidateSessionWithFeatureFlagsMutation, ValidateSessionWithFeatureFlagsMutationVariables>;
export const ValidateSessionDocument = gql`
    mutation validateSession {
  validateSession {
    id
    role
    entitlements {
      plan
      isActive
      limits {
        maxFloorplans
        maxFloorplanShapes
      }
      aiCredits {
        monthlyLimit
        used
        remaining
        resetAt
        unlimited
        topupCredits
      }
      featureFlags {
        floorplannerCatalogMaterials
        floorplannerProduct3DAssets
        shareDocuments
      }
    }
  }
}
    `;
export type ValidateSessionMutationFn = Apollo.MutationFunction<ValidateSessionMutation, ValidateSessionMutationVariables>;

/**
 * __useValidateSessionMutation__
 *
 * To run a mutation, you first call `useValidateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSessionMutation, { data, loading, error }] = useValidateSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useValidateSessionMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSessionMutation, ValidateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSessionMutation, ValidateSessionMutationVariables>(ValidateSessionDocument, options);
      }
export type ValidateSessionMutationHookResult = ReturnType<typeof useValidateSessionMutation>;
export type ValidateSessionMutationResult = Apollo.MutationResult<ValidateSessionMutation>;
export type ValidateSessionMutationOptions = Apollo.BaseMutationOptions<ValidateSessionMutation, ValidateSessionMutationVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    id
    email
    role
    entitlements {
      plan
      isActive
      limits {
        maxFloorplans
        maxFloorplanShapes
      }
      aiCredits {
        monthlyLimit
        used
        remaining
        resetAt
        unlimited
        topupCredits
      }
      featureFlags {
        floorplannerCatalogMaterials
        floorplannerProduct3DAssets
        shareDocuments
      }
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokensDocument = gql`
    mutation RefreshTokens {
  refreshTokens {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokensMutationFn = Apollo.MutationFunction<RefreshTokensMutation, RefreshTokensMutationVariables>;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokensMutation, { data, loading, error }] = useRefreshTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokensMutation, RefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(RefreshTokensDocument, options);
      }
export type RefreshTokensMutationHookResult = ReturnType<typeof useRefreshTokensMutation>;
export type RefreshTokensMutationResult = Apollo.MutationResult<RefreshTokensMutation>;
export type RefreshTokensMutationOptions = Apollo.BaseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables>;